import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AccessControlCreateDto = {
  active: Scalars['Boolean']['input'];
  modules: Array<ModuleInput>;
  name: Scalars['String']['input'];
};

export type AccessControlDeleteDto = {
  _id: Scalars['String']['input'];
};

export type AccessControlListDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AccessControlListSort>;
};

export type AccessControlListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type AccessControlModel = {
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  modules: Array<Module>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AccessControlUpdateDto = {
  _id: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  modules?: InputMaybe<Array<ModuleInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AccountWalletBalanceModel = {
  balanceCents: Scalars['Float']['output'];
  balanceWithPendingsCents: Scalars['Float']['output'];
  creditValueCentsToday: Scalars['Float']['output'];
  currentDate: Scalars['String']['output'];
  debitValueCentsToday: Scalars['Float']['output'];
};

export type ActionDto = {
  internalName: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
};

export type AddNoteGraphqlDto = {
  fileKey?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AddressDto = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  neighborhood: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type AddressGraphqlDto = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  neighborhood: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type AddressGraphqlModel = {
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  neighborhood: Scalars['String']['output'];
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type AffiliatePartnerDeleteUserModel = {
  success: Scalars['Boolean']['output'];
};

export type AffiliatePartnerUserAccessControl = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AffiliatePartnerUserApprovedUpdateInput = {
  accessStatus?: InputMaybe<EAffiliatePartnerUserAccessStatus>;
  /** e-mail do preposto */
  email?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliatePartnerUserCreateInput = {
  address: AddressGraphqlDto;
  captureSource: Scalars['String']['input'];
  cpf: Scalars['String']['input'];
  /** e-mail do preposto */
  email: Scalars['String']['input'];
  facebook?: InputMaybe<Scalars['String']['input']>;
  files: Array<AffiliatePartnerUserFileInput>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** nome do preposto */
  name: Scalars['String']['input'];
  /** telefone do preposto */
  phone: Scalars['String']['input'];
  professionalHistory?: InputMaybe<Array<AffiliatePartnerUserProfessionalReferenceInput>>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliatePartnerUserFileInput = {
  fileKey: Scalars['String']['input'];
  type: EAffiliatePartnerUserFileType;
};

export type AffiliatePartnerUserFileModel = {
  file: FileUploadModel;
  type: EAffiliatePartnerUserFileType;
};

export type AffiliatePartnerUserFilterArgs = {
  inAccessStatus?: InputMaybe<Array<EAffiliatePartnerUserAccessStatus>>;
  inStatus?: InputMaybe<Array<EAffiliatePartnerUserStatus>>;
  nameOrUsernameOrEmail?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliatePartnerUserHistoryModel = {
  author: EAffiliatePartnerUserHistoryAuthor;
  date: Scalars['DateTime']['output'];
  event: EAffiliatePartnerUserHistoryEvent;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type AffiliatePartnerUserListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type AffiliatePartnerUserLoggedUserOutput = {
  /** Generated accessToken of the user */
  accessToken: Scalars['String']['output'];
};

/** metadados de paginação */
export type AffiliatePartnerUserMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** preposto do parceiro */
export type AffiliatePartnerUserModel = {
  _id: Scalars['ID']['output'];
  accessControlRef: AffiliatePartnerUserAccessControl;
  accessStatus: EAffiliatePartnerUserAccessStatus;
  address?: Maybe<AddressGraphqlModel>;
  captureSource?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  facebook?: Maybe<Scalars['String']['output']>;
  files: Array<AffiliatePartnerUserFileModel>;
  history: Array<AffiliatePartnerUserHistoryModel>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner: Scalars['Boolean']['output'];
  partnerRef?: Maybe<AffiliatePartnerUserPartnerRef>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  professionalHistory: Array<AffiliatePartnerUserProfessionalReferenceModel>;
  site?: Maybe<Scalars['String']['output']>;
  status: EAffiliatePartnerUserStatus;
  type?: Maybe<EUserType>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type AffiliatePartnerUserPaginateArgs = {
  filter?: InputMaybe<AffiliatePartnerUserFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AffiliatePartnerUserListSort>;
};

export type AffiliatePartnerUserPartnerRef = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type AffiliatePartnerUserProfessionalReferenceInput = {
  companyName: Scalars['String']['input'];
  observation: Scalars['String']['input'];
  role: Scalars['String']['input'];
  segment: Scalars['String']['input'];
};

export type AffiliatePartnerUserProfessionalReferenceModel = {
  companyName?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
};

export type AffiliatePartnerUserRecoverPasswordChangeInput = {
  newPassword: Scalars['String']['input'];
  retypeNewPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AffiliatePartnerUserRecoverPasswordInput = {
  email: Scalars['String']['input'];
};

/** AffiliatePartnerUserRecoverPassword */
export type AffiliatePartnerUserRecoverPasswordModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  partnerUserRef: AffiliatePartnerUserRefModel;
  status: EAffiliatePartnerUserPasswordRecoverStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AffiliatePartnerUserRefModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type AffiliatePartnerUserUpdateInput = {
  address?: InputMaybe<AddressGraphqlDto>;
  captureSource?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  /** e-mail do preposto */
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<AffiliatePartnerUserFileInput>>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** nome do preposto */
  name?: InputMaybe<Scalars['String']['input']>;
  /** telefone do preposto */
  phone?: InputMaybe<Scalars['String']['input']>;
  professionalHistory?: InputMaybe<Array<AffiliatePartnerUserProfessionalReferenceInput>>;
  site?: InputMaybe<Scalars['String']['input']>;
};

/** paginação de prepostos */
export type AffiliatePartnerUsersPaginateModel = {
  data: Array<AffiliatePartnerUserModel>;
  meta: AffiliatePartnerUserMetaModel;
};

export type AnalyseLegalRepresentativeDataDto = {
  document: Scalars['String']['input'];
  pendencies: ProposalLegalRepresentativesPendencies;
  proposalId: Scalars['String']['input'];
};

export type AnalyseRegistrationDataDto = {
  pendencies: ProposalCustomerPendencies;
  proposalId: Scalars['String']['input'];
};

export type AnticipatedCommissionResponseDto = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
};

export type AnticipatedCommissioningParamsDto = {
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionExceptionGroups: Array<CommissionExceptionGroupCreateDto>;
  commissionedInvoices: Scalars['Float']['input'];
};

export type AnticipatedCommissioningUpdateParamsDto = {
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionExceptionGroups: Array<CommissionExceptionGroupUpdateDto>;
  commissionedInvoices: Scalars['Float']['input'];
};

export type AuthAffiliatePartnerUserArgs = {
  /** password of the user */
  password: Scalars['String']['input'];
  /** username of the user */
  username: Scalars['String']['input'];
};

export type AuthCustomerUserArgs = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** expo push token */
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  isPushNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** operating system */
  os?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  /** password */
  password: Scalars['String']['input'];
  /** username */
  username: Scalars['String']['input'];
};

export type AuthUserArgs = {
  /** password of the user */
  password: Scalars['String']['input'];
  /** username of the user */
  username: Scalars['String']['input'];
};

export type BankGraphqlDto = {
  account: Scalars['String']['input'];
  agency: Scalars['String']['input'];
  code: Scalars['String']['input'];
  type: EBankAccountType;
};

export type BankGraphqlModel = {
  account: Scalars['String']['output'];
  agency: Scalars['String']['output'];
  code: Scalars['String']['output'];
  type: EBankAccountType;
};

export type BankOperationResModel = {
  document: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pix?: Maybe<DigitalAccountPixResModel>;
  type: Scalars['String']['output'];
};

export type BusinessProposalFileModel = {
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  storageService?: Maybe<EStorageService>;
};

export type BusinessProposalModel = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  businessProposalDespertaNumber?: Maybe<Scalars['Float']['output']>;
  businessProposalPartnerNumber?: Maybe<Scalars['Float']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  contractOfAdhesion?: Maybe<BusinessProposalFileModel>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<BusinessProposalFileModel>;
  invoiceValueWithPartner?: Maybe<Scalars['Float']['output']>;
  linkFileToSign: Scalars['String']['output'];
  monthlyEconomyPercent: Scalars['Float']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  powerGeneratorId: Scalars['String']['output'];
  powerPlantId?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  status: EBusinessProposalStatus;
  tariffGreenFlag: Scalars['Float']['output'];
  tariffPurpleFlag: Scalars['Float']['output'];
  tariffRedFlagP1: Scalars['Float']['output'];
  tariffRedFlagP2: Scalars['Float']['output'];
  tariffYellowFlag: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CalculateCommissionParamsDto = {
  customerDiscountOffered: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
  personType: EPersonType;
};

export type CalculateCommissionResponseDto = {
  anticipated?: Maybe<AnticipatedCommissionResponseDto>;
  customerDiscountOffered: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  personType: EPersonType;
  recurring?: Maybe<RecurringCommissionResponseDto>;
};

export type CancelContractDtoGraphql = {
  contractId: Scalars['String']['input'];
  lossReason: EContractLossReason;
  reason: Scalars['String']['input'];
};

export type CancelProposalGraphqlDto = {
  lossReason: ELossReason;
  proposalId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionAnticipatedConditionModel = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
  commissionExceptionGroupId: Scalars['String']['output'];
  commissionedInvoices: Scalars['Float']['output'];
};

export type CommissionCalculationBaseModel = {
  /** Taxa de disponibilidade aplicada em kWh */
  availabilityFeeKwh: Scalars['Float']['output'];
  /** Consumo médio do contrato em kWh */
  averageConsumptionKwh: Scalars['Float']['output'];
  /** kWh faturáveis (consumo - taxa de disponibilidade) */
  billableKwh: Scalars['Float']['output'];
  /** Base de cálculo da comissão em centavos */
  calculationBaseValueCents: Scalars['Float']['output'];
  /** Motivo da escolha do consumo usado no cálculo */
  consumptionChoiceReason: Scalars['String']['output'];
  /** Consumo utilizado no cálculo (médio ou total) em kWh */
  consumptionUsedKwh: Scalars['Float']['output'];
  /** Percentual de desvio entre consumo médio e total */
  deviationPercentage: Scalars['Float']['output'];
  /** Tarifa TE + TUSD Desperta em R$/kWh */
  teAndTusdDespertaPerKwh: Scalars['Float']['output'];
  /** Tensão do contrato (monofasico, bifasico, trifasico) */
  tension: EConsumerUnitTension;
  /** Consumo total da fatura em kWh */
  totalConsumptionKwh: Scalars['Float']['output'];
  /** Se foi usado consumo total (true) ou médio (false) */
  usedTotalConsumption: Scalars['Boolean']['output'];
};

export type CommissionCondition = CommissionAnticipatedConditionModel | CommissionRecurringConditionModel;

export type CommissionExceptionGroupCreateDto = {
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionedInvoices: Scalars['Float']['input'];
  dealerships: Array<Scalars['String']['input']>;
};

export type CommissionExceptionGroupSchema = {
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionedInvoices: Scalars['Float']['output'];
  dealerships: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type CommissionExceptionGroupUpdateDto = {
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionedInvoices: Scalars['Float']['input'];
  dealerships: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionFilterArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  nameCustomerOrSalesman?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  salesmanId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ECommissionStatusFilter>>;
};

export type CommissionFilterMetricsArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  nameCustomerOrSalesman?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  salesmanId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ECommissionStatus>>;
};

export type CommissionListMetricsSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CommissionListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type CommissionMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type CommissionMetadataModel = {
  /** Detalhes do cálculo da base de comissão */
  calculationBase?: Maybe<CommissionCalculationBaseModel>;
  contractId: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceValueCents: Scalars['Float']['output'];
  proposalId: Scalars['String']['output'];
};

export type CommissionMetricsArgs = {
  filter?: InputMaybe<CommissionFilterMetricsArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CommissionListMetricsSort>;
};

export type CommissionMetricsDto = {
  expectedRevenueCents: Scalars['Float']['output'];
  receivableRevenueCents: Scalars['Float']['output'];
};

export type CommissionModel = {
  _id: Scalars['ID']['output'];
  commissioningType: ECommissioningType;
  condition?: Maybe<CommissionCondition>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate: Scalars['DateTime']['output'];
  indicationRef: IndicationRefModel;
  metadata: CommissionMetadataModel;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: ECommissionStatus;
  updatedAt: Scalars['DateTime']['output'];
  valueCents: Scalars['Float']['output'];
};

export type CommissionPaginateArgs = {
  filter?: InputMaybe<CommissionFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CommissionListSort>;
};

/** Commissions pagination */
export type CommissionPaginateModel = {
  data: Array<CommissionModel>;
  meta: CommissionMetaModel;
};

export type CommissionRecurringConditionModel = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  alwaysCommissionedInvoices: Scalars['Boolean']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
  commissionedInvoices?: Maybe<Scalars['Float']['output']>;
};

export type ConsortiumCreateDtoGraphql = {
  address: AddressGraphqlDto;
  bank?: InputMaybe<BankGraphqlDto>;
  cnpj: Scalars['String']['input'];
  documents?: InputMaybe<Array<ConsortiumDigitalAccountDocumentCreateDto>>;
  email: Scalars['String']['input'];
  fantasyName: Scalars['String']['input'];
  leaderEmail: Scalars['String']['input'];
  leaderName: Scalars['String']['input'];
  legalRepresentative?: InputMaybe<ConsortiumLegalRepresentativeDtoGraphql>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  status: EConsortiumStatus;
};

export type ConsortiumDigitalAccountDocumentCreateDto = {
  file: ConsortiumDigitalAccountDocumentFileCreateDto;
  type: EDigitalAccountDocumentType;
};

export type ConsortiumDigitalAccountDocumentFileCreateDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  storageService: EStorageService;
};

/** Digital Account Document File */
export type ConsortiumDigitalAccountDocumentFileModel = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  storageService: EStorageService;
};

/** Digital account document */
export type ConsortiumDigitalAccountDocumentModel = {
  file: ConsortiumDigitalAccountDocumentFileModel;
  type: EDigitalAccountDocumentType;
};

export type ConsortiumDigitalAccountLegalRepresentativeModel = {
  document?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** paginate metadata */
export type ConsortiumDigitalAccountModel = {
  accountOwner?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  documents: Array<ConsortiumDigitalAccountDocumentModel>;
  email?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalRepresentative?: Maybe<ConsortiumDigitalAccountLegalRepresentativeModel>;
  name: Scalars['String']['output'];
  pendencies: ConsortiumDigitalAccountPendenciesModel;
  phone?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Digital account pendencies */
export type ConsortiumDigitalAccountPendenciesModel = {
  account: ConsortiumDigitalAccountPendencyModel;
  address: ConsortiumDigitalAccountPendencyModel;
  addressProof: ConsortiumDigitalAccountPendencyModel;
  agency: ConsortiumDigitalAccountPendencyModel;
  balance_sheet: ConsortiumDigitalAccountPendencyModel;
  identificationBack: ConsortiumDigitalAccountPendencyModel;
  identificationFront: ConsortiumDigitalAccountPendencyModel;
  selfie: ConsortiumDigitalAccountPendencyModel;
  social_contract: ConsortiumDigitalAccountPendencyModel;
};

/** Digital account pendency */
export type ConsortiumDigitalAccountPendencyModel = {
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  inAnalysisAt?: Maybe<Scalars['DateTime']['output']>;
  pendenciedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConsortiumLegalRepresentativeDtoGraphql = {
  document: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** paginate metadata */
export type ConsortiumLegalRepresentativeModel = {
  document: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ConsortiumListDtoGraphql = {
  nameOrFantasyNameOrDocument?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ConsortiumListSort>;
};

export type ConsortiumListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type ConsortiumMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** consortiums */
export type ConsortiumModel = {
  _id: Scalars['ID']['output'];
  address: AddressGraphqlModel;
  bank?: Maybe<BankGraphqlModel>;
  cnpj: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digitalAccount?: Maybe<ConsortiumDigitalAccountModel>;
  email: Scalars['String']['output'];
  fantasyName: Scalars['String']['output'];
  leaderEmail: Scalars['String']['output'];
  leaderName: Scalars['String']['output'];
  legalRepresentative?: Maybe<ConsortiumLegalRepresentativeModel>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EConsortiumStatus>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Consortiums pagination */
export type ConsortiumPaginateModel = {
  data: Array<ConsortiumModel>;
  meta: ConsortiumMetaModel;
};

export type ConsortiumUpdateDtoGraphql = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<ConsortiumDigitalAccountDocumentCreateDto>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fantasyName?: InputMaybe<Scalars['String']['input']>;
  leaderEmail?: InputMaybe<Scalars['String']['input']>;
  leaderName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentative?: InputMaybe<ConsortiumLegalRepresentativeDtoGraphql>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EConsortiumStatus>;
};

export type ContactPersonCreateDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ContactPersonSchema = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type ContactPersonUpdateDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Erro de ativação contrato e massa */
export type ContractActivateBulkErrorModel = {
  error: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Ativação de contratos em massa */
export type ContractActivateBulkModel = {
  activated: Array<Scalars['String']['output']>;
  notActivated: Array<ContractActivateBulkErrorModel>;
};

export type ContractAddEnergyBillInfoGraphqlDto = {
  AmountCents?: InputMaybe<Scalars['Float']['input']>;
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  avarageBillAmountCents?: InputMaybe<Scalars['Float']['input']>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<ContractFileCreateDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractAnalysisFilesDto = {
  approve: Scalars['Boolean']['input'];
  legalRepresentativeDocument?: InputMaybe<Scalars['String']['input']>;
  types: Array<EProposalFileType>;
};

export type ContractAnalyzeLegalRepresentativeDataDto = {
  contractId: Scalars['String']['input'];
  document: Scalars['String']['input'];
  pendencies: ContractLegalRepresentativesPendencies;
};

export type ContractAnalyzeRegistrationDataDto = {
  contractId: Scalars['String']['input'];
  pendencies: ContractCustomerPendencies;
};

export type ContractChangeBenefitDto = {
  contractId: Scalars['String']['input'];
  rewardType: ERewardType;
};

export type ContractChangePowerPlantDto = {
  consortiumId: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  powerGeneratorId: Scalars['String']['input'];
  powerPlantId: Scalars['String']['input'];
};

export type ContractChangeSingleAccountDto = {
  contractId: Scalars['String']['input'];
  type: ESingleAccountType;
};

export type ContractCreateDtoGraphql = {
  billingType?: InputMaybe<EBillingType>;
  consortiumId?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Array<Scalars['String']['input']>>;
  contractedSharePercent?: InputMaybe<Scalars['Float']['input']>;
  customerId: Scalars['String']['input'];
  customerIndicationRef?: InputMaybe<ContractCustomerIndicationDto>;
  dealershipLogin?: InputMaybe<DealershipLoginCreateDto>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  eligibleForCashback?: InputMaybe<Scalars['Boolean']['input']>;
  energyBillInfo?: InputMaybe<ContractCreateEnergyBillInfoGraphqlDto>;
  fidelityMonths?: InputMaybe<Scalars['Float']['input']>;
  generatorId?: InputMaybe<Scalars['String']['input']>;
  gracePeriodMonths?: InputMaybe<Scalars['Float']['input']>;
  hasOwnGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  indicationRef?: InputMaybe<IndicationRefInputModel>;
  isPortabilityCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  origin?: InputMaybe<EContractOrigin>;
  ownGenerationAverageKwh?: InputMaybe<Scalars['Float']['input']>;
  participationKwh?: InputMaybe<Scalars['Float']['input']>;
  powerPlantId?: InputMaybe<Scalars['String']['input']>;
  previousGenerationBalance?: InputMaybe<Scalars['Float']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardCreateDto>;
  specialDiscount?: InputMaybe<Array<SpecialDiscountCreateDto>>;
  termOfManagement?: InputMaybe<Array<TermOfManagementCreateGraphqlDto>>;
  type: EContractType;
  validityMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractCreateEnergyBillInfoGraphqlDto = {
  AmountCents?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<AddressGraphqlDto>;
  avarageBillAmountCents?: InputMaybe<Scalars['Float']['input']>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<ContractFileCreateDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractCustomerIndicationDto = {
  customerId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
};

export type ContractCustomerPendencies = {
  city?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['Boolean']['input']>;
  uf?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractCustomerRefLegalRepresentativeModel = {
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  files?: Maybe<Array<DocumentationAnalysisFileModel>>;
  name: Scalars['String']['output'];
  pendencies?: Maybe<ContractCustomerRefLegalRepresentativePendenciesModel>;
  phone: Scalars['String']['output'];
};

export type ContractCustomerRefLegalRepresentativePendenciesModel = {
  city: ContractPendencyFieldModel;
  complement: ContractPendencyFieldModel;
  customerPjRepresentativeDocumentWithPhotoBack: ContractPendencyFieldModel;
  customerPjRepresentativeDocumentWithPhotoFront: ContractPendencyFieldModel;
  document: ContractPendencyFieldModel;
  email: ContractPendencyFieldModel;
  name: ContractPendencyFieldModel;
  neighborhood: ContractPendencyFieldModel;
  number: ContractPendencyFieldModel;
  phone: ContractPendencyFieldModel;
  state: ContractPendencyFieldModel;
  zipCode: ContractPendencyFieldModel;
};

export type ContractCustomerRefModel = {
  document: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  legalRepresentatives?: Maybe<Array<ContractCustomerRefLegalRepresentativeModel>>;
  name: Scalars['String']['output'];
  pendencies?: Maybe<ContractCustomerRefPendenciesModel>;
  personType: EPersonType;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ContractCustomerRefPendenciesModel = {
  city: ContractPendencyFieldModel;
  email: ContractPendencyFieldModel;
  name: ContractPendencyFieldModel;
  neighborhood: ContractPendencyFieldModel;
  number: ContractPendencyFieldModel;
  phone: ContractPendencyFieldModel;
  state: ContractPendencyFieldModel;
  street: ContractPendencyFieldModel;
  uf: ContractPendencyFieldModel;
  zipCode: ContractPendencyFieldModel;
};

export type ContractEnergyBillInfo = {
  AmountCents?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<AddressGraphqlModel>;
  avarageBillAmountCents?: Maybe<Scalars['Float']['output']>;
  avarageConsumption?: Maybe<Scalars['Float']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  consumerClassification?: Maybe<EConsumerUnitClassification>;
  dealershipId?: Maybe<Scalars['String']['output']>;
  dealershipName?: Maybe<Scalars['String']['output']>;
  distributionTaxes?: Maybe<Scalars['Float']['output']>;
  energyBillFile?: Maybe<ContractFileModel>;
  energyTaxes?: Maybe<Scalars['Float']['output']>;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  installationNumber?: Maybe<Scalars['String']['output']>;
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceDueDay?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  tariffClassification?: Maybe<ETariffClassification>;
  tension?: Maybe<EConsumerUnitTension>;
  tusdValue?: Maybe<Scalars['Float']['output']>;
};

export type ContractFileCreateDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  storageService: EStorageService;
};

export type ContractFileModel = {
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  storageService?: Maybe<EStorageService>;
};

export type ContractInvoiceChangeDueDateDto = {
  contractId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  isInterestAndFineWaived?: InputMaybe<Scalars['Boolean']['input']>;
  newDueDate: Scalars['DateTime']['input'];
};

export type ContractInvoiceSimulateDueDateChangeDto = {
  invoiceId: Scalars['String']['input'];
  isInterestAndFineWaived?: InputMaybe<Scalars['Boolean']['input']>;
  newDueDate: Scalars['DateTime']['input'];
};

export type ContractLegalRepresentativesPendencies = {
  city?: InputMaybe<Scalars['Boolean']['input']>;
  complement?: InputMaybe<Scalars['Boolean']['input']>;
  customerPjRepresentativeDocumentWithPhotoBack?: InputMaybe<Scalars['Boolean']['input']>;
  customerPjRepresentativeDocumentWithPhotoFront?: InputMaybe<Scalars['Boolean']['input']>;
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractListDtoGraphql = {
  canCreateInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeGraphqlSchema>;
  inOrigin?: InputMaybe<Array<EContractOrigin>>;
  inPendencies?: InputMaybe<Array<EContractFilterListPendencies>>;
  inPendenciesStatus?: InputMaybe<Array<EPendenciesStatus>>;
  inStatus?: InputMaybe<Array<EContractStatus>>;
  isFormalizedByPartner?: InputMaybe<Scalars['Boolean']['input']>;
  nameOrDocument?: InputMaybe<Scalars['String']['input']>;
  oldInstallationNumber?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ContractListSort>;
  type?: InputMaybe<EContractType>;
  ucOrClientNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ContractListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type ContractMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** Contracts */
export type ContractModel = {
  _id: Scalars['ID']['output'];
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedBy?: Maybe<Scalars['String']['output']>;
  billingType?: Maybe<EBillingType>;
  canCreateInvoices?: Maybe<Scalars['Boolean']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  canceledReason?: Maybe<Scalars['String']['output']>;
  cancellationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  cancellationRequestedBy?: Maybe<Scalars['String']['output']>;
  consortiumId?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Array<Scalars['String']['output']>>;
  contractedSharePercent?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['String']['output'];
  customerIndicationRef?: Maybe<CustomerIndicationReferenceModel>;
  customerRef: ContractCustomerRefModel;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<Scalars['String']['output']>;
  dealershipLogin?: Maybe<DealershipLoginModel>;
  eligibleForCashback: Scalars['Boolean']['output'];
  energyBillInfo?: Maybe<ContractEnergyBillInfo>;
  fidelityMonths?: Maybe<Scalars['Float']['output']>;
  files?: Maybe<Array<DocumentationAnalysisFileModel>>;
  gracePeriodMonths?: Maybe<Scalars['Float']['output']>;
  hasOwnGeneration: Scalars['Boolean']['output'];
  hasRequestedCustomerBankData?: Maybe<Scalars['Boolean']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  inDeactivationAt?: Maybe<Scalars['DateTime']['output']>;
  inDeactivationBy?: Maybe<Scalars['String']['output']>;
  indicationRef?: Maybe<IndicationRefModel>;
  isDocumentsAudited: Scalars['Boolean']['output'];
  isFormalizedByPartner: Scalars['Boolean']['output'];
  isPortabilityCustomer: Scalars['Boolean']['output'];
  lossReason?: Maybe<EContractLossReason>;
  monthlyConsumption?: Maybe<ContractMonthlyConsumption>;
  notes?: Maybe<Array<ObservationModel>>;
  origin?: Maybe<EContractOrigin>;
  ownGenerationAverageKwh?: Maybe<Scalars['Float']['output']>;
  participationKwh?: Maybe<Scalars['Float']['output']>;
  powerGeneratorId?: Maybe<Scalars['String']['output']>;
  powerPlantId?: Maybe<Scalars['String']['output']>;
  previousGenerationBalance?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<RewardModel>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signDate?: Maybe<Scalars['DateTime']['output']>;
  singleAccount?: Maybe<ContractSingleAccountModel>;
  specialDiscount?: Maybe<Array<SpecialDiscountModel>>;
  status?: Maybe<EContractStatus>;
  termOfAdhesion?: Maybe<Array<ContractTermOfAdhesionModel>>;
  termOfManagement?: Maybe<Array<ContractTermOfManagementModel>>;
  type?: Maybe<EContractType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validityMonths?: Maybe<Scalars['Float']['output']>;
};

export type ContractMonthlyConsumption = {
  april?: Maybe<Scalars['Int']['output']>;
  august?: Maybe<Scalars['Int']['output']>;
  december?: Maybe<Scalars['Int']['output']>;
  february?: Maybe<Scalars['Int']['output']>;
  january?: Maybe<Scalars['Int']['output']>;
  july?: Maybe<Scalars['Int']['output']>;
  june?: Maybe<Scalars['Int']['output']>;
  march?: Maybe<Scalars['Int']['output']>;
  may?: Maybe<Scalars['Int']['output']>;
  november?: Maybe<Scalars['Int']['output']>;
  october?: Maybe<Scalars['Int']['output']>;
  september?: Maybe<Scalars['Int']['output']>;
};

export type ContractNotifyPartnerFinishedDocumentationGraphqlDto = {
  contractId: Scalars['String']['input'];
};

/** Contracts pagination */
export type ContractPaginateModel = {
  data: Array<ContractModel>;
  meta: ContractMetaModel;
};

export type ContractPendencyFieldModel = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  analyzedBy?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

/** single account */
export type ContractSingleAccountCustomerAreaModel = {
  active: Scalars['Boolean']['output'];
  adhesionAt?: Maybe<Scalars['String']['output']>;
  adhesionBy?: Maybe<EAdhesionBySingleAccount>;
  adhesionResponsibility?: Maybe<Scalars['String']['output']>;
  history: Array<SingleAccountHitoryCustomerAreaModel>;
};

/** single account */
export type ContractSingleAccountModel = {
  active: Scalars['Boolean']['output'];
  adhesionAt?: Maybe<Scalars['DateTime']['output']>;
  adhesionBy?: Maybe<EAdhesionBySingleAccount>;
  adhesionResponsibility?: Maybe<Scalars['String']['output']>;
  history: Array<SingleAccountHitoryModel>;
};

export type ContractSolveCustomerPendenciesGraphqlDto = {
  contractId: Scalars['String']['input'];
  pendencies: Array<Scalars['String']['input']>;
};

export type ContractSolveLegalRepresentantPendenciesGraphqlDto = {
  contractId: Scalars['String']['input'];
  document: Scalars['String']['input'];
  pendencies: Array<Scalars['String']['input']>;
};

export type ContractSpecialDiscount = {
  discountPercent: Scalars['Float']['input'];
  month: Scalars['Float']['input'];
};

export type ContractTermOfAdhesionModel = {
  active: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  file?: Maybe<ContractFileModel>;
  replaced: Scalars['Boolean']['output'];
  signatureLink?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  signerEmail: Scalars['String']['output'];
  status: ETermStatus;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ContractTermOfManagementModel = {
  active: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  documentSignId: Scalars['String']['output'];
  file?: Maybe<ContractFileModel>;
  origin?: Maybe<Scalars['String']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  replaced: Scalars['Boolean']['output'];
  signatureLink?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signerEmail?: Maybe<Scalars['String']['output']>;
  status: ETermStatus;
  type?: Maybe<ETermOfManagementType>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ContractUpdateCommercialCondition = {
  billingType?: InputMaybe<EBillingType>;
  contractId: Scalars['String']['input'];
  contractedSharePercent?: InputMaybe<Scalars['Float']['input']>;
  defaultDiscount?: InputMaybe<Scalars['Float']['input']>;
  fidelityMonths?: InputMaybe<Scalars['Float']['input']>;
  gracePeriodMonths?: InputMaybe<Scalars['Float']['input']>;
  participationKwh?: InputMaybe<Scalars['Float']['input']>;
  specialDiscount?: InputMaybe<Array<ContractSpecialDiscount>>;
  validityMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractUpdateDtoGraphql = {
  _id: Scalars['String']['input'];
  billingType?: InputMaybe<EBillingType>;
  consortiumId?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Array<Scalars['String']['input']>>;
  contractedSharePercent?: InputMaybe<Scalars['Float']['input']>;
  dealershipLogin?: InputMaybe<DealershipLoginUpdateDto>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  eligibleForCashback?: InputMaybe<Scalars['Boolean']['input']>;
  fidelityMonths?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodMonths?: InputMaybe<Scalars['Float']['input']>;
  hasOwnGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  isPortabilityCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  ownGenerationAverageKwh?: InputMaybe<Scalars['Int']['input']>;
  participationKwh?: InputMaybe<Scalars['Float']['input']>;
  powerGeneratorId?: InputMaybe<Scalars['String']['input']>;
  powerPlantId?: InputMaybe<Scalars['String']['input']>;
  previousGenerationBalance?: InputMaybe<Scalars['Float']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardUpdateDto>;
  specialDiscount?: InputMaybe<Array<SpecialDiscountUpdateDto>>;
  status?: InputMaybe<EContractStatus>;
  type?: InputMaybe<EContractType>;
  validityMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractUpdateDealershipLogin = {
  extraPassword: Scalars['String']['input'];
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ContractUpdateEnergyBillInfo = {
  AmountCents?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<AddressGraphqlDto>;
  avarageBillAmountCents?: InputMaybe<Scalars['Float']['input']>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  contractId: Scalars['String']['input'];
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipLogin?: InputMaybe<ContractUpdateDealershipLogin>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<FileUploadInputTypeDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previousGenerationBalance?: InputMaybe<Scalars['Float']['input']>;
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractUpdateManuallyTermManagement = {
  contractId: Scalars['String']['input'];
  file: FilesUploadInputGraphqlDto;
};

export type ContractUpdateManuallyTermManagementApproveDto = {
  approve: Scalars['Boolean']['input'];
  contractId: Scalars['String']['input'];
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type CreateDiscountDto = {
  code: Scalars['String']['input'];
  /** Informar valor entre 0 e 100 % */
  discountPercentage?: Scalars['Float']['input'];
  type: EDiscountTableType;
};

export type CreateIndicationPartnerDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  averageEnergyBillValueCents: Scalars['Float']['input'];
  customerDiscountOffered?: InputMaybe<Scalars['Float']['input']>;
  dealershipId: Scalars['String']['input'];
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  personType: EPersonType;
  phone: Scalars['String']['input'];
  uf: Scalars['String']['input'];
};

export type CreateProposalPdfGraphql = {
  template: Scalars['String']['input'];
  variables: CreateProposalPdfVariablesGraphql;
};

export type CreateProposalPdfVariablesGraphql = {
  propoasalInstallationNumber: Scalars['String']['input'];
  proposalAmountWithDesperta: Scalars['String']['input'];
  proposalAmountWithoutDesperta: Scalars['String']['input'];
  proposalAverageMonthSavingValue: Scalars['String']['input'];
  proposalAverageYearSavingValue: Scalars['String']['input'];
  proposalConsumeAverageKwh: Scalars['String']['input'];
  proposalCustomerDocument: Scalars['String']['input'];
  proposalCustomerLegalRepresentativeName: Scalars['String']['input'];
  proposalCustomerName: Scalars['String']['input'];
  proposalDate: Scalars['String']['input'];
  proposalDiscountMonthPerFlagGreenPercentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagGreenValue: Scalars['String']['input'];
  proposalDiscountMonthPerFlagPurplePercentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagPurpleValue: Scalars['String']['input'];
  proposalDiscountMonthPerFlagRedP1Percentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagRedP1Value: Scalars['String']['input'];
  proposalDiscountMonthPerFlagRedP2Percentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagRedP2Value: Scalars['String']['input'];
  proposalDiscountMonthPerFlagYellowPercentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagYellowValue: Scalars['String']['input'];
  proposalDiscountPercentage: Scalars['String']['input'];
  proposalDueDate: Scalars['String']['input'];
  proposalNumber: Scalars['String']['input'];
};

export type CreateSimulationPdfGraphql = {
  template: Scalars['String']['input'];
  variables: CreateSimulationPdfVariablesGraphql;
};

export type CreateSimulationPdfVariablesGraphql = {
  applyDiscount?: InputMaybe<Scalars['Float']['input']>;
  baseURL?: InputMaybe<Scalars['String']['input']>;
  proposalToken?: InputMaybe<Scalars['String']['input']>;
  simulationAmountWithDesperta: Scalars['String']['input'];
  simulationAmountWithoutDesperta: Scalars['String']['input'];
  simulationAverageMonthSavingValue: Scalars['String']['input'];
  simulationAverageYearSavingValue: Scalars['String']['input'];
  simulationCustomerDocument: Scalars['String']['input'];
  simulationCustomerLegalRepresentativeName: Scalars['String']['input'];
  simulationCustomerName: Scalars['String']['input'];
  simulationDate: Scalars['String']['input'];
  simulationDueDate: Scalars['String']['input'];
  simulationNumber: Scalars['String']['input'];
};

export type CustomerAreaRewardHistoryModel = {
  description: Scalars['String']['output'];
  ocurredAt: Scalars['String']['output'];
};

export type CustomerAreaRewardModel = {
  history?: Maybe<Array<CustomerAreaRewardHistoryModel>>;
  percent: Scalars['Float']['output'];
  type: ECustomerAreaRewardType;
};

export type CustomerCashbackInvoicePayDto = {
  invoceIds: Array<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type CustomerCreateDigitalAccountGraphqlDto = {
  accountOwner: EPersonType;
  bank: BankGraphqlDto;
  customerId?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeDocument?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<CustomerFileCreateGraphql>>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  personType: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  uf?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDigitalAccountInfoDto = {
  address: AddressGraphqlModel;
  bank?: Maybe<BankGraphqlModel>;
  customerLegalRepresentative?: Maybe<CustomerDigitalAccountLegalRepresentativeDto>;
  digitalAccountStatus: EDigitalAccountStatus;
  document: Scalars['String']['output'];
  documents: Array<DigitalAccountDocumentDto>;
  feedback?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pendecies: DigitalAccountPendenciesDto;
  personType: EPersonType;
  phone: Scalars['String']['output'];
};

export type CustomerDigitalAccountLegalRepresentativeDto = {
  document: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Digital account pendencies */
export type CustomerDigitalAccountPendenciesModel = {
  account: CustomerDigitalAccountPendencyModel;
  address: CustomerDigitalAccountPendencyModel;
  addressProof: CustomerDigitalAccountPendencyModel;
  agency: CustomerDigitalAccountPendencyModel;
  balance_sheet?: Maybe<CustomerDigitalAccountPendencyModel>;
  identificationBack: CustomerDigitalAccountPendencyModel;
  identificationFront: CustomerDigitalAccountPendencyModel;
  selfie: CustomerDigitalAccountPendencyModel;
  social_contract?: Maybe<CustomerDigitalAccountPendencyModel>;
};

/** Digital account pendency */
export type CustomerDigitalAccountPendencyModel = {
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  inAnalysisAt?: Maybe<Scalars['DateTime']['output']>;
  pendenciedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerDigitalAccountUpdateLegalRepresentativeDto = {
  document: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CustomerFileCreateGraphql = {
  file: FileUploadInputTypeDto;
  sendAt: Scalars['String']['input'];
  status: ECustomerFileStatus;
  type: ECustomerFileType;
};

export type CustomerFileCreateGraphqlDto = {
  file?: InputMaybe<FileUploadInputTypeDto>;
  sendAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ECustomerFileStatus;
  type: ECustomerFileType;
};

export type CustomerFileModel = {
  file?: Maybe<FileUploadModel>;
  sendAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ECustomerFileStatus>;
  type?: Maybe<ECustomerFileType>;
};

export type CustomerIndicationRefModel = {
  address?: Maybe<AddressGraphqlModel>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type CustomerIndicationReferenceModel = {
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
};

export type CustomerLegalRepresentativeGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<ProposalFileCreateGraphqlDto>>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type CustomerListGraphqlDto = {
  dateRange?: InputMaybe<DateRangeGraphqlSchema>;
  nameOrDocumentOrEmail?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  personType?: InputMaybe<EPersonType>;
  sort?: InputMaybe<CustomerListSort>;
};

export type CustomerListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CustomerModel = {
  _id: Scalars['ID']['output'];
  address?: Maybe<AddressGraphqlModel>;
  bank?: Maybe<BankGraphqlModel>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digitalAccount?: Maybe<DigitalAccountModel>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  files?: Maybe<Array<CustomerFileModel>>;
  hash?: Maybe<Scalars['String']['output']>;
  indicationCode: Scalars['String']['output'];
  legalRepresentatives?: Maybe<Array<LegalRepresentativeModel>>;
  maritalStatus?: Maybe<EMaritalStatus>;
  name: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  origin: Scalars['String']['output'];
  personType: EPersonType;
  phone: Scalars['String']['output'];
  status: ECustomerStatus;
  uf?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerPendencyFields = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  analysedBy?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  sendedAt?: Maybe<Scalars['DateTime']['output']>;
  solvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerRefCustomerRefModel = {
  document: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  energyBillFile: CustomerUserFileModel;
  name: Scalars['String']['output'];
  personType: EPersonType;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerRefModel = {
  address?: Maybe<AddressGraphqlModel>;
  digitalAccountId?: Maybe<Scalars['String']['output']>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerUpdateGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uf?: InputMaybe<Scalars['String']['input']>;
};

/** CustomerUseCashbackModel */
export type CustomerUseCashbackModel = {
  balanceCashbackAfterInvoicedPaidCents: Scalars['Float']['output'];
  balanceCashbackCents: Scalars['Float']['output'];
  invoiceId: Scalars['String']['output'];
  oldInvoiceValueCents: Scalars['Float']['output'];
};

/** User Access control */
export type CustomerUserAccessControl = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomerUserContractEnergyBillInfo = {
  AmountCents?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<AddressGraphqlModel>;
  avarageBillAmountCents?: Maybe<Scalars['Float']['output']>;
  avarageConsumption?: Maybe<Scalars['Float']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  consumerClassification?: Maybe<EConsumerUnitClassification>;
  dealershipId?: Maybe<Scalars['String']['output']>;
  dealershipName?: Maybe<Scalars['String']['output']>;
  distributionTaxes?: Maybe<Scalars['Float']['output']>;
  energyTaxes?: Maybe<Scalars['Float']['output']>;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  installationNumber?: Maybe<Scalars['String']['output']>;
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceDueDay?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  tariffClassification?: Maybe<ETariffClassification>;
  tension?: Maybe<EConsumerUnitTension>;
  tusdValue?: Maybe<Scalars['Float']['output']>;
};

/** paginate metadata */
export type CustomerUserContractMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** CustomerUserContracts */
export type CustomerUserContractModel = {
  _id: Scalars['String']['output'];
  activatedAt?: Maybe<Scalars['String']['output']>;
  activatedBy?: Maybe<Scalars['String']['output']>;
  consortiumId?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Array<Scalars['String']['output']>>;
  contractedSharePercent?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerRef?: Maybe<CustomerRefCustomerRefModel>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  eligibleForCashback: Scalars['Boolean']['output'];
  energyBillInfo?: Maybe<CustomerUserContractEnergyBillInfo>;
  fidelityMonths?: Maybe<Scalars['Float']['output']>;
  gracePeriodMonths?: Maybe<Scalars['Float']['output']>;
  hasRequestedCustomerBankData?: Maybe<Scalars['Boolean']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Array<Scalars['String']['output']>>;
  participationKwh?: Maybe<Scalars['Float']['output']>;
  powerGeneratorId?: Maybe<Scalars['String']['output']>;
  powerPlantId?: Maybe<Scalars['String']['output']>;
  proposalId?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<CustomerAreaRewardModel>;
  signDate?: Maybe<Scalars['DateTime']['output']>;
  singleAccount?: Maybe<ContractSingleAccountCustomerAreaModel>;
  status?: Maybe<EContractStatus>;
  type?: Maybe<EContractType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  validityMonths?: Maybe<Scalars['Float']['output']>;
};

export type CustomerUserContractUpdateDealershipLoginDto = {
  contractId: Scalars['String']['input'];
  dealershipLogin: DealershipLoginUpdateDto;
};

export type CustomerUserCreateInput = {
  /** customer id */
  customerId: Scalars['String']['input'];
  /** username of the user */
  email: Scalars['String']['input'];
  /** name of the user */
  name: Scalars['String']['input'];
  /** password of the user */
  password: Scalars['String']['input'];
  /** phone of the user */
  phone: Scalars['String']['input'];
};

export type CustomerUserFileModel = {
  fileName: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  storageService: EStorageService;
};

export type CustomerUserFilterArgs = {
  nameOrUsernameOrEmail?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ECustomerUserStatus>;
};

export type CustomerUserListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CustomerUserLoggedUserOutput = {
  /** Generated accessToken of the user */
  accessToken: Scalars['String']['output'];
};

/** paginate metadata */
export type CustomerUserMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** user */
export type CustomerUserModel = {
  _id: Scalars['ID']['output'];
  accessControlRef: CustomerUserAccessControl;
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  customerRef?: Maybe<UserCustomerRefModel>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  status: ECustomerUserStatus;
  type?: Maybe<EUserType>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type CustomerUserPaginateArgs = {
  filter?: InputMaybe<CustomerUserFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CustomerUserListSort>;
};

export type CustomerUserRecoverPasswordChangeInput = {
  newPassword: Scalars['String']['input'];
  retypeNewPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CustomerUserRecoverPasswordInput = {
  email: Scalars['String']['input'];
};

/** customerUserRecoverPassword */
export type CustomerUserRecoverPasswordModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ECustomerUserPasswordRecoverStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userRef: CustomerUserRefModel;
};

export type CustomerUserRefModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

/** users pagination */
export type CustomerUsersPaginateModel = {
  data: Array<CustomerUserModel>;
  meta: CustomerUserMetaModel;
};

/** customerWithdraw */
export type CustomerWithdrawModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerRef?: Maybe<UserCustomerRefModel>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digitalAccountId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: ECustomerWithdrawStatus;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type CustomerWithdrawRequestInputDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type Dashboard = {
  internalId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DashboardEmbedInfo = {
  embedToken: Scalars['String']['output'];
  embedUrl: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type DashboardInfoResponse = {
  embedToken: Scalars['String']['output'];
  embedUrl: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type DateRangeGraphqlSchema = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** dealership */
export type DealershiRefModel = {
  available: Scalars['Boolean']['output'];
  distributorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationUf?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  needLoginDealership: Scalars['Boolean']['output'];
};

export type DealershipCreateDto = {
  available: Scalars['Boolean']['input'];
  distributorId: Scalars['String']['input'];
  locationUf: Scalars['String']['input'];
  maxDiscountPercentagePf: Scalars['Float']['input'];
  maxDiscountPercentagePj: Scalars['Float']['input'];
  minimumExceptionValue?: InputMaybe<DealershipMinimumExceptionValueCreateDto>;
  name: Scalars['String']['input'];
  needLoginDealership: Scalars['Boolean']['input'];
  partnerBenefitToCustomer: DealershipPartnerBenefitToCustomerCreateDto;
  resolutionAneel?: InputMaybe<DealershipResolutionAneelCreateDto>;
  resolutionClasses?: InputMaybe<Array<DealershipResolutionClassDto>>;
};

export type DealershipDeleteDto = {
  _id: Scalars['String']['input'];
};

/** paginate metadata */
export type DealershipFlagTaxMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type DealershipHistorySchema = {
  action: Scalars['String']['output'];
  newData?: Maybe<Scalars['JSON']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  oldData?: Maybe<Scalars['JSON']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type DealershipListDto = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscountPercentages?: InputMaybe<Scalars['Boolean']['input']>;
  locationUf?: InputMaybe<EBrazilStates>;
  maxDiscountPercentagePf?: InputMaybe<Scalars['Float']['input']>;
  maxDiscountPercentagePj?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DealershipListSort>;
};

export type DealershipListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type DealershipLoginCreateDto = {
  extraPassword?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type DealershipLoginModel = {
  extraPassword?: Maybe<Scalars['String']['output']>;
  login: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type DealershipLoginUpdateDto = {
  extraPassword?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** paginate metadata */
export type DealershipMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type DealershipMinimumExceptionValueCreateDto = {
  allowException: Scalars['Boolean']['input'];
  value: Scalars['Float']['input'];
};

/** Minimum exception value  */
export type DealershipMinimumExceptionValueModel = {
  allowException: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

/** dealerships */
export type DealershipModel = {
  _id: Scalars['ID']['output'];
  available: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distributorId?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<DealershipHistorySchema>>;
  locationUf?: Maybe<Scalars['String']['output']>;
  maxDiscountPercentagePf?: Maybe<Scalars['Float']['output']>;
  maxDiscountPercentagePj?: Maybe<Scalars['Float']['output']>;
  minimumExceptionValue?: Maybe<DealershipMinimumExceptionValueModel>;
  name?: Maybe<Scalars['String']['output']>;
  needLoginDealership: Scalars['Boolean']['output'];
  partnerBenefitToCustomer: DealershipPartnerBenefitToCustomerModel;
  resolutionAneel?: Maybe<DealershipResolutionAneelModel>;
  resolutionClasses: Array<DealershipResolutionClasseModel>;
  updatedAt: Scalars['DateTime']['output'];
};

/** dealerships pagination */
export type DealershipPaginateModel = {
  data: Array<DealershipModel>;
  meta: DealershipMetaModel;
};

export type DealershipPartnerBenefitToCustomerCreateDto = {
  customerPFDiscountMax: Scalars['Float']['input'];
  customerPFDiscountMin: Scalars['Float']['input'];
  customerPFDiscountSuggested: Scalars['Float']['input'];
  customerPJDiscountMax: Scalars['Float']['input'];
  customerPJDiscountMin: Scalars['Float']['input'];
  customerPJDiscountSuggested: Scalars['Float']['input'];
};

/** Partner benefit to customer */
export type DealershipPartnerBenefitToCustomerModel = {
  customerPFDiscountMax?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountMin?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountSuggested?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountMax?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountMin?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountSuggested?: Maybe<Scalars['Float']['output']>;
};

export type DealershipResolutionAneelCreateDto = {
  linkUrl: Scalars['String']['input'];
  modality?: InputMaybe<EDealershipResolutionModality>;
  resolutionHomologed: Scalars['String']['input'];
  validity: Scalars['String']['input'];
};

/** Resoluções da Aneel em vigor */
export type DealershipResolutionAneelModel = {
  linkUrl: Scalars['String']['output'];
  modality?: Maybe<EDealershipResolutionModality>;
  resolutionHomologed: Scalars['String']['output'];
  validity: Scalars['String']['output'];
};

export type DealershipResolutionClassDto = {
  class: EDealershipResolutuionClass;
  cofinsPercentage: Scalars['Float']['input'];
  fcp?: InputMaybe<Scalars['Float']['input']>;
  icmsPercentage: Scalars['Float']['input'];
  pisPercentage: Scalars['Float']['input'];
  teValueCents: Scalars['Float']['input'];
  tusdValueCents: Scalars['Float']['input'];
  wireBCalculationBaseValueCents?: InputMaybe<Scalars['Float']['input']>;
};

export type DealershipResolutionClasseModel = {
  class: EDealershipResolutuionClass;
  cofinsPercentage: Scalars['Float']['output'];
  fcp?: Maybe<Scalars['Float']['output']>;
  icmsPercentage: Scalars['Float']['output'];
  pisPercentage: Scalars['Float']['output'];
  teValueCents: Scalars['Float']['output'];
  tusdValueCents: Scalars['Float']['output'];
  wireBCalculationBaseValueCents?: Maybe<Scalars['Float']['output']>;
};

export type DealershipUpdateDto = {
  _id: Scalars['String']['input'];
  available?: InputMaybe<Scalars['Boolean']['input']>;
  distributorId?: InputMaybe<Scalars['String']['input']>;
  locationUf?: InputMaybe<Scalars['String']['input']>;
  maxDiscountPercentagePf?: InputMaybe<Scalars['Float']['input']>;
  maxDiscountPercentagePj?: InputMaybe<Scalars['Float']['input']>;
  minimumExceptionValue?: InputMaybe<DealershipMinimumExceptionValueCreateDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  needLoginDealership?: InputMaybe<Scalars['Boolean']['input']>;
  partnerBenefitToCustomer?: InputMaybe<DealershipPartnerBenefitToCustomerCreateDto>;
  resolutionAneel?: InputMaybe<DealershipResolutionAneelCreateDto>;
  resolutionClasses?: InputMaybe<Array<DealershipResolutionClassDto>>;
};

export type DigitalAccountBalanceModel = {
  balanceCents?: Maybe<Scalars['Float']['output']>;
};

export type DigitalAccountDocumentDto = {
  file: DigitalAccountDocumentFileDto;
  type: EDigitalAccountDocumentType;
};

export type DigitalAccountDocumentFileDto = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  storageService: EStorageService;
};

export type DigitalAccountDocumentFileModel = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  storageService: EStorageService;
};

export type DigitalAccountDocumentFileUpdateDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  storageService: EStorageService;
  type: EDigitalAccountDocumentType;
};

export type DigitalAccountDocumentModel = {
  file: DigitalAccountDocumentFileModel;
  type: EDigitalAccountDocumentType;
};

export type DigitalAccountInvoiceSplitModel = {
  amountCents: Scalars['Float']['output'];
  barcode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  internalAccountIdToPayment?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DigitalAccountLegalRepresentativeModel = {
  document?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DigitalAccountModel = {
  accountOwner?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  documents: Array<DigitalAccountDocumentModel>;
  email?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legalRepresentative?: Maybe<Array<DigitalAccountLegalRepresentativeModel>>;
  name: Scalars['String']['output'];
  pendencies: CustomerDigitalAccountPendenciesModel;
  phone?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DigitalAccountPendecyDto = {
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  inAnalysisAt?: Maybe<Scalars['DateTime']['output']>;
  pendenciedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DigitalAccountPendenciesDto = {
  account: DigitalAccountPendecyDto;
  address: DigitalAccountPendecyDto;
  addressProof: DigitalAccountPendecyDto;
  agency: DigitalAccountPendecyDto;
  balance_sheet?: Maybe<DigitalAccountPendecyDto>;
  customerLegalRepresentativeDocument?: Maybe<DigitalAccountPendecyDto>;
  customerLegalRepresentativeName?: Maybe<DigitalAccountPendecyDto>;
  identificationBack: DigitalAccountPendecyDto;
  identificationFront: DigitalAccountPendecyDto;
  selfie: DigitalAccountPendecyDto;
  social_contract?: Maybe<DigitalAccountPendecyDto>;
};

export type DigitalAccountPixResModel = {
  key: Scalars['String']['output'];
  keyType: Scalars['String']['output'];
};

export type DigitalAccountUpdateDto = {
  address: AddressGraphqlDto;
  bank: BankGraphqlDto;
  customerLegalRepresentative?: InputMaybe<CustomerDigitalAccountUpdateLegalRepresentativeDto>;
  documents: Array<DigitalAccountDocumentFileUpdateDto>;
  phone: Scalars['String']['input'];
};

export type DigitalAccountWalletExtractResponseModel = {
  _id: Scalars['String']['output'];
  balanceCents: Scalars['Float']['output'];
  bankOperation?: Maybe<BankOperationResModel>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  idempotencyKey: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  operationType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trackOperation?: Maybe<TrackOperationResModel>;
  updatedAt: Scalars['String']['output'];
  valueCents: Scalars['Float']['output'];
};

export type DiscountExceptionSchema = {
  customerPFDiscountMax: Scalars['Float']['output'];
  customerPFDiscountMin: Scalars['Float']['output'];
  customerPFDiscountSuggested: Scalars['Float']['output'];
  customerPJDiscountMax: Scalars['Float']['output'];
  customerPJDiscountMin: Scalars['Float']['output'];
  customerPJDiscountSuggested: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
};

export type DiscountOfferedSchema = {
  customerPFDiscountOffered: Scalars['Float']['output'];
  customerPJDiscountOffered: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
};

export type DiscountTableDto = {
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountPercentage: Scalars['Float']['output'];
  type: EDiscountTableType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscountTableListDto = {
  filter?: InputMaybe<FilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DiscountTableListSort>;
};

export type DiscountTableListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type DiscountTableModel = {
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountPercentage: Scalars['Float']['output'];
  type: EDiscountTableType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscountTablePaginateDto = {
  data: Array<DiscountTableDto>;
  meta: Meta;
};

export type DistributorListDto = {
  active?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DistributorListSort>;
};

export type DistributorListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type DistributorMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** distributors */
export type DistributorModel = {
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  providerDistributorId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** distributors pagination */
export type DistributorPaginateModel = {
  data: Array<DistributorModel>;
  meta: DistributorMetaModel;
};

export type DocumentSignerModel = {
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requestSignId?: Maybe<Scalars['String']['output']>;
};

export type DocumentationAnalysisFileModel = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  analyzedBy?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FileUploadModel>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: EProposalFileStatus;
  type: EProposalFileType;
};

export enum EAdhesionBySingleAccount {
  customer = 'customer',
  desperta = 'desperta'
}

export enum EAffiliatePartnerUserAccessStatus {
  allowed = 'allowed',
  notAllowed = 'notAllowed'
}

export enum EAffiliatePartnerUserFileType {
  addressProof = 'addressProof',
  cnpj = 'cnpj',
  idDocument = 'idDocument',
  selfie = 'selfie',
  socialContract = 'socialContract'
}

export enum EAffiliatePartnerUserHistoryAuthor {
  backoffice = 'backoffice',
  representative = 'representative'
}

export enum EAffiliatePartnerUserHistoryEvent {
  accessAllowed = 'accessAllowed',
  accessRevoked = 'accessRevoked',
  approved = 'approved',
  passwordSet = 'passwordSet',
  registered = 'registered',
  rejected = 'rejected'
}

export enum EAffiliatePartnerUserPasswordRecoverStatus {
  completed = 'completed',
  expired = 'expired',
  pending = 'pending'
}

export enum EAffiliatePartnerUserStatus {
  approved = 'approved',
  rejected = 'rejected',
  underAnalysis = 'underAnalysis'
}

export enum EBankAccountType {
  cc = 'cc',
  cp = 'cp'
}

export enum EBillingType {
  keepsBenefit = 'keepsBenefit',
  losesBenefit = 'losesBenefit'
}

export enum EBrazilStates {
  AC = 'AC',
  AL = 'AL',
  AM = 'AM',
  AP = 'AP',
  BA = 'BA',
  CE = 'CE',
  DF = 'DF',
  ES = 'ES',
  GO = 'GO',
  MA = 'MA',
  MG = 'MG',
  MS = 'MS',
  MT = 'MT',
  PA = 'PA',
  PB = 'PB',
  PE = 'PE',
  PI = 'PI',
  PR = 'PR',
  RJ = 'RJ',
  RN = 'RN',
  RO = 'RO',
  RR = 'RR',
  RS = 'RS',
  SC = 'SC',
  SE = 'SE',
  SP = 'SP'
}

export enum EBusinessProposalStatus {
  allocated = 'allocated',
  approved = 'approved',
  canceled = 'canceled',
  finalized = 'finalized',
  inAnalysis = 'inAnalysis',
  rejected = 'rejected'
}

export enum EChangedBy {
  AUTOMATIC = 'AUTOMATIC',
  BITRIX = 'BITRIX',
  MANUAL = 'MANUAL'
}

export enum ECommissionStatus {
  canceled = 'canceled',
  extension = 'extension',
  late = 'late',
  notPaid = 'notPaid',
  paid = 'paid'
}

export enum ECommissionStatusFilter {
  extension = 'extension',
  late = 'late',
  notPaid = 'notPaid',
  paid = 'paid'
}

export enum ECommissioningType {
  anticipated = 'anticipated',
  recurring = 'recurring'
}

export enum EConsortiumStatus {
  active = 'active',
  inactive = 'inactive'
}

export enum EConsumerUnitClassification {
  comercial = 'comercial',
  industrial = 'industrial',
  outros = 'outros',
  residencial = 'residencial',
  rural = 'rural'
}

export enum EConsumerUnitTension {
  bifasico = 'bifasico',
  monofasico = 'monofasico',
  trifasico = 'trifasico'
}

export enum EContractFilterListPendencies {
  signTermAdhesion = 'signTermAdhesion',
  signTermManagement = 'signTermManagement'
}

export enum EContractLossReason {
  areaNotCovered = 'areaNotCovered',
  beneficiaryDueToLowIncome = 'beneficiaryDueToLowIncome',
  buildingOwnPlantOrAlreadyHasOne = 'buildingOwnPlantOrAlreadyHasOne',
  closedWithCompetitor = 'closedWithCompetitor',
  companyChangingPartners = 'companyChangingPartners',
  companyDeactivated = 'companyDeactivated',
  delinquent = 'delinquent',
  didNotUnderstandTheSolution = 'didNotUnderstandTheSolution',
  duplicateLead = 'duplicateLead',
  leadCreatedForTesting = 'leadCreatedForTesting',
  lostToPartner = 'lostToPartner',
  other = 'other',
  rejectedByGenerator = 'rejectedByGenerator',
  suspectedFraud = 'suspectedFraud'
}

export enum EContractOrigin {
  activeCampaign = 'activeCampaign',
  customer = 'customer',
  internal = 'internal',
  partner = 'partner',
  partnerApi = 'partnerApi',
  partnerLink = 'partnerLink',
  rdStation = 'rdStation',
  website = 'website'
}

export enum EContractStatus {
  active = 'active',
  cancellationRequested = 'cancellationRequested',
  deactivated = 'deactivated',
  inDeactivation = 'inDeactivation',
  reserved = 'reserved',
  sent = 'sent',
  signatures = 'signatures'
}

export enum EContractType {
  desperta = 'desperta',
  externalGenerator = 'externalGenerator'
}

export enum ECustomerAreaRewardType {
  cashback = 'cashback',
  discount = 'discount'
}

export enum ECustomerFileStatus {
  accepted = 'accepted',
  pending = 'pending',
  rejected = 'rejected',
  send = 'send'
}

export enum ECustomerFileType {
  customerPfDocumentWithPhotoBack = 'customerPfDocumentWithPhotoBack',
  customerPfDocumentWithPhotoFront = 'customerPfDocumentWithPhotoFront',
  customerPjDocumentCard = 'customerPjDocumentCard',
  customerPjRepresentativeDocumentWithPhotoBack = 'customerPjRepresentativeDocumentWithPhotoBack',
  customerPjRepresentativeDocumentWithPhotoFront = 'customerPjRepresentativeDocumentWithPhotoFront',
  customerPjSocialContract = 'customerPjSocialContract',
  energyBill = 'energyBill'
}

export enum ECustomerStatus {
  completed = 'completed',
  pending = 'pending'
}

export enum ECustomerUserPasswordRecoverStatus {
  completed = 'completed',
  expired = 'expired',
  pending = 'pending'
}

export enum ECustomerUserStatus {
  active = 'active',
  blocked = 'blocked',
  inactive = 'inactive',
  pending = 'pending'
}

export enum ECustomerWithdrawStatus {
  error = 'error',
  finished = 'finished',
  pending = 'pending',
  requested = 'requested'
}

export enum EDealershipResolutionModality {
  conventional = 'conventional',
  notConventional = 'notConventional'
}

export enum EDealershipResolutuionClass {
  b1 = 'b1',
  b2 = 'b2',
  b3 = 'b3'
}

export enum EDigitalAccountDocumentType {
  addressProof = 'addressProof',
  balance_sheet = 'balance_sheet',
  identificationBack = 'identificationBack',
  identificationFront = 'identificationFront',
  others = 'others',
  selfie = 'selfie',
  social_contract = 'social_contract'
}

export enum EDigitalAccountStatus {
  approved = 'approved',
  blocked = 'blocked',
  canceled = 'canceled',
  disapproved = 'disapproved',
  inAnalysis = 'inAnalysis',
  inactive = 'inactive',
  pending = 'pending'
}

export enum EDiscountTableType {
  customerFloatFlag = 'customerFloatFlag',
  customerNotFloatFlag = 'customerNotFloatFlag'
}

export enum EDocumentSignStatus {
  created = 'created',
  error = 'error',
  expired = 'expired',
  pending = 'pending',
  refused = 'refused',
  signatureRequested = 'signatureRequested',
  signed = 'signed',
  uploaded = 'uploaded'
}

export enum EIndicationOrigin {
  api = 'api',
  link = 'link',
  partnerArea = 'partnerArea'
}

export enum EIndicationStatus {
  activeContract = 'activeContract',
  awaitingSignature = 'awaitingSignature',
  canceled = 'canceled',
  canceledContract = 'canceledContract',
  canceledProposal = 'canceledProposal',
  contractWithPendencies = 'contractWithPendencies',
  expiredProposal = 'expiredProposal',
  pending = 'pending',
  proposalUnderAudit = 'proposalUnderAudit',
  requestedProposal = 'requestedProposal',
  signedContract = 'signedContract'
}

export enum EIndicationType {
  customer = 'customer',
  partner = 'partner',
  partnerApi = 'partnerApi',
  partnerLink = 'partnerLink'
}

export enum EInvoiceBenefitStatus {
  lost = 'lost',
  maintained = 'maintained'
}

export enum EInvoiceBenefitType {
  cashback = 'cashback',
  discount = 'discount'
}

export enum EInvoiceCancelReason {
  clientNegotiation = 'clientNegotiation',
  clientRetention = 'clientRetention',
  incorrectData = 'incorrectData',
  incorrectInvoice = 'incorrectInvoice',
  other = 'other',
  systemError = 'systemError',
  wrongAmount = 'wrongAmount'
}

export enum EInvoicePaymentType {
  external = 'external',
  internal = 'internal'
}

export enum EInvoiceStatus {
  canceled = 'canceled',
  createPayment = 'createPayment',
  expired = 'expired',
  externalNegotiation = 'externalNegotiation',
  generatePDF = 'generatePDF',
  late = 'late',
  paid = 'paid',
  paymentRequest = 'paymentRequest',
  pending = 'pending',
  requested = 'requested'
}

export enum EInvoiceTemplate {
  gd1WithCashback = 'gd1WithCashback',
  gd1WithCashbackUnified = 'gd1WithCashbackUnified',
  gd1WithDiscount = 'gd1WithDiscount',
  gd1WithDiscountUnified = 'gd1WithDiscountUnified'
}

export enum ELossReason {
  areaNotCovered = 'areaNotCovered',
  beneficiaryDueToLowIncome = 'beneficiaryDueToLowIncome',
  buildingOwnPlantOrAlreadyHasOne = 'buildingOwnPlantOrAlreadyHasOne',
  closedWithCompetitor = 'closedWithCompetitor',
  companyChangingPartners = 'companyChangingPartners',
  companyDeactivated = 'companyDeactivated',
  delinquent = 'delinquent',
  didNotSendDocumentation = 'didNotSendDocumentation',
  didNotUnderstandTheSolution = 'didNotUnderstandTheSolution',
  disagreesWithContractTerms = 'disagreesWithContractTerms',
  doesNotIntendToLeaveUtility = 'doesNotIntendToLeaveUtility',
  duplicateLead = 'duplicateLead',
  incorrectEmail = 'incorrectEmail',
  insufficientInvoiceAmount = 'insufficientInvoiceAmount',
  invalidOrMissingPhone = 'invalidOrMissingPhone',
  isInFreeMarket = 'isInFreeMarket',
  leadCreatedForTesting = 'leadCreatedForTesting',
  linkExpiredAfter30Days = 'linkExpiredAfter30Days',
  lostToPartner = 'lostToPartner',
  noContactReturned = 'noContactReturned',
  noInterestLostInterest = 'noInterestLostInterest',
  other = 'other',
  publicAgency = 'publicAgency',
  registrationMismatchWithInvoice = 'registrationMismatchWithInvoice',
  rejectedByCredit = 'rejectedByCredit',
  rejectedByGenerator = 'rejectedByGenerator',
  suspectedFraud = 'suspectedFraud',
  wantedDifferentDiscountPercentage = 'wantedDifferentDiscountPercentage'
}

export enum EMaritalStatus {
  divorced = 'divorced',
  married = 'married',
  single = 'single',
  widowed = 'widowed'
}

export enum EModule {
  accessControl = 'accessControl',
  affiliatePartnerArea = 'affiliatePartnerArea',
  commissions = 'commissions',
  consortiums = 'consortiums',
  contractNotes = 'contractNotes',
  contracts = 'contracts',
  customers = 'customers',
  customersArea = 'customersArea',
  dealership = 'dealership',
  documentsign = 'documentsign',
  files = 'files',
  invoices = 'invoices',
  notification = 'notification',
  partner = 'partner',
  powerGenerator = 'powerGenerator',
  powerPlants = 'powerPlants',
  proposals = 'proposals',
  sellers = 'sellers',
  users = 'users'
}

export enum ENotificationRecipient {
  customer = 'customer',
  partner = 'partner'
}

export enum EPartnerStatus {
  active = 'active',
  inactive = 'inactive'
}

export enum EPasswordRecoverStatus {
  completed = 'completed',
  expired = 'expired',
  pending = 'pending'
}

export enum EPendenciesStatus {
  documentationFullyReceived = 'documentationFullyReceived',
  fullyResolved = 'fullyResolved',
  partiallyResolved = 'partiallyResolved',
  rejected = 'rejected'
}

export enum EPersonType {
  pf = 'pf',
  pj = 'pj'
}

export enum EPowerPlantModality {
  gd1 = 'gd1',
  gd2 = 'gd2',
  gd3 = 'gd3'
}

export enum EProposalCustomerPendencies {
  averageEnergyBillValue = 'averageEnergyBillValue',
  city = 'city',
  dealershipName = 'dealershipName',
  document = 'document',
  email = 'email',
  maritalStatus = 'maritalStatus',
  name = 'name',
  nationality = 'nationality',
  neighborhood = 'neighborhood',
  number = 'number',
  phone = 'phone',
  state = 'state',
  street = 'street',
  uf = 'uf',
  zipcode = 'zipcode'
}

export enum EProposalFileStatus {
  accepted = 'accepted',
  pending = 'pending',
  rejected = 'rejected',
  send = 'send'
}

export enum EProposalFileType {
  customerPfDocumentWithPhotoBack = 'customerPfDocumentWithPhotoBack',
  customerPfDocumentWithPhotoFront = 'customerPfDocumentWithPhotoFront',
  customerPjDocumentCard = 'customerPjDocumentCard',
  customerPjRepresentativeDocumentWithPhotoBack = 'customerPjRepresentativeDocumentWithPhotoBack',
  customerPjRepresentativeDocumentWithPhotoFront = 'customerPjRepresentativeDocumentWithPhotoFront',
  customerPjSocialContract = 'customerPjSocialContract',
  energyBill = 'energyBill'
}

export enum EProposalFilterListPendencies {
  addressData = 'addressData',
  documentation = 'documentation',
  energyBill = 'energyBill',
  personalData = 'personalData',
  signTermAdhesion = 'signTermAdhesion'
}

export enum EProposalLegalRepresentantPendencies {
  address = 'address',
  document = 'document',
  email = 'email',
  maritalStatus = 'maritalStatus',
  name = 'name',
  phone = 'phone'
}

export enum EProposalOrigin {
  activeCampaign = 'activeCampaign',
  bitrix = 'bitrix',
  customer = 'customer',
  internal = 'internal',
  partner = 'partner',
  partnerApi = 'partnerApi',
  partnerLink = 'partnerLink',
  rdStation = 'rdStation',
  website = 'website'
}

export enum EProposalStatus {
  canceled = 'canceled',
  documentation = 'documentation',
  finalized = 'finalized',
  formalization = 'formalization'
}

export enum EProviderInvoice {
  api = 'api',
  gera = 'gera'
}

export enum EProviderInvoiceStatus {
  canceled = 'canceled',
  generated = 'generated',
  imported = 'imported',
  importedDealership = 'importedDealership',
  invoiced = 'invoiced'
}

export enum EProviderInvoiceType {
  dealership = 'dealership',
  powerPlan = 'powerPlan'
}

export enum ERewardType {
  cashback = 'cashback',
  discount = 'discount'
}

export enum ESellerChangeBy {
  partner = 'partner',
  system = 'system',
  user = 'user'
}

export enum ESingleAccountType {
  adhesion = 'adhesion',
  cancel = 'cancel'
}

export enum EStage {
  awaitingSignature = 'awaitingSignature',
  contactReestablished = 'contactReestablished',
  firstContactAttempt = 'firstContactAttempt',
  lead = 'lead',
  legalAssembly = 'legalAssembly',
  lost = 'lost',
  negotiating = 'negotiating',
  negotiationCoolingDown = 'negotiationCoolingDown',
  opportunity = 'opportunity',
  proposalContracted = 'proposalContracted',
  secondContactAttempt = 'secondContactAttempt',
  thirdContactAttempt = 'thirdContactAttempt'
}

export enum EStorageService {
  awsS3 = 'awsS3'
}

export enum ETariffClassification {
  A4 = 'A4',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3'
}

export enum ETermOfManagementType {
  automatic = 'automatic',
  manual = 'manual'
}

export enum ETermStatus {
  canceled = 'canceled',
  created = 'created',
  expired = 'expired',
  refused = 'refused',
  replaced = 'replaced',
  requestedSignature = 'requestedSignature',
  signed = 'signed',
  uploaded = 'uploaded'
}

export enum EUserStatus {
  active = 'active',
  blocked = 'blocked',
  inactive = 'inactive',
  pending = 'pending'
}

export enum EUserType {
  customer = 'customer',
  internal = 'internal',
  partner = 'partner',
  seller = 'seller'
}

export enum EWalletExtractStatus {
  error = 'error',
  finalized = 'finalized',
  processing = 'processing',
  requested = 'requested'
}

export type EmbedInfo = {
  embedToken: Scalars['String']['output'];
  embedUrl: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type EnergyBill = {
  dealershipBarCode?: Maybe<Scalars['String']['output']>;
  dealershipBarCodeDueDate?: Maybe<Scalars['DateTime']['output']>;
  dealershipBarCodeValueCents?: Maybe<Scalars['Float']['output']>;
  dealershipInvoiceValueCents: Scalars['Float']['output'];
  despertaInvoiceValueCents: Scalars['Float']['output'];
  energyGeneratedInMonth: Scalars['Float']['output'];
  energyGenerationBalance: Scalars['Float']['output'];
  energyUsedMonth: Scalars['Float']['output'];
  lastMonthGenerationBalance: Scalars['Float']['output'];
  reference: ReferenceOrderModel;
};

/** Enriched Contracts pagination */
export type EnrichedContractModel = {
  _id: Scalars['ID']['output'];
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedBy?: Maybe<Scalars['String']['output']>;
  billingType?: Maybe<EBillingType>;
  canCreateInvoices?: Maybe<Scalars['Boolean']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  canceledReason?: Maybe<Scalars['String']['output']>;
  cancellationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  cancellationRequestedBy?: Maybe<Scalars['String']['output']>;
  consortiumId?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Array<Scalars['String']['output']>>;
  contractedSharePercent?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['String']['output'];
  customerIndicationRef?: Maybe<CustomerIndicationReferenceModel>;
  customerRef: ContractCustomerRefModel;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<Scalars['String']['output']>;
  dealershipLogin?: Maybe<DealershipLoginModel>;
  dealershipRef?: Maybe<DealershiRefModel>;
  eligibleForCashback: Scalars['Boolean']['output'];
  energyBillInfo?: Maybe<ContractEnergyBillInfo>;
  fidelityMonths?: Maybe<Scalars['Float']['output']>;
  files?: Maybe<Array<DocumentationAnalysisFileModel>>;
  gracePeriodMonths?: Maybe<Scalars['Float']['output']>;
  hasOwnGeneration: Scalars['Boolean']['output'];
  hasRequestedCustomerBankData?: Maybe<Scalars['Boolean']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  inDeactivationAt?: Maybe<Scalars['DateTime']['output']>;
  inDeactivationBy?: Maybe<Scalars['String']['output']>;
  indicationRef?: Maybe<IndicationRefModel>;
  isDocumentsAudited: Scalars['Boolean']['output'];
  isFormalizedByPartner: Scalars['Boolean']['output'];
  isPortabilityCustomer: Scalars['Boolean']['output'];
  lossReason?: Maybe<EContractLossReason>;
  monthlyConsumption?: Maybe<ContractMonthlyConsumption>;
  notes?: Maybe<Array<ObservationModel>>;
  origin?: Maybe<EContractOrigin>;
  ownGenerationAverageKwh?: Maybe<Scalars['Float']['output']>;
  participationKwh?: Maybe<Scalars['Float']['output']>;
  powerGeneratorId?: Maybe<Scalars['String']['output']>;
  powerPlantId?: Maybe<Scalars['String']['output']>;
  powerPlantRef?: Maybe<PowerPlantModel>;
  previousGenerationBalance?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<RewardModel>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signDate?: Maybe<Scalars['DateTime']['output']>;
  singleAccount?: Maybe<ContractSingleAccountModel>;
  specialDiscount?: Maybe<Array<SpecialDiscountModel>>;
  status?: Maybe<EContractStatus>;
  termOfAdhesion?: Maybe<Array<ContractTermOfAdhesionModel>>;
  termOfManagement?: Maybe<Array<ContractTermOfManagementModel>>;
  type?: Maybe<EContractType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validityMonths?: Maybe<Scalars['Float']['output']>;
};

/** Contracts pagination */
export type EnrichedContractPaginateModel = {
  data: Array<EnrichedContractModel>;
  meta: ContractMetaModel;
};

export type FileFilterArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

/** paginate metadata */
export type FileMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** metadata */
export type FileMetadataModel = {
  sample: Scalars['String']['output'];
};

/** file */
export type FileModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  metadata?: Maybe<FileMetadataModel>;
  mimetype: Scalars['String']['output'];
  storageService?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FilePaginateArgs = {
  filter?: InputMaybe<FileFilterArgs>;
};

export type FileUploadInputTypeDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  storageService: Scalars['String']['input'];
};

export type FileUploadModel = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  storageService: Scalars['String']['output'];
};

/** files pagination */
export type FilesPaginateModel = {
  data: Array<FileModel>;
  meta: FileMetaModel;
};

export type FilesUploadInputGraphqlDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  storageService: EStorageService;
};

export type FilterArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  floatType?: InputMaybe<Array<EDiscountTableType>>;
};

export type FilterDigitalAccountWalletExtractGraphqlDto = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  dateBegin: Scalars['DateTime']['input'];
  dateEnd: Scalars['DateTime']['input'];
  pageNumber?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EWalletExtractStatus>;
};

export type GeoLocationResModel = {
  accuracy: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GetIndicationRelatedEntitiesByIdResponseDto = {
  contract?: Maybe<ContractModel>;
  proposal?: Maybe<ProposalModel>;
};

export type GetMyContractsGraphql = {
  inStatus?: InputMaybe<Array<EContractStatus>>;
};

export type History = {
  action?: Maybe<Scalars['String']['output']>;
  createBy: HistoryCreateBy;
  ocurredAt: Scalars['DateTime']['output'];
  status?: Maybe<EInvoiceStatus>;
};

export type HistoryCreateBy = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IndicationAnticipatedConditionInputModel = {
  additionalCommissionPercentage: Scalars['Float']['input'];
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionAmountPercentage: Scalars['Float']['input'];
  commissionExceptionGroupId: Scalars['String']['input'];
  commissionedInvoices: Scalars['Float']['input'];
};

export type IndicationAnticipatedConditionModel = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
  commissionExceptionGroupId?: Maybe<Scalars['String']['output']>;
  commissionedInvoices: Scalars['Float']['output'];
};

export type IndicationConditionInputModel = {
  anticipated: IndicationAnticipatedConditionInputModel;
  customerDiscountMax: Scalars['Float']['input'];
  customerDiscountMin: Scalars['Float']['input'];
  customerDiscountOffered: Scalars['Float']['input'];
  customerDiscountSuggested: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
  dealershipName: Scalars['String']['input'];
  recurring: IndicationRecurringConditionInputModel;
  uf: Scalars['String']['input'];
};

export type IndicationConditionModel = {
  anticipated?: Maybe<IndicationAnticipatedConditionModel>;
  customerDiscountMax: Scalars['Float']['output'];
  customerDiscountMin: Scalars['Float']['output'];
  customerDiscountOffered: Scalars['Float']['output'];
  customerDiscountSuggested: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
  recurring?: Maybe<IndicationRecurringConditionModel>;
  uf: Scalars['String']['output'];
};

export type IndicationFilterArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  nameCustomerOrSalesman?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Array<EIndicationOrigin>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  salesmanId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<EIndicationStatus>>;
};

export type IndicationListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type IndicationMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type IndicationMetadataModel = {
  contractId?: Maybe<Scalars['String']['output']>;
  partnerRef?: Maybe<PartnerRefModel>;
  preProposalFileKey?: Maybe<Scalars['String']['output']>;
  proposalId?: Maybe<Scalars['String']['output']>;
};

export type IndicationMetricsDto = {
  activeContract: Scalars['Float']['output'];
  awaitingSignature: Scalars['Float']['output'];
  canceled: Scalars['Float']['output'];
  canceledContract: Scalars['Float']['output'];
  canceledProposal: Scalars['Float']['output'];
  contractWithPendencies: Scalars['Float']['output'];
  expiredProposal: Scalars['Float']['output'];
  indicationCount: Scalars['Float']['output'];
  pending: Scalars['Float']['output'];
  proposalUnderAudit: Scalars['Float']['output'];
  requestedProposal: Scalars['Float']['output'];
  signedContract: Scalars['Float']['output'];
};

export type IndicationModel = {
  _id: Scalars['ID']['output'];
  averageEnergyBillValueCents: Scalars['Float']['output'];
  condition?: Maybe<IndicationConditionModel>;
  createdAt: Scalars['DateTime']['output'];
  customerRef: CustomerIndicationRefModel;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  metadata: IndicationMetadataModel;
  origin: EIndicationOrigin;
  salesmanRef: SalesmanRefModel;
  status: EIndicationStatus;
  type: EIndicationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type IndicationPaginateArgs = {
  filter?: InputMaybe<IndicationFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<IndicationListSort>;
};

/** indications pagination */
export type IndicationPaginateModel = {
  data: Array<IndicationModel>;
  meta: IndicationMetaModel;
};

export type IndicationProposalFileDto = {
  file?: InputMaybe<FilesUploadInputGraphqlDto>;
  status: EProposalFileStatus;
  type: EProposalFileType;
};

export type IndicationRecurringConditionInputModel = {
  additionalCommissionPercentage: Scalars['Float']['input'];
  alwaysCommissionedInvoices: Scalars['Boolean']['input'];
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionAmountPercentage: Scalars['Float']['input'];
  commissionedInvoices: Scalars['Float']['input'];
};

export type IndicationRecurringConditionModel = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  alwaysCommissionedInvoices: Scalars['Boolean']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
  commissionedInvoices?: Maybe<Scalars['Float']['output']>;
};

export type IndicationRefInputModel = {
  condition?: InputMaybe<IndicationConditionInputModel>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  partner: PartnerRefInputModel;
  salesman: SalesmanRefInputModel;
  type: EIndicationType;
};

export type IndicationRefModel = {
  condition?: Maybe<IndicationConditionModel>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  partner?: Maybe<PartnerRefModel>;
  salesman: SalesmanRefModel;
  type: EIndicationType;
};

/** invoice calculate new duedate */
export type InvoiceCalculateNewDueDate = {
  invoiceId: Scalars['String']['output'];
  newDueDateCalculated: Array<InvoiceCalculateNewDueDateItem>;
};

export type InvoiceCalculateNewDueDateItem = {
  amountCents: Scalars['Float']['output'];
  dueDate: Scalars['DateTime']['output'];
  fineAmountCents: Scalars['Float']['output'];
  interestAmountCents: Scalars['Float']['output'];
  invoiceValue: Scalars['Float']['output'];
  lateDays: Scalars['Float']['output'];
};

export type InvoiceCancelInfoModel = {
  canceledBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceContractDealershipInfo = {
  dealershipTariff: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InvoiceContractInfo = {
  billingType: EBillingType;
  clientNumber: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dealership: InvoiceContractDealershipInfo;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  installationNumber: Scalars['String']['output'];
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  singleAccount: InvoiceContractSingleAccount;
};

export type InvoiceContractSingleAccount = {
  active: Scalars['Boolean']['output'];
  errorOnUnifiedInvoice?: Maybe<Scalars['String']['output']>;
  unifiedInvoice: Scalars['Boolean']['output'];
};

export type InvoiceDashboardHistoryInvoiceArrayModel = {
  history?: Maybe<Array<InvoiceHistoryDashboardModel>>;
};

export type InvoiceDashboardHistoryRewardsInvoiceArrayModel = {
  rewardHistory: Array<InvoiceHistoryRewardsDashboardModel>;
};

export type InvoiceDashboardInfoLastEconomyModel = {
  amountCents: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
};

export type InvoiceDashboardInfoModel = {
  lastEconomy: InvoiceDashboardInfoLastEconomyModel;
  lastInvoiceAmountCents: Scalars['Float']['output'];
  numberOfInvoices: Scalars['Float']['output'];
  overdueInvoices: Scalars['Float']['output'];
};

export type InvoiceDashboardUnifiedModel = {
  history?: Maybe<Array<InvoiceHistoryDashboardModel>>;
  rewardHistory: Array<InvoiceHistoryRewardsDashboardModel>;
};

export type InvoiceExternalPayment = {
  note?: Maybe<Scalars['String']['output']>;
  reportedAt: Scalars['DateTime']['output'];
  reportedBy: InvoiceExternalPaymentReportedByModel;
};

export type InvoiceExternalPaymentReportedByModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InvoiceHistoryDashboardModel = {
  amountCents: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type InvoiceHistoryRewardsDashboardModel = {
  amountCents: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type InvoiceListDto = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateRangeGraphqlSchema>;
  customerDocument?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<DateRangeGraphqlSchema>;
  inStatus?: InputMaybe<Array<EInvoiceStatus>>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paymentTypes?: InputMaybe<Array<EInvoicePaymentType>>;
  secondCopy?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  sort?: InputMaybe<InvoiceListSort>;
};

export type InvoiceListDigitalAccountModel = {
  _id: Scalars['String']['output'];
  amountCents: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  payment: InvoicePaymentModel;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentValueCents?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type InvoiceMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** invoices */
export type InvoiceModel = {
  _id: Scalars['ID']['output'];
  amountCents: Scalars['Int']['output'];
  benefitAmountCents: Scalars['Int']['output'];
  benefitPercentage: Scalars['Float']['output'];
  benefitStatus: EInvoiceBenefitStatus;
  benefitType: EInvoiceBenefitType;
  billingType: EBillingType;
  cancelInfo?: Maybe<InvoiceCancelInfoModel>;
  consortium: CustomerRefModel;
  contract: InvoiceContractInfo;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerRefModel;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate: Scalars['DateTime']['output'];
  energyBill: EnergyBill;
  extended: Scalars['Boolean']['output'];
  externalPayment?: Maybe<InvoiceExternalPayment>;
  hasInterestAndFine: Scalars['Boolean']['output'];
  history: Array<History>;
  indicationRef: IndicationRefModel;
  interestAndFineValues: PaymentInterestAndFineValues;
  isLate: Scalars['Boolean']['output'];
  items: Array<ItemModel>;
  lateDays: Scalars['Float']['output'];
  originalAmountCents: Scalars['Int']['output'];
  originalDueDate: Scalars['DateTime']['output'];
  paidAmountCents?: Maybe<Scalars['Float']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payment: Array<PaymentModel>;
  paymentType?: Maybe<EInvoicePaymentType>;
  status: EInvoiceStatus;
  totalConsumptionValueCents: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** invoice pagination */
export type InvoicePaginateModel = {
  data: Array<InvoiceModel>;
  meta: InvoiceMetaModel;
};

export type InvoicePaymentModel = {
  barcode?: Maybe<Scalars['String']['output']>;
  digitableLine?: Maybe<Scalars['String']['output']>;
  invoiceBase64?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paidValue?: Maybe<Scalars['Float']['output']>;
  pixQrcode?: Maybe<Scalars['String']['output']>;
  pixText?: Maybe<Scalars['String']['output']>;
};

export type InvoiceRequestSecondCopyInput = {
  dueDate: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
};

/** Invoice simulate due date change response */
export type InvoiceSimulateDueDateChangeModel = {
  /** Valor total da fatura em centavos */
  amountCents: Scalars['Float']['output'];
  /** Dias de diferença entre a data solicitada e a data válida */
  daysDifference: Scalars['Float']['output'];
  /** Valor da multa em centavos */
  fineAmountCents: Scalars['Float']['output'];
  /** Valor dos juros em centavos */
  interestAmountCents: Scalars['Float']['output'];
  invoiceId: Scalars['String']['output'];
  /** Valor original da fatura em centavos */
  invoiceValueCents: Scalars['Float']['output'];
  /** Se multa e juros foram perdoados */
  isInterestAndFineWaived: Scalars['Boolean']['output'];
  /** Dias de atraso em relação ao vencimento original */
  lateDays: Scalars['Float']['output'];
  /** Data solicitada pelo analista */
  requestedDueDate: Scalars['DateTime']['output'];
  /** Data válida (próximo dia útil se necessário) */
  validDueDate: Scalars['DateTime']['output'];
};

export type ItemModel = {
  description: Scalars['String']['output'];
  qtd?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  valueAmountCents: Scalars['Int']['output'];
  valueCentsUnit?: Maybe<Scalars['Int']['output']>;
};

export type JwtUserGraphql = {
  customerId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerOwner?: Maybe<Scalars['Boolean']['output']>;
  phone: Scalars['String']['output'];
  type: EUserType;
};

export type JwtUserGraphqlDto = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type JwtUserGraphqlModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type JwtUserTokenGraphql = {
  accessControlRef: UserAccessControlGraphql;
  roles: Array<Scalars['String']['output']>;
  user: JwtUserGraphql;
};

export type LegalRepresentativeAddGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  customerId: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<CustomerFileCreateGraphqlDto>>;
  identificationNumber: Scalars['String']['input'];
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type LegalRepresentativeModel = {
  address?: Maybe<AddressGraphqlModel>;
  bank?: Maybe<BankGraphqlModel>;
  document?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  files?: Maybe<Array<CustomerFileModel>>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type LegalRepresentativeRemoveGraphqlDto = {
  customerId: Scalars['String']['input'];
  document: Scalars['String']['input'];
};

export type LegalRepresentativeUpdateGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  customerId: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ListAllInvoicesFiltersGraphqlDto = {
  contractId?: InputMaybe<Scalars['String']['input']>;
};

export type LoggedUserOutput = {
  /** Generated accessToken of the user */
  accessToken: Scalars['String']['output'];
};

export type Meta = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type Metadata = {
  contractId: Scalars['String']['output'];
};

export type Module = {
  actions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ModuleDto = {
  actions: Array<ActionDto>;
  internalName: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
};

export type ModuleInput = {
  actions: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MonthlyConsumptionDto = {
  april?: InputMaybe<Scalars['Int']['input']>;
  august?: InputMaybe<Scalars['Int']['input']>;
  december?: InputMaybe<Scalars['Int']['input']>;
  february?: InputMaybe<Scalars['Int']['input']>;
  january?: InputMaybe<Scalars['Int']['input']>;
  july?: InputMaybe<Scalars['Int']['input']>;
  june?: InputMaybe<Scalars['Int']['input']>;
  march?: InputMaybe<Scalars['Int']['input']>;
  may?: InputMaybe<Scalars['Int']['input']>;
  november?: InputMaybe<Scalars['Int']['input']>;
  october?: InputMaybe<Scalars['Int']['input']>;
  september?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  accessControlCreate: AccessControlModel;
  accessControlDelete: Scalars['Boolean']['output'];
  accessControlUpdate: AccessControlModel;
  activateBulkContract: ContractActivateBulkModel;
  activateContract: ContractModel;
  activateDistributor?: Maybe<DistributorModel>;
  addNoteToProposal: ProposalModel;
  affiliatePartnerUserChangePassword: AffiliatePartnerUserRecoverPasswordModel;
  affiliatePartnerUserRecoverPassword?: Maybe<AffiliatePartnerUserRecoverPasswordModel>;
  analyseLegalRepresentativeData: ProposalModel;
  analyseRegistrationData: ProposalModel;
  calculateCommission: CalculateCommissionResponseDto;
  cancelContract: ContractModel;
  cancelProposal: ProposalModel;
  consortiumCreate: ConsortiumModel;
  consortiumDelete: Scalars['Boolean']['output'];
  consortiumUpdate: ConsortiumModel;
  contractAddEnergyBillInfo: ContractModel;
  contractAddObservation: ContractModel;
  contractAnalyzeLegalRepresentativeData: ContractModel;
  contractAnalyzeRegistrationData: ContractModel;
  contractChangeBenefit: ContractModel;
  contractChangeFlagCanCreateInvoices: ContractModel;
  contractChangePowerPlan: ContractModel;
  contractChangeSingleAccount: ContractModel;
  contractCreate: ContractModel;
  contractDelete: Scalars['Boolean']['output'];
  contractFilesAnalysis: ContractModel;
  contractRegenerateTermAdhesionOrAssociation?: Maybe<ContractModel>;
  contractRequestTermAdhesionOrAssociation?: Maybe<ContractModel>;
  contractRequestTermOfManagement?: Maybe<ContractModel>;
  contractSolveCustomerPendencies: ContractModel;
  contractSolveLegalRepresentativePendencies: ContractModel;
  contractSyncDocumentWithClickSign?: Maybe<ContractModel>;
  contractUpdate: ContractModel;
  contractUpdateCommercialCondition: ContractModel;
  contractUpdateEnergyBillInfo: ContractModel;
  contractUpdateManuallyTermManagement?: Maybe<ContractModel>;
  contractUpdateManuallyTermManagementApproveOrRepprove?: Maybe<ContractModel>;
  createAffiliatePartnerUser: AffiliatePartnerUserModel;
  createCustomerUser: CustomerUserModel;
  createIndication: IndicationModel;
  createProposalPdf: FileModel;
  createSimulationPdf: FileModel;
  createSimulationWithCashbackPdf: FileModel;
  createUser: UserModel;
  customerAddLegalRepresentant: CustomerModel;
  customerAreaCreateDigitalAccount: CustomerModel;
  customerCreate: CustomerModel;
  customerCreateDigitalAccount: CustomerModel;
  customerCreateUnLogged: CustomerModel;
  customerPayInvoicesWithCashback: CustomerUseCashbackModel;
  customerRemoveLegalRepresentant: CustomerModel;
  customerRequestInvoiceSecondCopy?: Maybe<CustomerModel>;
  customerUpdateById: CustomerModel;
  customerUpdateLegalRepresentant: CustomerModel;
  customerUserChangePassword: CustomerUserRecoverPasswordModel;
  customerUserRecoverPassword: CustomerUserRecoverPasswordModel;
  customerWithdrawRequest: CustomerWithdrawModel;
  dashboardHistoryInvoicesCustomerUser: InvoiceDashboardHistoryInvoiceArrayModel;
  dashboardHistoryInvoicesRewardsCustomerUser: InvoiceDashboardHistoryRewardsInvoiceArrayModel;
  dashboardInvoicesInfoCustomerUser: InvoiceDashboardInfoModel;
  dashboardUnifiedCustomerUser: InvoiceDashboardUnifiedModel;
  deactivateContract: ContractModel;
  deactivateDistributor?: Maybe<DistributorModel>;
  dealershipCreate: DealershipModel;
  dealershipDelete: Scalars['Boolean']['output'];
  dealershipResolutionClasseUpdate: DealershipModel;
  dealershipUpdate: DealershipModel;
  deleteAffiliatePartnerUser: AffiliatePartnerDeleteUserModel;
  deleteCustomerUser: CustomerUserModel;
  deleteUser: UserModel;
  discountTableCreate: DiscountTableModel;
  discountTableDelete?: Maybe<DiscountTableModel>;
  discountTableUpdate: DiscountTableModel;
  forInDeactivationContract: ContractModel;
  formalizeIndicationProposal: ProposalModel;
  generateNewTermOfAdhesion: ProposalModel;
  getCustomerNameByHash: Scalars['String']['output'];
  listAllInvoicesCustomerUser: PaginatedInvoiceDigitalAccountModel;
  loginAffiliatePartnerUser: AffiliatePartnerUserLoggedUserOutput;
  loginCustomerUser: CustomerUserLoggedUserOutput;
  loginUser: LoggedUserOutput;
  logoutCustomerUser: CustomerUserLoggedUserOutput;
  notificationCreate: NotificationModel;
  notifyCustomerFinishedDocumentation: ProposalModel;
  notifyFinishedDocumentation: Scalars['Boolean']['output'];
  openedOrClickedPushNotification: NotificationModel;
  partnerAffiliateUserApprove: PartnerAffiliateUserModel;
  partnerAffiliateUserReject: PartnerAffiliateUserModel;
  partnerCreate: PartnerModel;
  partnerDelete: Scalars['Boolean']['output'];
  partnerUpdate: PartnerModel;
  powerGeneratorAreaGetDashboardInfo: DashboardInfoResponse;
  powerGeneratorAreaLogin: PowerGeneratorAreaOutput;
  powerGeneratorCreate: PowerGeneratorModel;
  powerGeneratorDelete: Scalars['Boolean']['output'];
  powerGeneratorUpdate: PowerGeneratorModel;
  powerPlantCreate: PowerPlantModel;
  powerPlantDelete: Scalars['Boolean']['output'];
  powerPlantUpdate: PowerPlantModel;
  proposalAddEnergyBillInfo: ProposalModel;
  proposalAddLegalRepresentative: ProposalModel;
  proposalAddPreProposal: ProposalModel;
  proposalCreate: ProposalModel;
  proposalFilesAnalysis: ProposalModel;
  proposalFormalization: ProposalModel;
  proposalRemoveLegalRepresentative: ProposalModel;
  proposalUpdate: ProposalModel;
  proposalUpdateLegalRepresentative: ProposalModel;
  proposalUpdateManuallyTermManagement?: Maybe<ProposalModel>;
  proposalUpdateManuallyTermManagementApproveOrRepprove?: Maybe<ProposalModel>;
  providerInvoiceCancel: InvoiceModel;
  providerInvoiceChangeDueDate: ProviderInvoiceModel;
  receivedPushNotification: NotificationModel;
  regenerateApiKeyFromPartner: PartnerModel;
  reportExternalPayment: Scalars['Boolean']['output'];
  requestCustomerBankData: Scalars['String']['output'];
  sellerCreate: SellerModel;
  sellerDelete: Scalars['Boolean']['output'];
  sellerUpdate: SellerModel;
  sendContractToSign: ContractModel;
  sendPushNotification: NotificationModel;
  sendPushNotificationAll: NotificationModel;
  signedUrlLogin: Scalars['String']['output'];
  solveProposalCustomerPendencies: ProposalModel;
  solveProposalLegalRepresentantPendencies: ProposalModel;
  updateAffiliatePartnerUser: AffiliatePartnerUserModel;
  updateAffiliatePartnerUserApproved: AffiliatePartnerUserModel;
  updateCustomerDigitalAccountByHash: CustomerDigitalAccountInfoDto;
  updateDistributorsFromAPI: Array<DistributorModel>;
  updateIndication: IndicationModel;
  updateIndicationAddEnergyBillInfo: Scalars['Boolean']['output'];
  updateIndicationFiles: Scalars['Boolean']['output'];
  updateIndicationLegalRepresentatives: Scalars['Boolean']['output'];
  updateInvoicesToExternalNegotiation: UpdateInvoiceToExternalNegotiationModel;
  updatePartnerAreaPartnerIcone: PartnerModel;
  updatePartnerAreaPartnerLogo: PartnerModel;
  updatePartnerDefaultConfiguration: PartnerModel;
  updatePartnerDiscountsOffered: PartnerDiscountOfferedModel;
  updatePartnerWebhook: PartnerModel;
  updatePushNotifications: CustomerUserLoggedUserOutput;
  updateSalesFunnelStage: ProposalModel;
  updateUser: UserModel;
  userChangePassword: RecoverPasswordModel;
  userContractChangeBenefit: ContractModel;
  userContractChangeSingleAccount: ContractModel;
  userContractUpdateDealershipLogin: ContractModel;
  userRecoverPassword: RecoverPasswordModel;
};


export type MutationAccessControlCreateArgs = {
  params: AccessControlCreateDto;
};


export type MutationAccessControlDeleteArgs = {
  params: AccessControlDeleteDto;
};


export type MutationAccessControlUpdateArgs = {
  params: AccessControlUpdateDto;
};


export type MutationActivateBulkContractArgs = {
  contractIds: Array<Scalars['String']['input']>;
};


export type MutationActivateContractArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationActivateDistributorArgs = {
  distributorId: Scalars['String']['input'];
};


export type MutationAddNoteToProposalArgs = {
  params: AddNoteGraphqlDto;
};


export type MutationAffiliatePartnerUserChangePasswordArgs = {
  RecoverPasswordChangeInput: AffiliatePartnerUserRecoverPasswordChangeInput;
};


export type MutationAffiliatePartnerUserRecoverPasswordArgs = {
  RecoverPasswordInput: AffiliatePartnerUserRecoverPasswordInput;
};


export type MutationAnalyseLegalRepresentativeDataArgs = {
  params: AnalyseLegalRepresentativeDataDto;
};


export type MutationAnalyseRegistrationDataArgs = {
  params: AnalyseRegistrationDataDto;
};


export type MutationCalculateCommissionArgs = {
  params: CalculateCommissionParamsDto;
};


export type MutationCancelContractArgs = {
  params: CancelContractDtoGraphql;
};


export type MutationCancelProposalArgs = {
  params: CancelProposalGraphqlDto;
};


export type MutationConsortiumCreateArgs = {
  params: ConsortiumCreateDtoGraphql;
};


export type MutationConsortiumDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationConsortiumUpdateArgs = {
  params: ConsortiumUpdateDtoGraphql;
};


export type MutationContractAddEnergyBillInfoArgs = {
  params: ContractAddEnergyBillInfoGraphqlDto;
};


export type MutationContractAddObservationArgs = {
  params: ObservationCreateDtoGraphql;
};


export type MutationContractAnalyzeLegalRepresentativeDataArgs = {
  params: ContractAnalyzeLegalRepresentativeDataDto;
};


export type MutationContractAnalyzeRegistrationDataArgs = {
  params: ContractAnalyzeRegistrationDataDto;
};


export type MutationContractChangeBenefitArgs = {
  params: ContractChangeBenefitDto;
};


export type MutationContractChangeFlagCanCreateInvoicesArgs = {
  canCreateInvoices: Scalars['Boolean']['input'];
  contractId: Scalars['String']['input'];
};


export type MutationContractChangePowerPlanArgs = {
  params: ContractChangePowerPlantDto;
};


export type MutationContractChangeSingleAccountArgs = {
  params: ContractChangeSingleAccountDto;
};


export type MutationContractCreateArgs = {
  params: ContractCreateDtoGraphql;
};


export type MutationContractDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationContractFilesAnalysisArgs = {
  id: Scalars['String']['input'];
  params: ContractAnalysisFilesDto;
};


export type MutationContractRegenerateTermAdhesionOrAssociationArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationContractRequestTermAdhesionOrAssociationArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationContractRequestTermOfManagementArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationContractSolveCustomerPendenciesArgs = {
  params: ContractSolveCustomerPendenciesGraphqlDto;
};


export type MutationContractSolveLegalRepresentativePendenciesArgs = {
  params: ContractSolveLegalRepresentantPendenciesGraphqlDto;
};


export type MutationContractSyncDocumentWithClickSignArgs = {
  contractId: Scalars['String']['input'];
  documentKey: Scalars['String']['input'];
};


export type MutationContractUpdateArgs = {
  params: ContractUpdateDtoGraphql;
};


export type MutationContractUpdateCommercialConditionArgs = {
  params: ContractUpdateCommercialCondition;
};


export type MutationContractUpdateEnergyBillInfoArgs = {
  params: ContractUpdateEnergyBillInfo;
};


export type MutationContractUpdateManuallyTermManagementArgs = {
  params: ContractUpdateManuallyTermManagement;
};


export type MutationContractUpdateManuallyTermManagementApproveOrRepproveArgs = {
  params: ContractUpdateManuallyTermManagementApproveDto;
};


export type MutationCreateAffiliatePartnerUserArgs = {
  userCreateInput: AffiliatePartnerUserCreateInput;
};


export type MutationCreateCustomerUserArgs = {
  userCreateInput: CustomerUserCreateInput;
};


export type MutationCreateIndicationArgs = {
  params: CreateIndicationPartnerDto;
};


export type MutationCreateProposalPdfArgs = {
  params: CreateProposalPdfGraphql;
};


export type MutationCreateSimulationPdfArgs = {
  params: CreateSimulationPdfGraphql;
};


export type MutationCreateSimulationWithCashbackPdfArgs = {
  params: CreateSimulationPdfGraphql;
};


export type MutationCreateUserArgs = {
  userCreateInput: UserCreateInput;
};


export type MutationCustomerAddLegalRepresentantArgs = {
  params: LegalRepresentativeAddGraphqlDto;
};


export type MutationCustomerAreaCreateDigitalAccountArgs = {
  params: CustomerCreateDigitalAccountGraphqlDto;
};


export type MutationCustomerCreateArgs = {
  params: CustomerCreateGraphqlDto;
};


export type MutationCustomerCreateDigitalAccountArgs = {
  params: CustomerCreateDigitalAccountGraphqlDto;
};


export type MutationCustomerCreateUnLoggedArgs = {
  params: CustomerCreateGraphqlDto;
};


export type MutationCustomerPayInvoicesWithCashbackArgs = {
  CustomerCashbackInvoicePayDto: CustomerCashbackInvoicePayDto;
};


export type MutationCustomerRemoveLegalRepresentantArgs = {
  params: LegalRepresentativeRemoveGraphqlDto;
};


export type MutationCustomerRequestInvoiceSecondCopyArgs = {
  params: InvoiceRequestSecondCopyInput;
};


export type MutationCustomerUpdateByIdArgs = {
  id: Scalars['String']['input'];
  params: CustomerUpdateGraphqlDto;
};


export type MutationCustomerUpdateLegalRepresentantArgs = {
  params: LegalRepresentativeUpdateGraphqlDto;
};


export type MutationCustomerUserChangePasswordArgs = {
  RecoverPasswordChangeInput: CustomerUserRecoverPasswordChangeInput;
};


export type MutationCustomerUserRecoverPasswordArgs = {
  RecoverPasswordInput: CustomerUserRecoverPasswordInput;
};


export type MutationCustomerWithdrawRequestArgs = {
  CustomerWithdrawRequestInput: CustomerWithdrawRequestInputDto;
};


export type MutationDashboardHistoryInvoicesCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationDashboardHistoryInvoicesRewardsCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationDashboardInvoicesInfoCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationDashboardUnifiedCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationDeactivateContractArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationDeactivateDistributorArgs = {
  distributorId: Scalars['String']['input'];
};


export type MutationDealershipCreateArgs = {
  params: DealershipCreateDto;
};


export type MutationDealershipDeleteArgs = {
  params: DealershipDeleteDto;
};


export type MutationDealershipResolutionClasseUpdateArgs = {
  id: Scalars['String']['input'];
  params: Array<DealershipResolutionClassDto>;
};


export type MutationDealershipUpdateArgs = {
  params: DealershipUpdateDto;
};


export type MutationDeleteAffiliatePartnerUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCustomerUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDiscountTableCreateArgs = {
  params: CreateDiscountDto;
};


export type MutationDiscountTableDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDiscountTableUpdateArgs = {
  id: Scalars['String']['input'];
  params: UpdateDiscountDto;
};


export type MutationForInDeactivationContractArgs = {
  canCreateInvoices: Scalars['Boolean']['input'];
  contractId: Scalars['String']['input'];
};


export type MutationFormalizeIndicationProposalArgs = {
  indicationId: Scalars['String']['input'];
};


export type MutationGenerateNewTermOfAdhesionArgs = {
  proposalId: Scalars['String']['input'];
};


export type MutationListAllInvoicesCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationLoginAffiliatePartnerUserArgs = {
  authUserInput: AuthAffiliatePartnerUserArgs;
};


export type MutationLoginCustomerUserArgs = {
  authUserInput: AuthCustomerUserArgs;
};


export type MutationLoginUserArgs = {
  authUserInput: AuthUserArgs;
};


export type MutationLogoutCustomerUserArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationNotificationCreateArgs = {
  params: NotificationCreateDto;
};


export type MutationNotifyCustomerFinishedDocumentationArgs = {
  params: NotifyCustomerFinishedDocumentationGraphqlDto;
};


export type MutationNotifyFinishedDocumentationArgs = {
  params: ContractNotifyPartnerFinishedDocumentationGraphqlDto;
};


export type MutationOpenedOrClickedPushNotificationArgs = {
  params: Scalars['String']['input'];
};


export type MutationPartnerAffiliateUserApproveArgs = {
  id: Scalars['String']['input'];
};


export type MutationPartnerAffiliateUserRejectArgs = {
  id: Scalars['String']['input'];
  justification: Scalars['String']['input'];
};


export type MutationPartnerCreateArgs = {
  params: PartnerCreateDto;
};


export type MutationPartnerDeleteArgs = {
  params: PartnerDeleteDto;
};


export type MutationPartnerUpdateArgs = {
  params: PartnerUpdateDto;
};


export type MutationPowerGeneratorAreaLoginArgs = {
  installation: Scalars['String']['input'];
  powerPlantId: Scalars['String']['input'];
};


export type MutationPowerGeneratorCreateArgs = {
  params: PowerGeneratorCreateDto;
};


export type MutationPowerGeneratorDeleteArgs = {
  params: PowerGeneratorDeleteDto;
};


export type MutationPowerGeneratorUpdateArgs = {
  params: PowerGeneratorUpdateDto;
};


export type MutationPowerPlantCreateArgs = {
  params: PowerPlantCreateDto;
};


export type MutationPowerPlantDeleteArgs = {
  params: PowerPlantDeleteDto;
};


export type MutationPowerPlantUpdateArgs = {
  params: PowerPlantUpdateDto;
};


export type MutationProposalAddEnergyBillInfoArgs = {
  params: ProposalAddEnergyBillInfoGraphqlDto;
};


export type MutationProposalAddLegalRepresentativeArgs = {
  params: ProposalAddLegalRepresentativeGraphqlDto;
};


export type MutationProposalAddPreProposalArgs = {
  params: ProposalAddPreProposalGraphqlDto;
};


export type MutationProposalCreateArgs = {
  params: ProposalCreateGraphqlDto;
};


export type MutationProposalFilesAnalysisArgs = {
  id: Scalars['String']['input'];
  params: ProposalAnalysisFilesDto;
};


export type MutationProposalFormalizationArgs = {
  proposalId: Scalars['String']['input'];
};


export type MutationProposalRemoveLegalRepresentativeArgs = {
  params: ProposalRemoveLegalRepresentativeGraphqlDto;
};


export type MutationProposalUpdateArgs = {
  params: ProposalUpdateGraphqlDto;
};


export type MutationProposalUpdateLegalRepresentativeArgs = {
  params: ProposalUpdateLegalRepresentativeGraphqlDto;
};


export type MutationProposalUpdateManuallyTermManagementArgs = {
  params: ProposalUpdateManuallyTermManagement;
};


export type MutationProposalUpdateManuallyTermManagementApproveOrRepproveArgs = {
  params: ProposalUpdateManuallyTermManagementApproveDto;
};


export type MutationProviderInvoiceCancelArgs = {
  params: ProviderInvoiceCancelDto;
};


export type MutationProviderInvoiceChangeDueDateArgs = {
  params: ContractInvoiceChangeDueDateDto;
};


export type MutationReceivedPushNotificationArgs = {
  params: Scalars['String']['input'];
};


export type MutationReportExternalPaymentArgs = {
  params: ReportExternalPaymentDto;
};


export type MutationRequestCustomerBankDataArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationSellerCreateArgs = {
  params: SellerCreateDto;
};


export type MutationSellerDeleteArgs = {
  params: SellerDeleteDto;
};


export type MutationSellerUpdateArgs = {
  params: SellerUpdateDto;
};


export type MutationSendContractToSignArgs = {
  params: SendContractToSignDtoGraphql;
};


export type MutationSendPushNotificationArgs = {
  params: SendPushNotificationDto;
};


export type MutationSendPushNotificationAllArgs = {
  params: SendPushNotificationDto;
};


export type MutationSolveProposalCustomerPendenciesArgs = {
  params: SolveProposalCustomerPendenciesGraphqlDto;
};


export type MutationSolveProposalLegalRepresentantPendenciesArgs = {
  params: SolveProposalLegalRepresentantPendenciesGraphqlDto;
};


export type MutationUpdateAffiliatePartnerUserArgs = {
  id: Scalars['String']['input'];
  userUpdateInput: AffiliatePartnerUserUpdateInput;
};


export type MutationUpdateAffiliatePartnerUserApprovedArgs = {
  id: Scalars['String']['input'];
  userUpdateInput: AffiliatePartnerUserApprovedUpdateInput;
};


export type MutationUpdateCustomerDigitalAccountByHashArgs = {
  hash: Scalars['String']['input'];
  input: DigitalAccountUpdateDto;
};


export type MutationUpdateIndicationArgs = {
  params: UpdateIndicationPartnerDto;
};


export type MutationUpdateIndicationAddEnergyBillInfoArgs = {
  params: UpdateIndicationEnergyBillInfoDto;
};


export type MutationUpdateIndicationFilesArgs = {
  params: UpdateIndicationFilesDto;
};


export type MutationUpdateIndicationLegalRepresentativesArgs = {
  params: UpdateIndicationLegalRepresentativeGraphqlDto;
};


export type MutationUpdateInvoicesToExternalNegotiationArgs = {
  invoiceIds: Array<Scalars['String']['input']>;
};


export type MutationUpdatePartnerAreaPartnerIconeArgs = {
  partnerIcone: FileUploadInputTypeDto;
};


export type MutationUpdatePartnerAreaPartnerLogoArgs = {
  partnerLogo: FileUploadInputTypeDto;
};


export type MutationUpdatePartnerDefaultConfigurationArgs = {
  UpdatePartnerDefaultConfigurationDto: UpdatePartnerDefaultConfigurationDto;
};


export type MutationUpdatePartnerDiscountsOfferedArgs = {
  UpdatePartnerDiscountOfferedDto: UpdatePartnerDiscountOfferedDto;
};


export type MutationUpdatePartnerWebhookArgs = {
  updatePartnerWebhookDto: UpdatePartnerWebhookDto;
};


export type MutationUpdatePushNotificationsArgs = {
  isPushNotificationEnabled: Scalars['Boolean']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationUpdateSalesFunnelStageArgs = {
  params: UpdateSalesFunnelStageDto;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  userUpdateInput: UserUpdateInput;
};


export type MutationUserChangePasswordArgs = {
  RecoverPasswordChangeInput: RecoverPasswordChangeInput;
};


export type MutationUserContractChangeBenefitArgs = {
  params: ContractChangeBenefitDto;
};


export type MutationUserContractChangeSingleAccountArgs = {
  params: ContractChangeSingleAccountDto;
};


export type MutationUserContractUpdateDealershipLoginArgs = {
  params: CustomerUserContractUpdateDealershipLoginDto;
};


export type MutationUserRecoverPasswordArgs = {
  RecoverPasswordInput: RecoverPasswordInput;
};

export type NoteModel = {
  analystId: Scalars['ID']['output'];
  analystName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<BusinessProposalFileModel>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NotificationAttachmentModel = {
  fileInBase64: Scalars['String']['output'];
  mimetype?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type NotificationCreateAttachmentDto = {
  fileInBase64: Scalars['String']['input'];
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type NotificationCreateDto = {
  attachments?: InputMaybe<Array<NotificationCreateAttachmentDto>>;
  bcc?: InputMaybe<NotificationCreateToDto>;
  bccList?: InputMaybe<Array<NotificationCreateToDto>>;
  cc?: InputMaybe<NotificationCreateToDto>;
  ccList?: InputMaybe<Array<NotificationCreateToDto>>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  idempotence?: InputMaybe<Scalars['String']['input']>;
  message: NotificationCreateMessageDto;
  options?: InputMaybe<NotificationCreateOptionDto>;
  reployTo?: InputMaybe<NotificationCreateToDto>;
  subject: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  to: NotificationCreateToDto;
  toList?: InputMaybe<Array<NotificationCreateToDto>>;
};

export type NotificationCreateMessageDto = {
  html?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCreateOptionDto = {
  personalization?: InputMaybe<Array<NotificationCreatePersonalizationDto>>;
  schedulerTimeStamp?: InputMaybe<Scalars['Float']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCreatePersonalizationDataDto = {
  allMonthsReference?: InputMaybe<Scalars['String']['input']>;
  barCode?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  formatedValue?: InputMaybe<Scalars['String']['input']>;
  haveUniffyAccount?: InputMaybe<Scalars['String']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceMonth?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoicesLength?: InputMaybe<Scalars['String']['input']>;
  isEligibleCashback?: InputMaybe<Scalars['String']['input']>;
  isFirstInvoiceAndLossBenefit?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceLate?: InputMaybe<Scalars['Boolean']['input']>;
  isReducedAccountPartner?: InputMaybe<Scalars['Boolean']['input']>;
  lastMonthReference?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkSignIn?: InputMaybe<Scalars['String']['input']>;
  linkToProposal?: InputMaybe<Scalars['String']['input']>;
  listRejectData: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  monthReference?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameConsumeUnit?: InputMaybe<Scalars['String']['input']>;
  needLoginDealership?: InputMaybe<Scalars['Boolean']['input']>;
  newDueDate?: InputMaybe<Scalars['String']['input']>;
  newInvoiceValue?: InputMaybe<Scalars['String']['input']>;
  oldInvoiceAmount?: InputMaybe<Scalars['String']['input']>;
  partnerLogo?: InputMaybe<PartnerLogo>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vencimentAt?: InputMaybe<Scalars['String']['input']>;
  whatsappLink?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCreatePersonalizationDto = {
  data: NotificationCreatePersonalizationDataDto;
  email: Scalars['String']['input'];
};

export type NotificationCreateToDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  token?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationListDto = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<NotificationListSort>;
};

export type NotificationListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type NotificationMessageModel = {
  html?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NotificationModel = {
  _id: Scalars['ID']['output'];
  attachments?: Maybe<Array<NotificationAttachmentModel>>;
  bcc?: Maybe<Array<NotificationToModel>>;
  cc?: Maybe<Array<NotificationToModel>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  message: NotificationMessageModel;
  messageKey: Scalars['String']['output'];
  options?: Maybe<NotificationOptionModel>;
  reployTo?: Maybe<NotificationToModel>;
  status: Scalars['String']['output'];
  steps: NotificationStepModel;
  subject: Scalars['String']['output'];
  to: Array<NotificationToModel>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationOptionModel = {
  personalization?: Maybe<Array<NotificationPersonalizationModel>>;
  schedulerTimeStamp?: Maybe<Scalars['Float']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

export type NotificationPersonalizationDataModel = {
  name: Scalars['String']['output'];
};

export type NotificationPersonalizationModel = {
  data: NotificationPersonalizationDataModel;
  email: Scalars['String']['output'];
};

export type NotificationStepModel = {
  bounced?: Maybe<Scalars['DateTime']['output']>;
  canceled?: Maybe<Scalars['DateTime']['output']>;
  clicked?: Maybe<Scalars['DateTime']['output']>;
  delivered?: Maybe<Scalars['DateTime']['output']>;
  opened?: Maybe<Scalars['DateTime']['output']>;
  pending?: Maybe<Scalars['DateTime']['output']>;
  sended?: Maybe<Scalars['DateTime']['output']>;
  spam?: Maybe<Scalars['DateTime']['output']>;
  unsubscribed?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationToModel = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NotifyCustomerFinishedDocumentationGraphqlDto = {
  proposalId: Scalars['String']['input'];
  recipients: Array<ENotificationRecipient>;
};

export type ObservationCreateDtoGraphql = {
  _id: Scalars['String']['input'];
  fileKey?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationModel = {
  analystId: Scalars['String']['output'];
  analystName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<ContractFileModel>;
  text?: Maybe<Scalars['String']['output']>;
};

export type OwnerResModel = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PaginatedAccessControlModel = {
  data: Array<AccessControlModel>;
  meta: Meta;
};

export type PaginatedCustomerModel = {
  data: Array<CustomerModel>;
  meta: Meta;
};

export type PaginatedDigitalAccountWalletExtractModel = {
  data: Array<DigitalAccountWalletExtractResponseModel>;
  meta: Meta;
  status: Scalars['Float']['output'];
};

export type PaginatedInvoiceDigitalAccountModel = {
  data: Array<InvoiceListDigitalAccountModel>;
  meta: Meta;
};

export type PaginatedNotificationModel = {
  data: Array<NotificationModel>;
  meta: Meta;
};

export type PaginatedPowerGeneratorModel = {
  data: Array<PowerGeneratorModel>;
  meta: Meta;
};

export type PartnerAffiliateUserAccessControl = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PartnerAffiliateUserFileModel = {
  file: FileUploadModel;
  type: EAffiliatePartnerUserFileType;
};

export type PartnerAffiliateUserHistoryModel = {
  author: EAffiliatePartnerUserHistoryAuthor;
  date: Scalars['DateTime']['output'];
  event: EAffiliatePartnerUserHistoryEvent;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type PartnerAffiliateUserListDto = {
  inAccessStatus?: InputMaybe<Array<EAffiliatePartnerUserAccessStatus>>;
  inStatus?: InputMaybe<Array<EAffiliatePartnerUserStatus>>;
  nameOrEmailOrCpf?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<PartnerAffiliateUserListSort>;
};

export type PartnerAffiliateUserListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** metadados de paginação */
export type PartnerAffiliateUserMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** preposto do parceiro (visão backoffice) */
export type PartnerAffiliateUserModel = {
  _id: Scalars['ID']['output'];
  accessControlRef: PartnerAffiliateUserAccessControl;
  accessStatus: EAffiliatePartnerUserAccessStatus;
  address?: Maybe<AddressGraphqlModel>;
  captureSource?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  facebook?: Maybe<Scalars['String']['output']>;
  files: Array<PartnerAffiliateUserFileModel>;
  history: Array<PartnerAffiliateUserHistoryModel>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner: Scalars['Boolean']['output'];
  partnerRef?: Maybe<PartnerAffiliateUserPartnerRef>;
  phone?: Maybe<Scalars['String']['output']>;
  professionalHistory: Array<PartnerAffiliateUserProfessionalReferenceModel>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  status: EAffiliatePartnerUserStatus;
  type?: Maybe<EUserType>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type PartnerAffiliateUserPartnerRef = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type PartnerAffiliateUserProfessionalReferenceModel = {
  companyName?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
};

/** paginação de prepostos (backoffice) */
export type PartnerAffiliateUsersPaginateModel = {
  data: Array<PartnerAffiliateUserModel>;
  meta: PartnerAffiliateUserMetaModel;
};

export type PartnerAnticipatedCommissioningParamsSchema = {
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionExceptionGroups: Array<CommissionExceptionGroupSchema>;
  commissionedInvoices: Scalars['Float']['output'];
};

export type PartnerConfigurationCreateDto = {
  allowAffiliateLink: Scalars['Boolean']['input'];
  allowManualProposal: Scalars['Boolean']['input'];
  allowViewIndicationData?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  icone?: InputMaybe<FileUploadInputTypeDto>;
  logo?: InputMaybe<FileUploadInputTypeDto>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerConfigurationSchema = {
  allowAffiliateLink: Scalars['Boolean']['output'];
  allowManualProposal: Scalars['Boolean']['output'];
  allowViewIndicationData?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  icone?: Maybe<PartnerFileUploadModel>;
  logo?: Maybe<PartnerFileUploadModel>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type PartnerConfigurationUpdateDto = {
  allowAffiliateLink?: InputMaybe<Scalars['Boolean']['input']>;
  allowManualProposal?: InputMaybe<Scalars['Boolean']['input']>;
  allowViewIndicationData?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  icone?: InputMaybe<FileUploadInputTypeDto>;
  logo?: InputMaybe<FileUploadInputTypeDto>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerCreateDto = {
  allowFormalizeProposal: Scalars['Boolean']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  configuration: PartnerConfigurationCreateDto;
  contactPerson?: InputMaybe<ContactPersonCreateDto>;
  discountsException: Array<PartnerDiscountExceptionCreateDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partnershipConditions: PartnershipConditionsCreateDto;
  personType: EPersonType;
  phone: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  status: EPartnerStatus;
};

export type PartnerDealershipConditionsListDto = {
  locationUf?: InputMaybe<EBrazilStates>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerDealershipConditionsListSort>;
};

export type PartnerDealershipConditionsListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type PartnerDealershipConditionsMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** dealership conditions */
export type PartnerDealershipConditionsModel = {
  ceilingReferencePercentage: Scalars['Float']['output'];
  customerPFDiscountMax?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountMin?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountOffered?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountSuggested?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountMax?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountMin?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountOffered?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountSuggested?: Maybe<Scalars['Float']['output']>;
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
  uf: Scalars['String']['output'];
};

/** dealership conditions pagination */
export type PartnerDealershipConditionsPaginateModel = {
  data: Array<PartnerDealershipConditionsModel>;
  meta: PartnerDealershipConditionsMetaModel;
};

export type PartnerDeleteDto = {
  _id: Scalars['String']['input'];
};

export type PartnerDiscountExceptionCreateDto = {
  customerPFDiscountMax: Scalars['Float']['input'];
  customerPFDiscountMin: Scalars['Float']['input'];
  customerPFDiscountSuggested: Scalars['Float']['input'];
  customerPJDiscountMax: Scalars['Float']['input'];
  customerPJDiscountMin: Scalars['Float']['input'];
  customerPJDiscountSuggested: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
};

export type PartnerDiscountOfferedCreateDto = {
  customerPFDiscountOffered: Scalars['Float']['input'];
  customerPJDiscountOffered: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
  dealershipName: Scalars['String']['input'];
};

/** partner dealership discount offered */
export type PartnerDiscountOfferedModel = {
  customerPFDiscountOffered: Scalars['Float']['output'];
  customerPJDiscountOffered: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
};

export type PartnerDiscountOfferedToUpdateDto = {
  customerPFDiscountOffered: Scalars['Float']['input'];
  customerPJDiscountOffered: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
};

export type PartnerFileUploadModel = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  storageService: EStorageService;
};

export type PartnerHistorySchema = {
  action: Scalars['String']['output'];
  newData?: Maybe<Scalars['JSON']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  oldData?: Maybe<Scalars['JSON']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type PartnerInfoUserModel = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PartnerListDto = {
  nameDocumentOrPhone?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerListSort>;
};

export type PartnerListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type PartnerLogo = {
  url?: InputMaybe<Scalars['String']['input']>;
};

/** partner managers list */
export type PartnerManagerModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['String']['output']>;
};

export type PartnerManagerSchema = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['String']['output']>;
};

/** paginate metadata */
export type PartnerMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** partners */
export type PartnerModel = {
  _id: Scalars['ID']['output'];
  allowFormalizeProposal: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  configuration: PartnerConfigurationSchema;
  contactPerson?: Maybe<ContactPersonSchema>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountsException: Array<DiscountExceptionSchema>;
  discountsOffered: Array<DiscountOfferedSchema>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  history: Array<PartnerHistorySchema>;
  manager?: Maybe<PartnerManagerSchema>;
  name: Scalars['String']['output'];
  partnershipConditions?: Maybe<PartnershipConditionsSchema>;
  personType: EPersonType;
  phone: Scalars['String']['output'];
  site?: Maybe<Scalars['String']['output']>;
  status: EPartnerStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** partner pagination */
export type PartnerPaginateModel = {
  data: Array<PartnerModel>;
  meta: PartnerMetaModel;
};

export type PartnerRecurringCommissioningParamsSchema = {
  alwaysCommissionedInvoices: Scalars['Boolean']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionedInvoices?: Maybe<Scalars['Float']['output']>;
};

export type PartnerRefInputModel = {
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PartnerRefModel = {
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type PartnerUpdateDto = {
  allowFormalizeProposal?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<PartnerConfigurationUpdateDto>;
  contactPerson?: InputMaybe<ContactPersonUpdateDto>;
  discountsException?: InputMaybe<Array<PartnerDiscountExceptionCreateDto>>;
  discountsOffered?: InputMaybe<Array<PartnerDiscountOfferedCreateDto>>;
  email?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['String']['input'];
  partnershipConditions?: InputMaybe<PartnershipConditionsUpdateDto>;
  phone?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EPartnerStatus>;
};

export type PartnershipConditionsCreateDto = {
  anticipated?: InputMaybe<AnticipatedCommissioningParamsDto>;
  recurring?: InputMaybe<RecurringCommissioningParamsDto>;
};

export type PartnershipConditionsSchema = {
  anticipated?: Maybe<PartnerAnticipatedCommissioningParamsSchema>;
  recurring?: Maybe<PartnerRecurringCommissioningParamsSchema>;
};

export type PartnershipConditionsUpdateDto = {
  anticipated?: InputMaybe<AnticipatedCommissioningUpdateParamsDto>;
  recurring?: InputMaybe<RecurringCommissioningUpdateParamsDto>;
};

export type PaymentInterestAndFineValues = {
  finesPercentage: Scalars['Float']['output'];
  finesValueCents: Scalars['Float']['output'];
  interestPercentage: Scalars['Float']['output'];
  interestValueCents: Scalars['Float']['output'];
};

export type PaymentModel = {
  active: Scalars['Boolean']['output'];
  barcode: Scalars['String']['output'];
  billingType: EBillingType;
  createdAt: Scalars['DateTime']['output'];
  digitableLine: Scalars['String']['output'];
  digitalAccountId: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  hasInterestAndFine: Scalars['Boolean']['output'];
  history: Array<History>;
  interestAndFineValues: PaymentInterestAndFineValues;
  invoiceId: Scalars['ID']['output'];
  invoiceKey?: Maybe<Scalars['String']['output']>;
  isInterestAndFineWaived: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paidValue?: Maybe<Scalars['Float']['output']>;
  pixQrcode?: Maybe<Scalars['String']['output']>;
  pixText?: Maybe<Scalars['String']['output']>;
  secondCopy: Scalars['Boolean']['output'];
  splits: Array<DigitalAccountInvoiceSplitModel>;
  status: EInvoiceStatus;
  template: EInvoiceTemplate;
  unifiedInvoice: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type PowerGeneratorAreaOutput = {
  /** Generated accessToken of the user */
  accessToken: Scalars['String']['output'];
};

export type PowerGeneratorCreateDto = {
  active: Scalars['Boolean']['input'];
  isDesperta: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  representatives: Array<PowerGeneratorRepresentativeInput>;
};

export type PowerGeneratorDeleteDto = {
  _id: Scalars['String']['input'];
};

export type PowerGeneratorListDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  isDesperta?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  representatives?: InputMaybe<Array<PowerGeneratorRepresentativeInput>>;
  sort?: InputMaybe<PowerGeneratorListSort>;
};

export type PowerGeneratorListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type PowerGeneratorModel = {
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  isDesperta: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  representatives: Array<PowerGeneratorRepresentativeModel>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PowerGeneratorRepresentativeInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PowerGeneratorRepresentativeModel = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type PowerGeneratorUpdateDto = {
  _id: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  isDesperta?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  representatives?: InputMaybe<Array<PowerGeneratorRepresentativeInput>>;
};

export type PowerPlantCashbackInfoModel = {
  active: Scalars['Boolean']['output'];
};

export type PowerPlantCreateDto = {
  acceptsPF: Scalars['Boolean']['input'];
  acceptsPJ: Scalars['Boolean']['input'];
  accessKeyExtra?: InputMaybe<Scalars['String']['input']>;
  accessKeyLogin?: InputMaybe<Scalars['String']['input']>;
  accessKeyPassword?: InputMaybe<Scalars['String']['input']>;
  address: AddressGraphqlDto;
  clientNumber: Scalars['String']['input'];
  corporateName: Scalars['String']['input'];
  dealershipId: Scalars['String']['input'];
  discountConfiguration?: InputMaybe<PowerPlantDiscountConfigurationCreateDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  generatorId: Scalars['String']['input'];
  installation: Scalars['String']['input'];
  modality?: InputMaybe<EPowerPlantModality>;
  name: Scalars['String']['input'];
  observation: Scalars['String']['input'];
  operationStartDate?: InputMaybe<Scalars['String']['input']>;
  productionKwh: Scalars['Float']['input'];
  productionMwac: Scalars['Float']['input'];
};

export type PowerPlantDeleteDto = {
  _id: Scalars['String']['input'];
};

export type PowerPlantDiscountConfigurationCreateDto = {
  discount: PowerPlantDiscountPersonCreateDto;
  useDealershipDiscountPercentage: Scalars['Boolean']['input'];
};

export type PowerPlantDiscountConfigurationModel = {
  discount: PowerPlantDiscountPersonModel;
  useDealershipDiscountPercentage: Scalars['Boolean']['output'];
};

export type PowerPlantDiscountPersonCreateDto = {
  pf: Scalars['Float']['input'];
  pj: Scalars['Float']['input'];
};

export type PowerPlantDiscountPersonModel = {
  pf: Scalars['Float']['output'];
  pj: Scalars['Float']['output'];
};

export type PowerPlantListDto = {
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PowerPlantListSort>;
};

export type PowerPlantListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type PowerPlantMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** powerPlant */
export type PowerPlantModel = {
  _id: Scalars['ID']['output'];
  acceptsPF: Scalars['Boolean']['output'];
  acceptsPJ: Scalars['Boolean']['output'];
  accessKeyExtra?: Maybe<Scalars['String']['output']>;
  accessKeyLogin?: Maybe<Scalars['String']['output']>;
  accessKeyPassword?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  address?: Maybe<AddressGraphqlModel>;
  cashbackInfo?: Maybe<PowerPlantCashbackInfoModel>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  corporateName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dealershipId: Scalars['String']['output'];
  deletedAt: Scalars['DateTime']['output'];
  discountConfiguration?: Maybe<PowerPlantDiscountConfigurationModel>;
  document?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  generatorId: Scalars['String']['output'];
  installation: Scalars['String']['output'];
  isDesperta: Scalars['Boolean']['output'];
  modality?: Maybe<EPowerPlantModality>;
  name: Scalars['String']['output'];
  observation: Scalars['String']['output'];
  operationStartDate?: Maybe<Scalars['DateTime']['output']>;
  productionKwh: Scalars['Float']['output'];
  productionMwac: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** power plants pagination */
export type PowerPlantPaginateModel = {
  data: Array<PowerPlantModel>;
  meta: PowerPlantMetaModel;
};

export type PowerPlantUpdateDto = {
  _id: Scalars['String']['input'];
  acceptsPF?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsPJ?: InputMaybe<Scalars['Boolean']['input']>;
  accessKeyExtra?: InputMaybe<Scalars['String']['input']>;
  accessKeyLogin?: InputMaybe<Scalars['String']['input']>;
  accessKeyPassword?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressGraphqlDto>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  corporateName?: InputMaybe<Scalars['String']['input']>;
  discountConfiguration?: InputMaybe<PowerPlantDiscountConfigurationCreateDto>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  installation?: InputMaybe<Scalars['String']['input']>;
  modality?: InputMaybe<EPowerPlantModality>;
  name?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  operationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  productionKwh?: InputMaybe<Scalars['Float']['input']>;
  productionMwac?: InputMaybe<Scalars['Float']['input']>;
};

export type PreProposalModel = {
  averageEconomyPercentage: Scalars['Float']['output'];
  averageEnergyBillValue: Scalars['Float']['output'];
  averageMonthSavingValue: Scalars['Float']['output'];
  averageYearSavingValue: Scalars['Float']['output'];
  consumerInKwh?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
  file: BusinessProposalFileModel;
  rateWithTaxesCents?: Maybe<Scalars['Float']['output']>;
  realConsumerValueCents?: Maybe<Scalars['Float']['output']>;
  savingAmountCents?: Maybe<Scalars['Float']['output']>;
  streetLightingCents?: Maybe<Scalars['Float']['output']>;
};

export type ProposalAddEnergyBillInfoGraphqlDto = {
  AmountCents?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<AddressGraphqlDto>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<ProposalFileCreateGraphqlDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  proposalId: Scalars['String']['input'];
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ProposalAddLegalRepresentativeGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
};

export type ProposalAddPreProposalGraphqlDto = {
  proposalId: Scalars['String']['input'];
};

export type ProposalAnalysisFilesDto = {
  approve: Scalars['Boolean']['input'];
  legalRepresentativeDocument?: InputMaybe<Scalars['String']['input']>;
  types: Array<EProposalFileType>;
};

export type ProposalCashbackInfoModel = {
  active: Scalars['Boolean']['output'];
  cashbackPercentagePf: Scalars['Float']['output'];
  cashbackPercentagePj: Scalars['Float']['output'];
};

export type ProposalCreateGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  averageEnergyBillValue: Scalars['Float']['input'];
  consortiumId?: InputMaybe<Scalars['String']['input']>;
  dealershipId: Scalars['String']['input'];
  dealershipLogin?: InputMaybe<ProposalDealershipLoginDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fidelityMonths?: InputMaybe<Scalars['Float']['input']>;
  legalRepresentative?: InputMaybe<Array<CustomerLegalRepresentativeGraphqlDto>>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<EProposalOrigin>;
  personType: EPersonType;
  phone: Scalars['String']['input'];
  uf: Scalars['String']['input'];
  utmInfo?: InputMaybe<UtmInfoDtoGraphql>;
};

export type ProposalCustomerPendencies = {
  averageEnergyBillValue?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['Boolean']['input']>;
  dealershipName?: InputMaybe<Scalars['Boolean']['input']>;
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  nationality?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['Boolean']['input']>;
  uf?: InputMaybe<Scalars['Boolean']['input']>;
  zipcode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalCustomerPendenciesFields = {
  averageEnergyBillValue: CustomerPendencyFields;
  city: CustomerPendencyFields;
  dealershipName: CustomerPendencyFields;
  document: CustomerPendencyFields;
  email: CustomerPendencyFields;
  legalRepresentative: CustomerPendencyFields;
  name: CustomerPendencyFields;
  neighborhood: CustomerPendencyFields;
  nickname: CustomerPendencyFields;
  number: CustomerPendencyFields;
  phone: CustomerPendencyFields;
  state: CustomerPendencyFields;
  street: CustomerPendencyFields;
  uf: CustomerPendencyFields;
  zipcode: CustomerPendencyFields;
};

export type ProposalCustomerRefModel = {
  address?: Maybe<AddressGraphqlModel>;
  averageEnergyBillValue?: Maybe<Scalars['Float']['output']>;
  dealershipId?: Maybe<Scalars['String']['output']>;
  dealershipName?: Maybe<Scalars['String']['output']>;
  document: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasPendencies?: Maybe<Scalars['Boolean']['output']>;
  legalRepresentative?: Maybe<Array<ProposalLegalRepresentativeModel>>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  pendencies?: Maybe<ProposalCustomerPendenciesFields>;
  personType: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  uf?: Maybe<Scalars['String']['output']>;
};

export type ProposalDealershipLoginDto = {
  extraPassword?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ProposalDealershipLoginModel = {
  extraPassword?: Maybe<Scalars['String']['output']>;
  login: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type ProposalFileCreateGraphqlDto = {
  file: FileUploadInputTypeDto;
  status: EProposalFileStatus;
  type: EProposalFileType;
};

export type ProposalFileModel = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  analysedBy?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FileUploadModel>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<EProposalFileStatus>;
  type?: Maybe<EProposalFileType>;
};

export type ProposalLegalRepresentativeModel = {
  address?: Maybe<AddressGraphqlModel>;
  bank?: Maybe<BankGraphqlModel>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  files?: Maybe<Array<ProposalFileModel>>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<EMaritalStatus>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  pendencies?: Maybe<ProposalLegalRepresentativePendenciesFields>;
  phone: Scalars['String']['output'];
};

export type ProposalLegalRepresentativePendenciesFields = {
  city: CustomerPendencyFields;
  complement: CustomerPendencyFields;
  customerPjRepresentativeDocumentWithPhotoBack: CustomerPendencyFields;
  customerPjRepresentativeDocumentWithPhotoFront: CustomerPendencyFields;
  document: CustomerPendencyFields;
  email: CustomerPendencyFields;
  name: CustomerPendencyFields;
  neighborhood: CustomerPendencyFields;
  number: CustomerPendencyFields;
  phone: CustomerPendencyFields;
  state: CustomerPendencyFields;
  zipcode: CustomerPendencyFields;
};

export type ProposalLegalRepresentativesPendencies = {
  city?: InputMaybe<Scalars['Boolean']['input']>;
  complement?: InputMaybe<Scalars['Boolean']['input']>;
  customerPjRepresentativeDocumentWithPhotoBack?: InputMaybe<Scalars['Boolean']['input']>;
  customerPjRepresentativeDocumentWithPhotoFront?: InputMaybe<Scalars['Boolean']['input']>;
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  zipcode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalListDto = {
  averageEnergyBillValueMax?: InputMaybe<Scalars['Int']['input']>;
  averageEnergyBillValueMin?: InputMaybe<Scalars['Int']['input']>;
  createBy?: InputMaybe<JwtUserGraphqlDto>;
  dateRange?: InputMaybe<DateRangeGraphqlSchema>;
  hasAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  hasPendencies?: InputMaybe<Scalars['Boolean']['input']>;
  inOrigin?: InputMaybe<Array<EProposalOrigin>>;
  inPendencies?: InputMaybe<Array<EProposalFilterListPendencies>>;
  inPendenciesStatus?: InputMaybe<Array<EPendenciesStatus>>;
  inStatus?: InputMaybe<Array<EProposalStatus>>;
  nameOrDocument?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  salesFunnelInStage?: InputMaybe<Array<EStage>>;
  sort?: InputMaybe<ProposalListSort>;
};

export type ProposalListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type ProposalMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** proposal */
export type ProposalModel = {
  _id: Scalars['ID']['output'];
  businessProposals: Array<BusinessProposalModel>;
  cashbackInfo?: Maybe<ProposalCashbackInfoModel>;
  consortiumId?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  createBy?: Maybe<JwtUserGraphqlModel>;
  createdAt: Scalars['DateTime']['output'];
  customerIndicationRef?: Maybe<CustomerIndicationReferenceModel>;
  customerRef: ProposalCustomerRefModel;
  dealershipLogin?: Maybe<ProposalDealershipLoginModel>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  energyBillInfo?: Maybe<PropsoalEnergyBillInfo>;
  fidelityMonths?: Maybe<Scalars['Float']['output']>;
  files?: Maybe<Array<ProposalFileModel>>;
  hasAnalysis: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  indicationRef?: Maybe<IndicationRefModel>;
  lossReason?: Maybe<Scalars['String']['output']>;
  monthlyConsumption?: Maybe<ProposalMonthlyConsumption>;
  notes?: Maybe<Array<NoteModel>>;
  origin: EProposalOrigin;
  preProposals?: Maybe<Array<PreProposalModel>>;
  rejectedInfo?: Maybe<RejectInfoModel>;
  salesFunnel?: Maybe<SalesFunnelModel>;
  sellerRef?: Maybe<SellerRefModel>;
  status: EProposalStatus;
  supportRef?: Maybe<SellerRefModel>;
  termOfAdhesion?: Maybe<TermOfAdhesionModel>;
  updatedAt: Scalars['DateTime']['output'];
  utmInfo?: Maybe<ProposalUtmInfo>;
};

export type ProposalMonthlyConsumption = {
  april?: Maybe<Scalars['Int']['output']>;
  august?: Maybe<Scalars['Int']['output']>;
  december?: Maybe<Scalars['Int']['output']>;
  february?: Maybe<Scalars['Int']['output']>;
  january?: Maybe<Scalars['Int']['output']>;
  july?: Maybe<Scalars['Int']['output']>;
  june?: Maybe<Scalars['Int']['output']>;
  march?: Maybe<Scalars['Int']['output']>;
  may?: Maybe<Scalars['Int']['output']>;
  november?: Maybe<Scalars['Int']['output']>;
  october?: Maybe<Scalars['Int']['output']>;
  september?: Maybe<Scalars['Int']['output']>;
};

/** proposals pagination */
export type ProposalPaginateModel = {
  data: Array<ProposalModel>;
  meta: ProposalMetaModel;
};

export type ProposalRemoveLegalRepresentativeGraphqlDto = {
  document: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
};

export type ProposalSellerModel = {
  changeAt: Scalars['DateTime']['output'];
  changeBy: ESellerChangeBy;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  user?: Maybe<SellerUserModel>;
};

export type ProposalUpdateGraphqlDto = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  averageEnergyBillValue?: InputMaybe<Scalars['Float']['input']>;
  consortiumId?: InputMaybe<Scalars['String']['input']>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipLogin?: InputMaybe<ProposalDealershipLoginDto>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fidelityMonths?: InputMaybe<Scalars['Float']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<EPersonType>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sellerUserId?: InputMaybe<Scalars['String']['input']>;
  supportUserId?: InputMaybe<Scalars['String']['input']>;
  uf?: InputMaybe<Scalars['String']['input']>;
};

export type ProposalUpdateLegalRepresentativeGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  documentNumber: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['String']['input'];
};

export type ProposalUpdateManuallyTermManagement = {
  file: FilesUploadInputGraphqlDto;
  proposalId: Scalars['String']['input'];
};

export type ProposalUpdateManuallyTermManagementApproveDto = {
  approve: Scalars['Boolean']['input'];
  proposalId: Scalars['String']['input'];
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ProposalUtmInfo = {
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

export type PropsoalEnergyBillInfo = {
  AmountCents?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<AddressGraphqlModel>;
  avarageConsumption?: Maybe<Scalars['Float']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  consumerClassification?: Maybe<EConsumerUnitClassification>;
  dealershipId?: Maybe<Scalars['String']['output']>;
  dealershipName?: Maybe<Scalars['String']['output']>;
  distributionTaxes?: Maybe<Scalars['Float']['output']>;
  energyBillFile?: Maybe<ProposalFileModel>;
  energyTaxes?: Maybe<Scalars['Float']['output']>;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  installationNumber?: Maybe<Scalars['String']['output']>;
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceDueDay?: Maybe<Scalars['Float']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  tariffClassification?: Maybe<ETariffClassification>;
  tension?: Maybe<EConsumerUnitTension>;
  tusdValue?: Maybe<Scalars['Float']['output']>;
};

export type ProviderInvoiceCancelDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  reason?: InputMaybe<EInvoiceCancelReason>;
};

export type ProviderInvoiceHistoryModel = {
  action: Scalars['String']['output'];
  ocurredAt: Scalars['DateTime']['output'];
  status: EProviderInvoiceStatus;
};

/** Provider Invoices */
export type ProviderInvoiceModel = {
  _id: Scalars['ID']['output'];
  contractId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerDocument: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digitalAccountInvoiceId?: Maybe<Scalars['String']['output']>;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  history: Array<ProviderInvoiceHistoryModel>;
  installationNumber: Scalars['String']['output'];
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  provider: EProviderInvoice;
  providerData: Scalars['String']['output'];
  reference: ProviderInvoiceReferenceModel;
  status: EProviderInvoiceStatus;
  type: EProviderInvoiceType;
  updatedAt: Scalars['DateTime']['output'];
  valueCents: Scalars['Float']['output'];
};

export type ProviderInvoiceReferenceComposedModel = {
  energyCreditBalanceKwh: Scalars['Float']['output'];
  energyCreditProducedKwh: Scalars['Float']['output'];
  energyCreditUsedKwh: Scalars['Float']['output'];
  energyUsedKwh: Scalars['Float']['output'];
  valueDealershipCents: Scalars['Float']['output'];
  valueDiscountPowerPlantCents: Scalars['Float']['output'];
  valueTotalPowerPlantCents: Scalars['Float']['output'];
};

export type ProviderInvoiceReferenceModel = {
  month: Scalars['String']['output'];
  values: ProviderInvoiceReferenceComposedModel;
  year: Scalars['String']['output'];
};

export type Query = {
  accessControlGet?: Maybe<AccessControlModel>;
  accessControlList: PaginatedAccessControlModel;
  actionList: Array<Scalars['String']['output']>;
  affiliatePartnerGetMe: AffiliatePartnerUserModel;
  affiliatePartnerGetMyPartner: PartnerModel;
  affiliatePartnerUserGet: AffiliatePartnerUserModel;
  affiliatePartnerUserList: AffiliatePartnerUsersPaginateModel;
  calculateAverageConsumption: Scalars['Int']['output'];
  consortiumGet?: Maybe<ConsortiumModel>;
  consortiumList: ConsortiumPaginateModel;
  contractGet?: Maybe<ContractModel>;
  contractList: ContractPaginateModel;
  customerCalculateNewDueDateInvoiceId: InvoiceCalculateNewDueDate;
  customerGet?: Maybe<CustomerModel>;
  customerGetMe: CustomerModel;
  customerInvoicePayWithCashbackAvaliable: CustomerUseCashbackModel;
  customerList: PaginatedCustomerModel;
  customerUserGet: CustomerUserModel;
  customerUserGetMe: CustomerUserModel;
  customerUserGetMyContracts: EnrichedContractPaginateModel;
  customerUserList: CustomerUsersPaginateModel;
  dashboardsGetEmbedInfo: DashboardEmbedInfo;
  dashboardsList: Array<Dashboard>;
  dealershipGet?: Maybe<DealershipModel>;
  dealershipList: DealershipPaginateModel;
  discountTableById?: Maybe<DiscountTableDto>;
  discountTableByList: DiscountTablePaginateDto;
  fileGet: FileModel;
  fileGetByKey: FileModel;
  fileList: FilesPaginateModel;
  getAuthUser: JwtUserTokenGraphql;
  getCommissionMetrics: CommissionMetricsDto;
  getCommissions: CommissionPaginateModel;
  getCustomerInfoByHash?: Maybe<CustomerDigitalAccountInfoDto>;
  getDigitalAccountWalletExtractByCustomerId?: Maybe<PaginatedDigitalAccountWalletExtractModel>;
  getDistributors: DistributorPaginateModel;
  getIndicationById: IndicationModel;
  getIndicationMetrics: IndicationMetricsDto;
  getIndicationRelatedEntitiesById: GetIndicationRelatedEntitiesByIdResponseDto;
  getIndications: IndicationPaginateModel;
  getMyDigitalAccountBalanceCustomerUser?: Maybe<DigitalAccountBalanceModel>;
  getMyDigitalAccountWalletExtractCustomerUser?: Maybe<PaginatedDigitalAccountWalletExtractModel>;
  getPartnerAreaDashboard: EmbedInfo;
  getWalletBalanceByCustomerId?: Maybe<AccountWalletBalanceModel>;
  invoiceList: InvoicePaginateModel;
  modules: Array<ModuleDto>;
  modulesList: Array<Scalars['String']['output']>;
  notificationGet?: Maybe<NotificationModel>;
  notificationList: PaginatedNotificationModel;
  paginateDealershipConditions: PartnerDealershipConditionsPaginateModel;
  partnerAffiliateUserGet: PartnerAffiliateUserModel;
  partnerAffiliateUserList: PartnerAffiliateUsersPaginateModel;
  partnerGet?: Maybe<PartnerModel>;
  partnerGetManagers: Array<PartnerManagerModel>;
  partnerList: PartnerPaginateModel;
  powerGeneratorGet?: Maybe<PowerGeneratorModel>;
  powerGeneratorList: PaginatedPowerGeneratorModel;
  powerPlantGet?: Maybe<PowerPlantModel>;
  powerPlantList: PowerPlantPaginateModel;
  proposalGet?: Maybe<ProposalModel>;
  proposalList: ProposalPaginateModel;
  providerInvoiceSimulateDueDateChange: InvoiceSimulateDueDateChangeModel;
  reenqueueInvoicesWithUnsyncedCommissionStatus: Array<InvoiceModel>;
  sellerGet?: Maybe<SellerModel>;
  sellerList: SellerPaginateModel;
  userGet: UserModel;
  userList: UsersPaginateModel;
};


export type QueryAccessControlGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccessControlListArgs = {
  params?: InputMaybe<AccessControlListDto>;
};


export type QueryActionListArgs = {
  module?: InputMaybe<EModule>;
};


export type QueryAffiliatePartnerUserGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryAffiliatePartnerUserListArgs = {
  params?: InputMaybe<AffiliatePartnerUserPaginateArgs>;
};


export type QueryCalculateAverageConsumptionArgs = {
  params: MonthlyConsumptionDto;
};


export type QueryConsortiumGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryConsortiumListArgs = {
  params?: InputMaybe<ConsortiumListDtoGraphql>;
};


export type QueryContractGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractListArgs = {
  params?: InputMaybe<ContractListDtoGraphql>;
};


export type QueryCustomerCalculateNewDueDateInvoiceIdArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryCustomerGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerListArgs = {
  params?: InputMaybe<CustomerListGraphqlDto>;
};


export type QueryCustomerUserGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerUserGetMyContractsArgs = {
  filters: GetMyContractsGraphql;
};


export type QueryCustomerUserListArgs = {
  params?: InputMaybe<CustomerUserPaginateArgs>;
};


export type QueryDashboardsGetEmbedInfoArgs = {
  internalId: Scalars['String']['input'];
};


export type QueryDealershipGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryDealershipListArgs = {
  params?: InputMaybe<DealershipListDto>;
};


export type QueryDiscountTableByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryDiscountTableByListArgs = {
  params: DiscountTableListDto;
};


export type QueryFileGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryFileGetByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryFileListArgs = {
  params?: InputMaybe<FilePaginateArgs>;
};


export type QueryGetCommissionMetricsArgs = {
  params?: InputMaybe<CommissionMetricsArgs>;
};


export type QueryGetCommissionsArgs = {
  params?: InputMaybe<CommissionPaginateArgs>;
};


export type QueryGetCustomerInfoByHashArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetDigitalAccountWalletExtractByCustomerIdArgs = {
  customerId: Scalars['String']['input'];
  filters: FilterDigitalAccountWalletExtractGraphqlDto;
};


export type QueryGetDistributorsArgs = {
  params: DistributorListDto;
};


export type QueryGetIndicationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIndicationMetricsArgs = {
  params?: InputMaybe<IndicationPaginateArgs>;
};


export type QueryGetIndicationRelatedEntitiesByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIndicationsArgs = {
  params?: InputMaybe<IndicationPaginateArgs>;
};


export type QueryGetMyDigitalAccountWalletExtractCustomerUserArgs = {
  filters: FilterDigitalAccountWalletExtractGraphqlDto;
};


export type QueryGetWalletBalanceByCustomerIdArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryInvoiceListArgs = {
  params?: InputMaybe<InvoiceListDto>;
};


export type QueryNotificationGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationListArgs = {
  params?: InputMaybe<NotificationListDto>;
};


export type QueryPaginateDealershipConditionsArgs = {
  params?: InputMaybe<PartnerDealershipConditionsListDto>;
};


export type QueryPartnerAffiliateUserGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerAffiliateUserListArgs = {
  params?: InputMaybe<PartnerAffiliateUserListDto>;
};


export type QueryPartnerGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerListArgs = {
  params?: InputMaybe<PartnerListDto>;
};


export type QueryPowerGeneratorGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryPowerGeneratorListArgs = {
  params?: InputMaybe<PowerGeneratorListDto>;
};


export type QueryPowerPlantGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryPowerPlantListArgs = {
  params?: InputMaybe<PowerPlantListDto>;
};


export type QueryProposalGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryProposalListArgs = {
  params?: InputMaybe<ProposalListDto>;
};


export type QueryProviderInvoiceSimulateDueDateChangeArgs = {
  params: ContractInvoiceSimulateDueDateChangeDto;
};


export type QuerySellerGetArgs = {
  id: Scalars['String']['input'];
};


export type QuerySellerListArgs = {
  params?: InputMaybe<SellerListDto>;
};


export type QueryUserGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserListArgs = {
  params?: InputMaybe<UserPaginateArgs>;
};

export type RecoverPasswordChangeInput = {
  newPassword: Scalars['String']['input'];
  retypeNewPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RecoverPasswordInput = {
  email: Scalars['String']['input'];
};

/** recoverPassword */
export type RecoverPasswordModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  status: EPasswordRecoverStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userRef: UserRefModel;
};

export type RecurringCommissionResponseDto = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
};

export type RecurringCommissioningParamsDto = {
  alwaysCommissionedInvoices: Scalars['Boolean']['input'];
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionedInvoices?: InputMaybe<Scalars['Float']['input']>;
};

export type RecurringCommissioningUpdateParamsDto = {
  alwaysCommissionedInvoices: Scalars['Boolean']['input'];
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionedInvoices?: InputMaybe<Scalars['Float']['input']>;
};

export type ReferenceOrderModel = {
  month: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type RejectInfoModel = {
  reason?: Maybe<Scalars['String']['output']>;
  rejectedAt: Scalars['DateTime']['output'];
  rejectedBy: JwtUserGraphqlModel;
};

export type ReportExternalPaymentDto = {
  finesAmountCents?: InputMaybe<Scalars['Float']['input']>;
  finesAndInterestWereCharged: Scalars['Boolean']['input'];
  finesPercentage?: InputMaybe<Scalars['Float']['input']>;
  interestAmountCents?: InputMaybe<Scalars['Float']['input']>;
  interestPercentage?: InputMaybe<Scalars['Float']['input']>;
  invoiceId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paidAmountCents: Scalars['Float']['input'];
  paymentDate: Scalars['DateTime']['input'];
};

export type RewardCreateDto = {
  history: Array<RewardHistoryUpdateDto>;
  percent: Scalars['Float']['input'];
  type: ERewardType;
};

export type RewardHistoryModel = {
  description: Scalars['String']['output'];
  ocurredAt: Scalars['DateTime']['output'];
};

export type RewardHistoryUpdateDto = {
  description: Scalars['String']['input'];
  ocurredAt: Scalars['DateTime']['input'];
};

export type RewardModel = {
  history?: Maybe<Array<RewardHistoryModel>>;
  percent: Scalars['Float']['output'];
  type: ERewardType;
};

export type RewardUpdateDto = {
  history?: InputMaybe<Array<RewardHistoryUpdateDto>>;
  percent: Scalars['Float']['input'];
  type: ERewardType;
};

export type SalesFunnelBase = {
  changedBy: EChangedBy;
  date: Scalars['DateTime']['output'];
  stage: EStage;
  user?: Maybe<Scalars['String']['output']>;
};

export type SalesFunnelModel = {
  changedBy: EChangedBy;
  date: Scalars['DateTime']['output'];
  history: Array<SalesFunnelBase>;
  stage: EStage;
  user?: Maybe<Scalars['String']['output']>;
};

export type SalesmanRefInputModel = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SalesmanRefModel = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SellerCreateDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SellerDeleteDto = {
  _id: Scalars['String']['input'];
};

export type SellerListDto = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
  sort?: InputMaybe<SellerListSort>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SellerListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type SellerMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** sellers */
export type SellerModel = {
  _id: Scalars['ID']['output'];
  address?: Maybe<AddressGraphqlModel>;
  bank?: Maybe<BankGraphqlModel>;
  bankAccount: Scalars['String']['output'];
  bankAgency: Scalars['String']['output'];
  birthDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  documentNumber: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/** sellers pagination */
export type SellerPaginateModel = {
  data: Array<SellerModel>;
  meta: SellerMetaModel;
};

export type SellerRefModel = {
  changeAt: Scalars['DateTime']['output'];
  changeBy: ESellerChangeBy;
  email: Scalars['String']['output'];
  history: Array<ProposalSellerModel>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  user?: Maybe<SellerUserModel>;
};

export type SellerUpdateDto = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SellerUserModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SendContractToSignDtoGraphql = {
  contractId: Scalars['String']['input'];
};

export type SendPushNotificationDto = {
  badge?: InputMaybe<Scalars['Float']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  mutableContent?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sound?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  to: Array<SendPushNotificationTo>;
  ttl?: InputMaybe<Scalars['Float']['input']>;
  /** type of push notification */
  type: Scalars['String']['input'];
};

export type SendPushNotificationTo = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  token?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SingleAccountHitoryCustomerAreaModel = {
  active: Scalars['Boolean']['output'];
  adhesionAt?: Maybe<Scalars['DateTime']['output']>;
  adhesionBy?: Maybe<EAdhesionBySingleAccount>;
  adhesionResponsibility?: Maybe<Scalars['String']['output']>;
  ocurredAt: Scalars['DateTime']['output'];
};

export type SingleAccountHitoryModel = {
  active: Scalars['Boolean']['output'];
  adhesionAt?: Maybe<Scalars['DateTime']['output']>;
  adhesionBy?: Maybe<EAdhesionBySingleAccount>;
  adhesionResponsibility?: Maybe<Scalars['String']['output']>;
  ocurredAt: Scalars['DateTime']['output'];
};

export type SolveProposalCustomerPendenciesGraphqlDto = {
  pendencies: Array<EProposalCustomerPendencies>;
  proposalId: Scalars['String']['input'];
};

export type SolveProposalLegalRepresentantPendenciesGraphqlDto = {
  document: Scalars['String']['input'];
  pendencies: Array<EProposalLegalRepresentantPendencies>;
  proposalId: Scalars['String']['input'];
};

export type SpecialDiscountCreateDto = {
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['Float']['input'];
};

export type SpecialDiscountModel = {
  discountPercent: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
};

export type SpecialDiscountUpdateDto = {
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['Float']['input'];
};

export type TermOfAdhesionModel = {
  _id: Scalars['String']['output'];
  approveManual?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  manualOrAutomatic?: Maybe<ETermOfManagementType>;
  name: Scalars['String']['output'];
  refusedReason?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  signedDocumentUrl?: Maybe<Scalars['String']['output']>;
  signerEmail?: Maybe<Scalars['String']['output']>;
  signerUrl?: Maybe<Scalars['String']['output']>;
  signers: Array<DocumentSignerModel>;
  status: EDocumentSignStatus;
  updatedAt: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TermOfManagementCreateGraphqlDto = {
  active: Scalars['Boolean']['input'];
  canceledAt?: InputMaybe<Scalars['String']['input']>;
  canceledBy?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  documentSignId?: InputMaybe<Scalars['String']['input']>;
  file: ContractFileCreateDto;
  origin: Scalars['String']['input'];
  replaced: Scalars['Boolean']['input'];
  signatureLink: Scalars['String']['input'];
  signedAt?: InputMaybe<Scalars['String']['input']>;
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  status: ETermStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TrackOperationResModel = {
  geoLocation?: Maybe<GeoLocationResModel>;
  ip: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  owner: OwnerResModel;
};

export type UpdateDiscountDto = {
  /** Informar valor entre 0 e 100 % */
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EDiscountTableType>;
};

export type UpdateIndicationDealershipLoginDto = {
  extraPassword?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UpdateIndicationEnergyBillInfoDto = {
  AmountCents: Scalars['Float']['input'];
  address?: InputMaybe<AddressDto>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<IndicationProposalFileDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateIndicationFilesDto = {
  file: FilesUploadInputGraphqlDto;
  id: Scalars['String']['input'];
  legalRepresentativeDocument?: InputMaybe<Scalars['String']['input']>;
  type: EProposalFileType;
};

export type UpdateIndicationLegalRepresentativeFileGraphqlDto = {
  file?: InputMaybe<FilesUploadInputGraphqlDto>;
  sendAt: Scalars['DateTime']['input'];
  status?: InputMaybe<ECustomerFileStatus>;
  type?: InputMaybe<ECustomerFileType>;
};

export type UpdateIndicationLegalRepresentativeGraphqlDto = {
  id: Scalars['String']['input'];
  legalRepresentatives: Array<UpdateLegalRepresentativeIndicationDto>;
};

export type UpdateIndicationPartnerDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  averageEnergyBillValueCents?: InputMaybe<Scalars['Float']['input']>;
  customerDiscountOffered?: InputMaybe<Scalars['Float']['input']>;
  dealerShipName?: InputMaybe<Scalars['String']['input']>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipLogin?: InputMaybe<UpdateIndicationDealershipLoginDto>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  maritalStatus?: InputMaybe<EMaritalStatus>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<EPersonType>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uf?: InputMaybe<Scalars['String']['input']>;
};

/** Update invoices to externalNegotiation status error */
export type UpdateInvoiceToExternalNegotiationErrorModel = {
  error: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Update invoices to externalNegotiation status */
export type UpdateInvoiceToExternalNegotiationModel = {
  notUpdated: Array<UpdateInvoiceToExternalNegotiationErrorModel>;
  updated?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateLegalRepresentativeIndicationDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<UpdateIndicationLegalRepresentativeFileGraphqlDto>>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type UpdatePartnerDefaultConfigurationDto = {
  allowAffiliateLink: Scalars['Boolean']['input'];
  allowManualProposal: Scalars['Boolean']['input'];
};

export type UpdatePartnerDiscountOfferedDto = {
  discountOffered: PartnerDiscountOfferedToUpdateDto;
};

export type UpdatePartnerWebhookDto = {
  url: Scalars['String']['input'];
};

export type UpdateSalesFunnelStageDto = {
  lossReason?: InputMaybe<ELossReason>;
  newStage: EStage;
  proposalId: Scalars['String']['input'];
};

/** User Access control */
export type UserAccessControl = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserAccessControlGraphql = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserCreateInput = {
  /** access control id of the user */
  accessControlId: Scalars['String']['input'];
  /** access control name of the user */
  accessControlName: Scalars['String']['input'];
  /** username of the user */
  email: Scalars['String']['input'];
  /** name of the user */
  name: Scalars['String']['input'];
  /** password of the user */
  password: Scalars['String']['input'];
  /** phone of the user */
  phone: Scalars['String']['input'];
  /** status of the user */
  status: Scalars['String']['input'];
  /** type of user */
  type: Scalars['String']['input'];
  /** username of the user */
  username: Scalars['String']['input'];
};

export type UserCustomerRefModel = {
  document: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  personType: EPersonType;
  phone?: Maybe<Scalars['String']['output']>;
};

export type UserFilterArgs = {
  accessControlId?: InputMaybe<Array<Scalars['String']['input']>>;
  nameOrUsernameOrEmail?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EUserStatus>;
};

export type UserListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type UserMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** user */
export type UserModel = {
  _id: Scalars['ID']['output'];
  accessControlRef: UserAccessControl;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  status: EUserStatus;
  type?: Maybe<EUserType>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type UserPaginateArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserListSort>;
};

export type UserRefModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type UserUpdateInput = {
  /** access control id of the user */
  accessControlId?: InputMaybe<Scalars['String']['input']>;
  /** access control name of the user */
  accessControlName?: InputMaybe<Scalars['String']['input']>;
  /** username of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** name of the user */
  name?: InputMaybe<Scalars['String']['input']>;
  /** phone of the user */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** status of the user */
  status?: InputMaybe<Scalars['String']['input']>;
  /** type of user */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** users pagination */
export type UsersPaginateModel = {
  data: Array<UserModel>;
  meta: UserMetaModel;
};

export type UtmInfoDtoGraphql = {
  utm_campaign: Scalars['String']['input'];
  utm_content: Scalars['String']['input'];
  utm_medium: Scalars['String']['input'];
  utm_source: Scalars['String']['input'];
  utm_term: Scalars['String']['input'];
};

export type AccessControlCreateMutationVariables = Exact<{
  params: AccessControlCreateDto;
}>;


export type AccessControlCreateMutation = { accessControlCreate: { _id: string, name: string, active: boolean, createdAt: any, modules: Array<{ actions: Array<string>, name: string }> } };

export type AccessControlUpdateMutationVariables = Exact<{
  params: AccessControlUpdateDto;
}>;


export type AccessControlUpdateMutation = { accessControlUpdate: { _id: string, name: string, active: boolean, createdAt: any, modules: Array<{ actions: Array<string>, name: string }> } };

export type ActivateBulkContractMutationVariables = Exact<{
  contractIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ActivateBulkContractMutation = { activateBulkContract: { activated: Array<string>, notActivated: Array<{ error: string, id: string }> } };

export type ActiveContractMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ActiveContractMutation = { activateContract: { _id: string, status?: EContractStatus | null } };

export type AddNoteToProposalMutationVariables = Exact<{
  params: AddNoteGraphqlDto;
}>;


export type AddNoteToProposalMutation = { addNoteToProposal: { _id: string, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null } };

export type AnalyseLegalRepresentativeDataMutationVariables = Exact<{
  params: AnalyseLegalRepresentativeDataDto;
}>;


export type AnalyseLegalRepresentativeDataMutation = { analyseLegalRepresentativeData: { _id: string, customerRef: { legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, pendencies?: { city: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, document: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, email: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, name: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, neighborhood: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, number: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, phone: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, state: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, zipcode: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null } } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, status?: EProposalFileStatus | null, rejectedAt?: any | null, sendAt?: any | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null } } };

export type AnalyseRegistrationDataMutationVariables = Exact<{
  params: AnalyseRegistrationDataDto;
}>;


export type AnalyseRegistrationDataMutation = { analyseRegistrationData: { _id: string, customerRef: { hasPendencies?: boolean | null, pendencies?: { city: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, document: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, email: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, name: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, neighborhood: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, number: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, phone: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, state: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, street: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, zipcode: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, uf: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, averageEnergyBillValue: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, dealershipName: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null } } | null } } };

export type CancelContractMutationVariables = Exact<{
  params: CancelContractDtoGraphql;
}>;


export type CancelContractMutation = { cancelContract: { _id: string, status?: EContractStatus | null, lossReason?: EContractLossReason | null } };

export type ProviderInvoiceCancelMutationVariables = Exact<{
  params: ProviderInvoiceCancelDto;
}>;


export type ProviderInvoiceCancelMutation = { providerInvoiceCancel: { _id: string, status: EInvoiceStatus } };

export type ConsortiumCreateMutationVariables = Exact<{
  params: ConsortiumCreateDtoGraphql;
}>;


export type ConsortiumCreateMutation = { consortiumCreate: { _id: string, cnpj: string, createdAt: any, updatedAt: any, deletedAt?: any | null, email: string, fantasyName: string, leaderEmail: string, leaderName: string, name: string, phone?: string | null, status?: EConsortiumStatus | null, address: { city: string, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string, complement?: string | null }, digitalAccount?: { accountOwner?: string | null, document?: string | null, email?: string | null, feedback?: string | null, name: string, phone?: string | null, status: string, documents: Array<{ type: EDigitalAccountDocumentType, file: { fileName: string, fileUrl: string, key: string, mimeType: string, storageService: EStorageService } }>, legalRepresentative?: { document?: string | null, name: string } | null, pendencies: { account: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, address: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, addressProof: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, agency: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, balance_sheet: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, identificationBack: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, identificationFront: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, selfie: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, social_contract: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null } } } | null } };

export type ConsortiumUpdateMutationVariables = Exact<{
  params: ConsortiumUpdateDtoGraphql;
}>;


export type ConsortiumUpdateMutation = { consortiumUpdate: { _id: string, cnpj: string, createdAt: any, updatedAt: any, deletedAt?: any | null, email: string, fantasyName: string, leaderEmail: string, leaderName: string, name: string, phone?: string | null, status?: EConsortiumStatus | null, address: { city: string, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string, complement?: string | null }, digitalAccount?: { accountOwner?: string | null, document?: string | null, email?: string | null, feedback?: string | null, name: string, phone?: string | null, status: string, documents: Array<{ type: EDigitalAccountDocumentType, file: { fileName: string, fileUrl: string, key: string, mimeType: string, storageService: EStorageService } }>, legalRepresentative?: { document?: string | null, name: string } | null, pendencies: { account: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, address: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, addressProof: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, agency: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, balance_sheet: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, identificationBack: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, identificationFront: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, selfie: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, social_contract: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null } } } | null } };

export type ContractAddEnergyBillInfoMutationVariables = Exact<{
  params: ContractAddEnergyBillInfoGraphqlDto;
}>;


export type ContractAddEnergyBillInfoMutation = { contractAddEnergyBillInfo: { _id: string, previousGenerationBalance?: number | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, invoiceDueDay?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null } };

export type ContractAddObservationMutationVariables = Exact<{
  params: ObservationCreateDtoGraphql;
}>;


export type ContractAddObservationMutation = { contractAddObservation: { _id: string, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, notes?: Array<{ analystId: string, analystName: string, createdAt: any, text?: string | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null } };

export type ContractAnalyzeRegistrationDataMutationVariables = Exact<{
  params: ContractAnalyzeRegistrationDataDto;
}>;


export type ContractAnalyzeRegistrationDataMutation = { contractAnalyzeRegistrationData: { _id: string, customerRef: { pendencies?: { city: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, email: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, name: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, neighborhood: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, number: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, phone: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, state: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, street: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, zipCode: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, uf: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null } } | null } } };

export type ContractChangeFlagCanCreateInvoicesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  canCreate: Scalars['Boolean']['input'];
}>;


export type ContractChangeFlagCanCreateInvoicesMutation = { contractChangeFlagCanCreateInvoices: { _id: string, status?: EContractStatus | null, canCreateInvoices?: boolean | null } };

export type ContractChangePowerPlantMutationVariables = Exact<{
  params: ContractChangePowerPlantDto;
}>;


export type ContractChangePowerPlantMutation = { contractChangePowerPlan: { _id: string, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null } };

export type ContractCreateMutationVariables = Exact<{
  params: ContractCreateDtoGraphql;
}>;


export type ContractCreateMutation = { contractCreate: { _id: string, previousGenerationBalance?: number | null, billingType?: EBillingType | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, eligibleForCashback: boolean, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, canceledReason?: string | null, reward?: { percent: number, type: ERewardType, history?: Array<{ description: string, ocurredAt: any }> | null } | null, customerRef: { document: string, name: string, personType: EPersonType }, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null } };

export type ContractPendencyRepresentativiesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  filesParams: ContractAnalysisFilesDto;
  dataParams: ContractAnalyzeLegalRepresentativeDataDto;
}>;


export type ContractPendencyRepresentativiesMutation = { contractAnalyzeLegalRepresentativeData: { _id: string, customerRef: { legalRepresentatives?: Array<{ document: string, pendencies?: { city: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, complement: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, document: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, email: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, name: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, neighborhood: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, number: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, phone: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, state: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, zipCode: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null } } | null }> | null } }, contractFilesAnalysis: { _id: string, customerRef: { legalRepresentatives?: Array<{ document: string, files?: Array<{ acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, status: EProposalFileStatus, type: EProposalFileType, sentAt?: any | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null } } };

export type ContractRequestTermOfManagementMutationVariables = Exact<{
  contractId: Scalars['String']['input'];
}>;


export type ContractRequestTermOfManagementMutation = { contractRequestTermOfManagement?: { _id: string, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, documentSignId: string, refusedReason?: string | null, type?: ETermOfManagementType | null, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, uuid?: string | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null } | null };

export type ContractUpdateMutationVariables = Exact<{
  params: ContractUpdateDtoGraphql;
}>;


export type ContractUpdateMutation = { contractUpdate: { _id: string, previousGenerationBalance?: number | null, ownGenerationAverageKwh?: number | null, billingType?: EBillingType | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null } };

export type ContractUpdateCommercialConditionMutationVariables = Exact<{
  params: ContractUpdateCommercialCondition;
}>;


export type ContractUpdateCommercialConditionMutation = { contractUpdateCommercialCondition: { _id: string, billingType?: EBillingType | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null } };

export type ContractUpdateEnergyBillInfoMutationVariables = Exact<{
  params: ContractUpdateEnergyBillInfo;
}>;


export type ContractUpdateEnergyBillInfoMutation = { contractUpdateEnergyBillInfo: { _id: string, previousGenerationBalance?: number | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null } };

export type ContractUpdateManuallyTermManagementMutationVariables = Exact<{
  params: ContractUpdateManuallyTermManagement;
}>;


export type ContractUpdateManuallyTermManagementMutation = { contractUpdateManuallyTermManagement?: { termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, documentSignId: string, type?: ETermOfManagementType | null, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, uuid?: string | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null } | null };

export type ContractUpdateManuallyTermManagementApproveOrRepproveMutationVariables = Exact<{
  params: ContractUpdateManuallyTermManagementApproveDto;
}>;


export type ContractUpdateManuallyTermManagementApproveOrRepproveMutation = { contractUpdateManuallyTermManagementApproveOrRepprove?: { termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, documentSignId: string, type?: ETermOfManagementType | null, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, uuid?: string | null, refusedReason?: string | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null } | null };

export type CreateUserMutationVariables = Exact<{
  params: UserCreateInput;
}>;


export type CreateUserMutation = { createUser: { _id: string, name: string, status: EUserStatus, email: string, type?: EUserType | null, phone: string, createdAt: any, accessControlRef: { id: string, name: string } } };

export type CustomerAddLegalRepresentantMutationVariables = Exact<{
  params: LegalRepresentativeAddGraphqlDto;
}>;


export type CustomerAddLegalRepresentantMutation = { customerAddLegalRepresentant: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, nationality?: string | null, maritalStatus?: EMaritalStatus | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, nationality?: string | null, maritalStatus?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } };

export type CustomerCreateMutationVariables = Exact<{
  params: CustomerCreateGraphqlDto;
}>;


export type CustomerCreateMutation = { customerCreate: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, nationality?: string | null, maritalStatus?: EMaritalStatus | null, bank?: { account: string, agency: string, code: string, type: EBankAccountType } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, nationality?: string | null, maritalStatus?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } };

export type CustomerCreateDigitalAccountMutationVariables = Exact<{
  params: CustomerCreateDigitalAccountGraphqlDto;
}>;


export type CustomerCreateDigitalAccountMutation = { customerCreateDigitalAccount: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, nationality?: string | null, maritalStatus?: EMaritalStatus | null, bank?: { account: string, agency: string, code: string, type: EBankAccountType } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, nationality?: string | null, maritalStatus?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } };

export type CustomerRemoveLegalRepresentantMutationVariables = Exact<{
  params: LegalRepresentativeRemoveGraphqlDto;
}>;


export type CustomerRemoveLegalRepresentantMutation = { customerRemoveLegalRepresentant: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, nationality?: string | null, maritalStatus?: EMaritalStatus | null, bank?: { account: string, agency: string, code: string, type: EBankAccountType } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, nationality?: string | null, maritalStatus?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } };

export type CustomerUpdateByIdMutationVariables = Exact<{
  id: Scalars['String']['input'];
  params: CustomerUpdateGraphqlDto;
}>;


export type CustomerUpdateByIdMutation = { customerUpdateById: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, nationality?: string | null, maritalStatus?: EMaritalStatus | null, bank?: { account: string, agency: string, code: string, type: EBankAccountType } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, nationality?: string | null, maritalStatus?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } };

export type CustomerUpdateLegalRepresentantMutationVariables = Exact<{
  params: LegalRepresentativeUpdateGraphqlDto;
}>;


export type CustomerUpdateLegalRepresentantMutation = { customerUpdateLegalRepresentant: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, nationality?: string | null, maritalStatus?: EMaritalStatus | null, bank?: { account: string, agency: string, code: string, type: EBankAccountType } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, nationality?: string | null, maritalStatus?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } };

export type DeactivateContractMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeactivateContractMutation = { deactivateContract: { _id: string, status?: EContractStatus | null } };

export type DealershipCreateMutationVariables = Exact<{
  params: DealershipCreateDto;
}>;


export type DealershipCreateMutation = { dealershipCreate: { _id: string, needLoginDealership: boolean, name?: string | null, locationUf?: string | null, distributorId?: string | null, maxDiscountPercentagePf?: number | null, maxDiscountPercentagePj?: number | null, available: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, minimumExceptionValue?: { value: number, allowException: boolean } | null, resolutionAneel?: { linkUrl: string, modality?: EDealershipResolutionModality | null, resolutionHomologed: string, validity: string } | null, resolutionClasses: Array<{ class: EDealershipResolutuionClass, cofinsPercentage: number, fcp?: number | null, icmsPercentage: number, teValueCents: number, pisPercentage: number, tusdValueCents: number, wireBCalculationBaseValueCents?: number | null }>, partnerBenefitToCustomer: { customerPFDiscountMax?: number | null, customerPFDiscountMin?: number | null, customerPJDiscountMax?: number | null, customerPJDiscountMin?: number | null, customerPFDiscountSuggested?: number | null, customerPJDiscountSuggested?: number | null } } };

export type DealershipUpdateMutationVariables = Exact<{
  params: DealershipUpdateDto;
}>;


export type DealershipUpdateMutation = { dealershipUpdate: { _id: string, needLoginDealership: boolean, name?: string | null, locationUf?: string | null, distributorId?: string | null, maxDiscountPercentagePf?: number | null, maxDiscountPercentagePj?: number | null, available: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, minimumExceptionValue?: { value: number, allowException: boolean } | null, resolutionAneel?: { linkUrl: string, modality?: EDealershipResolutionModality | null, resolutionHomologed: string, validity: string } | null, resolutionClasses: Array<{ class: EDealershipResolutuionClass, cofinsPercentage: number, fcp?: number | null, icmsPercentage: number, teValueCents: number, pisPercentage: number, tusdValueCents: number, wireBCalculationBaseValueCents?: number | null }>, partnerBenefitToCustomer: { customerPFDiscountMax?: number | null, customerPFDiscountMin?: number | null, customerPJDiscountMax?: number | null, customerPJDiscountMin?: number | null, customerPFDiscountSuggested?: number | null, customerPJDiscountSuggested?: number | null } } };

export type DiscountTableCreateMutationVariables = Exact<{
  params: CreateDiscountDto;
}>;


export type DiscountTableCreateMutation = { discountTableCreate: { _id: string, createdAt: any, type: EDiscountTableType, code: string, updatedAt: any, discountPercentage: number } };

export type DiscountTableUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  params: UpdateDiscountDto;
}>;


export type DiscountTableUpdateMutation = { discountTableUpdate: { _id: string, createdAt: any, type: EDiscountTableType, code: string, updatedAt: any, discountPercentage: number } };

export type ForInDeactivationContractMutationVariables = Exact<{
  id: Scalars['String']['input'];
  canCreate: Scalars['Boolean']['input'];
}>;


export type ForInDeactivationContractMutation = { forInDeactivationContract: { _id: string, status?: EContractStatus | null } };

export type GenerateNewTermOfAdhesionMutationVariables = Exact<{
  proposalId: Scalars['String']['input'];
}>;


export type GenerateNewTermOfAdhesionMutation = { generateNewTermOfAdhesion: { customerRef: { personType: string }, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, refusedReason?: string | null, approveManual?: boolean | null, manualOrAutomatic?: ETermOfManagementType | null, status: EDocumentSignStatus, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null } };

export type LoginUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginUserMutation = { loginUser: { accessToken: string } };

export type NotifyCustomerFinishedDocumentationMutationVariables = Exact<{
  params: NotifyCustomerFinishedDocumentationGraphqlDto;
}>;


export type NotifyCustomerFinishedDocumentationMutation = { notifyCustomerFinishedDocumentation: { _id: string } };

export type NotifyPartnerFinishedDocumentationMutationVariables = Exact<{
  params: ContractNotifyPartnerFinishedDocumentationGraphqlDto;
}>;


export type NotifyPartnerFinishedDocumentationMutation = { notifyFinishedDocumentation: boolean };

export type PartnerAffiliateUserApproveMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PartnerAffiliateUserApproveMutation = { partnerAffiliateUserApprove: { _id: string, status: EAffiliatePartnerUserStatus, accessStatus: EAffiliatePartnerUserAccessStatus } };

export type PartnerAffiliateUserRejectMutationVariables = Exact<{
  id: Scalars['String']['input'];
  justification: Scalars['String']['input'];
}>;


export type PartnerAffiliateUserRejectMutation = { partnerAffiliateUserReject: { _id: string, status: EAffiliatePartnerUserStatus, rejectionReason?: string | null } };

export type PartnerCreateMutationVariables = Exact<{
  params: PartnerCreateDto;
}>;


export type PartnerCreateMutation = { partnerCreate: { _id: string, code?: string | null, document: string, email: string, name: string, personType: EPersonType, phone: string, site?: string | null, status: EPartnerStatus, allowFormalizeProposal: boolean, createdAt: any, updatedAt: any, manager?: { email: string, id: string, name: string, partnerId?: string | null } | null, partnershipConditions?: { anticipated?: { baseCommissionPercentage: number, commissionedInvoices: number, commissionExceptionGroups: Array<{ baseCommissionPercentage: number, commissionedInvoices: number, id: string, dealerships: Array<string> }> } | null, recurring?: { alwaysCommissionedInvoices: boolean, baseCommissionPercentage: number, commissionedInvoices?: number | null } | null } | null, contactPerson?: { email: string, name: string, phone: string } | null, discountsException: Array<{ customerPFDiscountMax: number, customerPJDiscountMax: number, customerPFDiscountMin: number, customerPJDiscountMin: number, customerPFDiscountSuggested: number, customerPJDiscountSuggested: number, dealershipId: string, dealershipName: string }>, configuration: { icone?: { fileName: string, fileUrl: string, key: string, storageService: EStorageService } | null, logo?: { fileName: string, fileUrl: string, key: string, storageService: EStorageService } | null } } };

export type PartnerUpdateMutationVariables = Exact<{
  params: PartnerUpdateDto;
}>;


export type PartnerUpdateMutation = { partnerUpdate: { _id: string, code?: string | null, document: string, email: string, name: string, personType: EPersonType, phone: string, site?: string | null, status: EPartnerStatus, allowFormalizeProposal: boolean, createdAt: any, updatedAt: any, manager?: { email: string, id: string, name: string, partnerId?: string | null } | null, partnershipConditions?: { recurring?: { alwaysCommissionedInvoices: boolean, baseCommissionPercentage: number, commissionedInvoices?: number | null } | null, anticipated?: { baseCommissionPercentage: number, commissionedInvoices: number, commissionExceptionGroups: Array<{ baseCommissionPercentage: number, commissionedInvoices: number, dealerships: Array<string>, id: string }> } | null } | null, contactPerson?: { email: string, name: string, phone: string } | null, discountsException: Array<{ customerPFDiscountMax: number, customerPJDiscountMax: number, customerPFDiscountMin: number, customerPJDiscountMin: number, customerPFDiscountSuggested: number, customerPJDiscountSuggested: number, dealershipId: string, dealershipName: string }>, configuration: { icone?: { fileName: string, fileUrl: string, key: string, storageService: EStorageService } | null, logo?: { fileName: string, fileUrl: string, key: string, storageService: EStorageService } | null } } };

export type PendencyFilesContractMutationVariables = Exact<{
  id: Scalars['String']['input'];
  params: ContractAnalysisFilesDto;
}>;


export type PendencyFilesContractMutation = { contractFilesAnalysis: { _id: string, customerRef: { legalRepresentatives?: Array<{ files?: Array<{ acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, status: EProposalFileStatus }> | null, pendencies?: { document: { acceptedAt?: any | null, analyzedBy?: string | null, sentAt?: any | null, rejectedAt?: any | null } } | null }> | null }, files?: Array<{ status: EProposalFileStatus, type: EProposalFileType, acceptedAt?: any | null, analyzedBy?: string | null, sentAt?: any | null, rejectedAt?: any | null, file?: { fileUrl: string, fileName: string } | null }> | null } };

export type PendencyFilesProposalMutationVariables = Exact<{
  id: Scalars['String']['input'];
  params: ProposalAnalysisFilesDto;
}>;


export type PendencyFilesProposalMutation = { proposalFilesAnalysis: { _id: string, customerRef: { legalRepresentative?: Array<{ files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, status?: EProposalFileStatus | null }> | null, pendencies?: { document: { acceptedAt?: any | null, analysedBy?: string | null, solvedAt?: any | null, rejectedAt?: any | null } } | null }> | null }, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, acceptedAt?: any | null, analysedBy?: string | null, sendAt?: any | null, rejectedAt?: any | null, file?: { fileUrl: string, fileName: string } | null }> | null } };

export type PendencyRepresentativiesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  filesParams: ProposalAnalysisFilesDto;
  dataParams: AnalyseLegalRepresentativeDataDto;
}>;


export type PendencyRepresentativiesMutation = { analyseLegalRepresentativeData: { _id: string, customerRef: { hasPendencies?: boolean | null, legalRepresentative?: Array<{ document: string, pendencies?: { city: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, complement: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, document: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, email: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, name: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, neighborhood: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, number: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, phone: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, state: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, zipcode: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null } } | null }> | null } }, proposalFilesAnalysis: { _id: string, customerRef: { legalRepresentative?: Array<{ document: string, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null } } };

export type PowerGeneratorCreateMutationVariables = Exact<{
  params: PowerGeneratorCreateDto;
}>;


export type PowerGeneratorCreateMutation = { powerGeneratorCreate: { _id: string, active: boolean, isDesperta: boolean, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null, representatives: Array<{ email: string, name: string, phone: string }> } };

export type PowerGeneratorUpdateMutationVariables = Exact<{
  params: PowerGeneratorUpdateDto;
}>;


export type PowerGeneratorUpdateMutation = { powerGeneratorUpdate: { _id: string, active: boolean, isDesperta: boolean, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null, representatives: Array<{ email: string, name: string, phone: string }> } };

export type PowerPlantCreateMutationVariables = Exact<{
  params: PowerPlantCreateDto;
}>;


export type PowerPlantCreateMutation = { powerPlantCreate: { _id: string, name: string, acceptsPF: boolean, acceptsPJ: boolean, dealershipId: string, installation: string, isDesperta: boolean, observation: string, productionKwh: number, productionMwac: number, createdAt: any, updatedAt: any, generatorId: string, email?: string | null, corporateName?: string | null, operationStartDate?: any | null, modality?: EPowerPlantModality | null, cashbackInfo?: { active: boolean } | null, discountConfiguration?: { useDealershipDiscountPercentage: boolean, discount: { pf: number, pj: number } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } };

export type PowerPlantUpdateMutationVariables = Exact<{
  params: PowerPlantUpdateDto;
}>;


export type PowerPlantUpdateMutation = { powerPlantUpdate: { _id: string, name: string, acceptsPF: boolean, acceptsPJ: boolean, dealershipId: string, installation: string, isDesperta: boolean, observation: string, productionKwh: number, productionMwac: number, createdAt: any, updatedAt: any, generatorId: string, email?: string | null, corporateName?: string | null, operationStartDate?: any | null, modality?: EPowerPlantModality | null, cashbackInfo?: { active: boolean } | null, discountConfiguration?: { useDealershipDiscountPercentage: boolean, discount: { pf: number, pj: number } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } };

export type ProposalAddEnergyBillInfoMutationVariables = Exact<{
  params: ProposalAddEnergyBillInfoGraphqlDto;
}>;


export type ProposalAddEnergyBillInfoMutation = { proposalAddEnergyBillInfo: { _id: string, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, invoiceDueDay?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null } };

export type ProposalAddLegalRepresentativeMutationVariables = Exact<{
  params: ProposalAddLegalRepresentativeGraphqlDto;
}>;


export type ProposalAddLegalRepresentativeMutation = { proposalAddLegalRepresentative: { _id: string, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null } };

export type ProposalCancelMutationVariables = Exact<{
  params: CancelProposalGraphqlDto;
}>;


export type ProposalCancelMutation = { cancelProposal: { _id: string, lossReason?: string | null, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, rejectedInfo?: { reason?: string | null, rejectedAt: any, rejectedBy: { id: string, name: string } } | null, salesFunnel?: { stage: EStage, changedBy: EChangedBy, date: any, user?: string | null, history: Array<{ changedBy: EChangedBy, date: any, stage: EStage, user?: string | null }> } | null, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null } };

export type ProposalCreateMutationVariables = Exact<{
  params: ProposalCreateGraphqlDto;
}>;


export type ProposalCreateMutation = { proposalCreate: { _id: string, fidelityMonths?: number | null, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, consortiumId?: string | null, sellerRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, supportRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null } };

export type ProposalFormalizationMutationVariables = Exact<{
  proposalId: Scalars['String']['input'];
}>;


export type ProposalFormalizationMutation = { proposalFormalization: { status: EProposalStatus, consortiumId?: string | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, refusedReason?: string | null, approveManual?: boolean | null, manualOrAutomatic?: ETermOfManagementType | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null } };

export type ProposalUpdateMutationVariables = Exact<{
  params: ProposalUpdateGraphqlDto;
}>;


export type ProposalUpdateMutation = { proposalUpdate: { _id: string, fidelityMonths?: number | null, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, consortiumId?: string | null, sellerRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, supportRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ linkFileToSign: string, acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string, country: string } | null } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null } };

export type ProposalUpdateLegalRepresentativeMutationVariables = Exact<{
  params: ProposalUpdateLegalRepresentativeGraphqlDto;
}>;


export type ProposalUpdateLegalRepresentativeMutation = { proposalUpdateLegalRepresentative: { _id: string, fidelityMonths?: number | null, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null } };

export type ProviderInvoiceChangeDueDateMutationVariables = Exact<{
  params: ContractInvoiceChangeDueDateDto;
}>;


export type ProviderInvoiceChangeDueDateMutation = { providerInvoiceChangeDueDate: { _id: string, createdAt: any, customerDocument: string, customerId: string, deletedAt?: any | null, digitalAccountInvoiceId?: string | null, installationNumber: string, provider: EProviderInvoice, providerData: string, status: EProviderInvoiceStatus, type: EProviderInvoiceType, updatedAt: any, valueCents: number, reference: { month: string, values: { energyCreditBalanceKwh: number, energyCreditProducedKwh: number, energyCreditUsedKwh: number, energyUsedKwh: number, valueDealershipCents: number, valueDiscountPowerPlantCents: number, valueTotalPowerPlantCents: number } } } };

export type ProposalRemoveLegalRepresentativeMutationVariables = Exact<{
  params: ProposalRemoveLegalRepresentativeGraphqlDto;
}>;


export type ProposalRemoveLegalRepresentativeMutation = { proposalRemoveLegalRepresentative: { _id: string, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null } };

export type ReportExternalPaymentMutationVariables = Exact<{
  params: ReportExternalPaymentDto;
}>;


export type ReportExternalPaymentMutation = { reportExternalPayment: boolean };

export type SendContractToSignMutationVariables = Exact<{
  params: SendContractToSignDtoGraphql;
}>;


export type SendContractToSignMutation = { sendContractToSign: { _id: string, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null } };

export type SolveProposalCustomerPendenciesMutationVariables = Exact<{
  params: SolveProposalCustomerPendenciesGraphqlDto;
}>;


export type SolveProposalCustomerPendenciesMutation = { solveProposalCustomerPendencies: { _id: string, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null } };

export type SolveProposalLegalRepresentantPendenciesMutationVariables = Exact<{
  params: SolveProposalLegalRepresentantPendenciesGraphqlDto;
}>;


export type SolveProposalLegalRepresentantPendenciesMutation = { solveProposalLegalRepresentantPendencies: { _id: string, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null } };

export type UpdateInvoicesToExternalNegotiationMutationVariables = Exact<{
  invoiceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateInvoicesToExternalNegotiationMutation = { updateInvoicesToExternalNegotiation: { updated?: Array<string> | null, notUpdated: Array<{ error: string, id: string }> } };

export type UpdateSalesFunnelStageMutationVariables = Exact<{
  params: UpdateSalesFunnelStageDto;
}>;


export type UpdateSalesFunnelStageMutation = { updateSalesFunnelStage: { _id: string, lossReason?: string | null, rejectedInfo?: { reason?: string | null, rejectedAt: any, rejectedBy: { id: string, name: string } } | null, salesFunnel?: { stage: EStage, changedBy: EChangedBy, date: any, user?: string | null, history: Array<{ changedBy: EChangedBy, date: any, stage: EStage, user?: string | null }> } | null } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  params: UserUpdateInput;
}>;


export type UpdateUserMutation = { updateUser: { _id: string, name: string, status: EUserStatus, email: string, type?: EUserType | null, phone: string, createdAt: any, accessControlRef: { id: string, name: string } } };

export type UserChangePasswordMutationVariables = Exact<{
  params: RecoverPasswordChangeInput;
}>;


export type UserChangePasswordMutation = { userChangePassword: { _id: string, userRef: { email: string } } };

export type UserRecoverPasswordMutationVariables = Exact<{
  params: RecoverPasswordInput;
}>;


export type UserRecoverPasswordMutation = { userRecoverPassword: { _id: string, userRef: { email: string } } };

export type AccessControlGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AccessControlGetQuery = { accessControlGet?: { _id: string, name: string, active: boolean, createdAt: any, modules: Array<{ actions: Array<string>, name: string }> } | null };

export type AccessControlListQueryVariables = Exact<{
  params?: InputMaybe<AccessControlListDto>;
}>;


export type AccessControlListQuery = { accessControlList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, active: boolean, name: string, createdAt: any }> } };

export type ConsortiumGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConsortiumGetQuery = { consortiumGet?: { _id: string, cnpj: string, createdAt: any, updatedAt: any, deletedAt?: any | null, email: string, fantasyName: string, leaderEmail: string, leaderName: string, name: string, phone?: string | null, status?: EConsortiumStatus | null, digitalAccount?: { accountOwner?: string | null, document?: string | null, email?: string | null, feedback?: string | null, name: string, phone?: string | null, status: string, documents: Array<{ type: EDigitalAccountDocumentType, file: { fileName: string, fileUrl: string, key: string, mimeType: string, storageService: EStorageService } }>, legalRepresentative?: { document?: string | null, name: string } | null, pendencies: { account: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, address: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, addressProof: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, agency: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, balance_sheet: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, identificationBack: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, identificationFront: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, selfie: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null }, social_contract: { approvedAt?: any | null, inAnalysisAt?: any | null, pendenciedAt?: any | null, rejectedAt?: any | null } } } | null, legalRepresentative?: { name: string, document: string } | null, bank?: { account: string, agency: string, code: string, type: EBankAccountType } | null, address: { city: string, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string, complement?: string | null } } | null };

export type ConsortiumListQueryVariables = Exact<{
  params?: InputMaybe<ConsortiumListDtoGraphql>;
}>;


export type ConsortiumListQuery = { consortiumList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, cnpj: string, status?: EConsortiumStatus | null, name: string, digitalAccount?: { status: string } | null }> } };

export type ContractGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ContractGetQuery = { contractGet?: { _id: string, canCreateInvoices?: boolean | null, ownGenerationAverageKwh?: number | null, isFormalizedByPartner: boolean, isDocumentsAudited: boolean, cancellationRequestedAt?: any | null, cancellationRequestedBy?: string | null, previousGenerationBalance?: number | null, billingType?: EBillingType | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, activatedAt?: any | null, activatedBy?: string | null, canceledReason?: string | null, notes?: Array<{ analystId: string, analystName: string, createdAt: any, text?: string | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, customerRef: { document: string, name: string, personType: EPersonType, email?: string | null, phone?: string | null, legalRepresentatives?: Array<{ document: string, email: string, name: string, phone: string, files?: Array<{ acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null, status: EProposalFileStatus, type: EProposalFileType, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null, pendencies?: { city: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, complement: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, document: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, email: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, name: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, neighborhood: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, number: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, phone: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, state: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, zipCode: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null } } | null }> | null, pendencies?: { city: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, email: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, name: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, neighborhood: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, number: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, phone: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, state: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, street: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, zipCode: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, uf: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null } } | null }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, type?: ETermOfManagementType | null, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, uuid?: string | null, refusedReason?: string | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, oldInstallationNumber?: string | null, hasNewStandardInstallationNumber?: boolean | null, installationNumberMigratedAt?: any | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null, indicationRef?: { expired?: boolean | null, id: string, type: EIndicationType, condition?: { customerDiscountMax: number, customerDiscountMin: number, customerDiscountOffered: number, customerDiscountSuggested: number, dealershipId: string, dealershipName: string, uf: string, anticipated?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionExceptionGroupId?: string | null, commissionedInvoices: number } | null, recurring?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, alwaysCommissionedInvoices: boolean, commissionedInvoices?: number | null } | null } | null, partner?: { document: string, email: string, id: string, name: string, phone: string } | null, salesman: { id: string, name: string } } | null, customerIndicationRef?: { customerId: string, customerName: string } | null, files?: Array<{ acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null, status: EProposalFileStatus, type: EProposalFileType, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } | null };

export type ContractListQueryVariables = Exact<{
  params?: InputMaybe<ContractListDtoGraphql>;
}>;


export type ContractListQuery = { contractList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, isFormalizedByPartner: boolean, origin?: EContractOrigin | null, status?: EContractStatus | null, type?: EContractType | null, energyBillInfo?: { installationNumber?: string | null, oldInstallationNumber?: string | null, hasNewStandardInstallationNumber?: boolean | null, installationNumberMigratedAt?: any | null } | null, indicationRef?: { partner?: { name: string } | null } | null, customerRef: { name: string, document: string, phone?: string | null, email?: string | null }, customerIndicationRef?: { customerId: string, customerName: string } | null }> } };

export type CustomerCalculateNewDueDateInvoiceIdQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;


export type CustomerCalculateNewDueDateInvoiceIdQuery = { customerCalculateNewDueDateInvoiceId: { invoiceId: string, newDueDateCalculated: Array<{ dueDate: any, invoiceValue: number, fineAmountCents: number, interestAmountCents: number, amountCents: number, lateDays: number }> } };

export type CustomerContractListQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerContractListQuery = { contractList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, contractedSharePercent?: number | null, status?: EContractStatus | null, reward?: { type: ERewardType, percent: number } | null }> } };

export type CustomerGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CustomerGetQuery = { customerGet?: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, nationality?: string | null, maritalStatus?: EMaritalStatus | null, digitalAccount?: { id?: string | null, name: string, status: string } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, nationality?: string | null, maritalStatus?: string | null, identificationNumber?: string | null, bank?: { code: string, type: EBankAccountType, account: string, agency: string } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null, bank?: { code: string, type: EBankAccountType, account: string, agency: string } | null } | null };

export type CustomerListQueryVariables = Exact<{
  params?: InputMaybe<CustomerListGraphqlDto>;
}>;


export type CustomerListQuery = { customerList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, name: string, email: string, phone: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType }> } };

export type CustomerListAllQueryVariables = Exact<{
  params?: InputMaybe<CustomerListGraphqlDto>;
}>;


export type CustomerListAllQuery = { customerList: { data: Array<{ _id: string, name: string, email: string, phone: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, nationality?: string | null, maritalStatus?: EMaritalStatus | null, address?: { city: string, state: string, street: string, number: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, bank?: { code: string, type: EBankAccountType, account: string, agency: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, nationality?: string | null, maritalStatus?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, street: string, number: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string } | null }> | null, bank?: { code: string, type: EBankAccountType, account: string, agency: string } | null }> | null }> } };

export type CustomerRequestInvoiceSecondCopyMutationVariables = Exact<{
  params: InvoiceRequestSecondCopyInput;
}>;


export type CustomerRequestInvoiceSecondCopyMutation = { customerRequestInvoiceSecondCopy?: { status: ECustomerStatus } | null };

export type DashboardsGetEmbedInfoQueryVariables = Exact<{
  internalId: Scalars['String']['input'];
}>;


export type DashboardsGetEmbedInfoQuery = { dashboardsGetEmbedInfo: { embedToken: string, embedUrl: string, reportId: string } };

export type DashboardsListQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardsListQuery = { dashboardsList: Array<{ name: string, internalId: string }> };

export type DealershipGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DealershipGetQuery = { dealershipGet?: { _id: string, needLoginDealership: boolean, name?: string | null, distributorId?: string | null, locationUf?: string | null, maxDiscountPercentagePf?: number | null, maxDiscountPercentagePj?: number | null, available: boolean, resolutionAneel?: { linkUrl: string, modality?: EDealershipResolutionModality | null, resolutionHomologed: string, validity: string } | null, resolutionClasses: Array<{ class: EDealershipResolutuionClass, cofinsPercentage: number, fcp?: number | null, icmsPercentage: number, pisPercentage: number, teValueCents: number, tusdValueCents: number, wireBCalculationBaseValueCents?: number | null }>, minimumExceptionValue?: { value: number, allowException: boolean } | null, partnerBenefitToCustomer: { customerPFDiscountMax?: number | null, customerPFDiscountMin?: number | null, customerPJDiscountMax?: number | null, customerPJDiscountMin?: number | null, customerPFDiscountSuggested?: number | null, customerPJDiscountSuggested?: number | null } } | null };

export type DealershipListQueryVariables = Exact<{
  params?: InputMaybe<DealershipListDto>;
}>;


export type DealershipListQuery = { dealershipList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, name?: string | null, locationUf?: string | null, maxDiscountPercentagePf?: number | null, maxDiscountPercentagePj?: number | null, available: boolean, partnerBenefitToCustomer: { customerPFDiscountMax?: number | null, customerPFDiscountMin?: number | null, customerPFDiscountSuggested?: number | null, customerPJDiscountMax?: number | null, customerPJDiscountMin?: number | null, customerPJDiscountSuggested?: number | null }, minimumExceptionValue?: { value: number, allowException: boolean } | null }> } };

export type DiscountTableByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DiscountTableByIdQuery = { discountTableById?: { _id: string, code: string, discountPercentage: number, type: EDiscountTableType, createdAt: any, updatedAt: any } | null };

export type DiscountTableByListQueryVariables = Exact<{
  params: DiscountTableListDto;
}>;


export type DiscountTableByListQuery = { discountTableByList: { data: Array<{ _id: string, code: string, discountPercentage: number, type: EDiscountTableType, createdAt: any, updatedAt: any }>, meta: { currentPage: number, documentCounts: number, pageSize: number } } };

export type GetAuthUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthUserQuery = { getAuthUser: { roles: Array<string>, user: { customerId?: string | null, email: string, id: string, name: string, partnerId?: string | null, partnerOwner?: boolean | null, phone: string, type: EUserType }, accessControlRef: { id: string, name: string } } };

export type GetDigitalAccountWalletExtractByCustomerIdQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  filters: FilterDigitalAccountWalletExtractGraphqlDto;
}>;


export type GetDigitalAccountWalletExtractByCustomerIdQuery = { getDigitalAccountWalletExtractByCustomerId?: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, balanceCents: number, status: string, valueCents: number, createdAt: string, operationType: string, description: string, metadata?: { contractId: string } | null, trackOperation?: { owner: { id: string, name: string } } | null }> } | null };

export type GetDistributorsQueryVariables = Exact<{
  params: DistributorListDto;
}>;


export type GetDistributorsQuery = { getDistributors: { data: Array<{ _id: string, name: string, active: boolean }> } };

export type GetModulesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModulesListQuery = { modules: Array<{ publicName: string, internalName: string, actions: Array<{ internalName: string, publicName: string }> }> };

export type GetWalletBalanceByCustomerIdQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetWalletBalanceByCustomerIdQuery = { getWalletBalanceByCustomerId?: { balanceCents: number } | null };

export type InvoiceListQueryVariables = Exact<{
  params?: InputMaybe<InvoiceListDto>;
}>;


export type InvoiceListQuery = { invoiceList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, status: EInvoiceStatus, createdAt: any, updatedAt: any, dueDate: any, amountCents: number, paymentType?: EInvoicePaymentType | null, contract: { id: string }, cancelInfo?: { canceledBy?: string | null, createdAt: any, description?: string | null, reason?: string | null } | null, energyBill: { reference: { month: string, year: string } }, payment: Array<{ paidAt?: any | null, paidValue?: number | null }>, customer: { name: string } }> } };

export type ModulesListQueryVariables = Exact<{ [key: string]: never; }>;


export type ModulesListQuery = { modulesList: Array<string> };

export type PartnerAffiliateUserGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PartnerAffiliateUserGetQuery = { partnerAffiliateUserGet: { _id: string, name: string, cpf?: string | null, email: string, phone?: string | null, status: EAffiliatePartnerUserStatus, accessStatus: EAffiliatePartnerUserAccessStatus, captureSource?: string | null, linkedin?: string | null, instagram?: string | null, facebook?: string | null, site?: string | null, rejectionReason?: string | null, createdAt: any, updatedAt: any, address?: { street: string, number: string, complement?: string | null, neighborhood: string, city: string, state: string, zipcode: string, country: string } | null, partnerRef?: { id: string, name: string, email: string, phone: string } | null, professionalHistory: Array<{ companyName?: string | null, segment?: string | null, role?: string | null, observation?: string | null }>, files: Array<{ type: EAffiliatePartnerUserFileType, file: { fileName: string, fileUrl: string, key: string, storageService: string } }>, history: Array<{ author: EAffiliatePartnerUserHistoryAuthor, date: any, event: EAffiliatePartnerUserHistoryEvent, userId: string, userName: string }>, accessControlRef: { id: string, name: string } } };

export type PartnerAffiliateUserListQueryVariables = Exact<{
  params?: InputMaybe<PartnerAffiliateUserListDto>;
}>;


export type PartnerAffiliateUserListQuery = { partnerAffiliateUserList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, name: string, cpf?: string | null, email: string, status: EAffiliatePartnerUserStatus, accessStatus: EAffiliatePartnerUserAccessStatus, createdAt: any, partnerRef?: { id: string, name: string } | null }> } };

export type PartnerGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PartnerGetQuery = { partnerGet?: { _id: string, code?: string | null, document: string, email: string, name: string, personType: EPersonType, phone: string, site?: string | null, status: EPartnerStatus, allowFormalizeProposal: boolean, createdAt: any, updatedAt: any, manager?: { email: string, id: string, name: string, partnerId?: string | null } | null, partnershipConditions?: { recurring?: { alwaysCommissionedInvoices: boolean, baseCommissionPercentage: number, commissionedInvoices?: number | null } | null, anticipated?: { baseCommissionPercentage: number, commissionedInvoices: number, commissionExceptionGroups: Array<{ baseCommissionPercentage: number, commissionedInvoices: number, dealerships: Array<string>, id: string }> } | null } | null, contactPerson?: { email: string, name: string, phone: string } | null, discountsException: Array<{ customerPFDiscountMax: number, customerPJDiscountMax: number, customerPFDiscountMin: number, customerPJDiscountMin: number, customerPFDiscountSuggested: number, customerPJDiscountSuggested: number, dealershipId: string, dealershipName: string }>, configuration: { icone?: { fileName: string, fileUrl: string, key: string, storageService: EStorageService } | null, logo?: { fileName: string, fileUrl: string, key: string, storageService: EStorageService } | null } } | null };

export type PartnerGetManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerGetManagersQuery = { partnerGetManagers: Array<{ email: string, id: string, name: string, partnerId?: string | null }> };

export type PartnerListQueryVariables = Exact<{
  params?: InputMaybe<PartnerListDto>;
}>;


export type PartnerListQuery = { partnerList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, name: string, phone: string, document: string, createdAt: any, updatedAt: any, status: EPartnerStatus }> } };

export type PowerGeneratorGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PowerGeneratorGetQuery = { powerGeneratorGet?: { _id: string, active: boolean, isDesperta: boolean, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null, representatives: Array<{ email: string, name: string, phone: string }> } | null };

export type PowerGeneratorListQueryVariables = Exact<{
  params?: InputMaybe<PowerGeneratorListDto>;
}>;


export type PowerGeneratorListQuery = { powerGeneratorList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, active: boolean, isDesperta: boolean, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null, representatives: Array<{ email: string, name: string, phone: string }> }> } };

export type PowerPlantGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PowerPlantGetQuery = { powerPlantGet?: { _id: string, name: string, acceptsPF: boolean, acceptsPJ: boolean, dealershipId: string, installation: string, isDesperta: boolean, observation: string, productionKwh: number, productionMwac: number, createdAt: any, updatedAt: any, generatorId: string, clientNumber?: string | null, accessKeyExtra?: string | null, accessKeyLogin?: string | null, accessKeyPassword?: string | null, modality?: EPowerPlantModality | null, document?: string | null, email?: string | null, corporateName?: string | null, operationStartDate?: any | null, discountConfiguration?: { useDealershipDiscountPercentage: boolean, discount: { pf: number, pj: number } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, cashbackInfo?: { active: boolean } | null } | null };

export type PowerPlantListQueryVariables = Exact<{
  params?: InputMaybe<PowerPlantListDto>;
}>;


export type PowerPlantListQuery = { powerPlantList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, name: string, acceptsPF: boolean, acceptsPJ: boolean, dealershipId: string, installation: string, isDesperta: boolean, observation: string, productionKwh: number, productionMwac: number, createdAt: any, updatedAt: any, generatorId: string, cashbackInfo?: { active: boolean } | null }> } };

export type ProposalGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProposalGetQuery = { proposalGet?: { _id: string, consortiumId?: string | null, contractId?: string | null, lossReason?: string | null, fidelityMonths?: number | null, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, sellerRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, supportRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, rejectedInfo?: { reason?: string | null, rejectedAt: any, rejectedBy: { id: string, name: string } } | null, salesFunnel?: { stage: EStage, changedBy: EChangedBy, date: any, user?: string | null, history: Array<{ changedBy: EChangedBy, date: any, stage: EStage, user?: string | null }> } | null, indicationRef?: { partner?: { name: string } | null } | null, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, refusedReason?: string | null, approveManual?: boolean | null, manualOrAutomatic?: ETermOfManagementType | null, status: EDocumentSignStatus, key?: string | null, url?: string | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, oldInstallationNumber?: string | null, hasNewStandardInstallationNumber?: boolean | null, installationNumberMigratedAt?: any | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null, customerIndicationRef?: { customerId: string, customerName: string } | null } | null };

export type ProposalWithDealershipsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  params?: InputMaybe<DealershipListDto>;
}>;


export type ProposalWithDealershipsQuery = { dealershipList: { data: Array<{ _id: string, locationUf?: string | null, name?: string | null }> }, proposalGet?: { _id: string, fidelityMonths?: number | null, hash: string, origin: EProposalOrigin, updatedAt: any, createdAt: any, status: EProposalStatus, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, acceptedAt?: any | null, analysedBy?: string | null, sendAt?: any | null, rejectedAt?: any | null, file?: { fileUrl: string, fileName: string } | null }> | null, rejectedInfo?: { reason?: string | null, rejectedAt: any, rejectedBy: { id: string, name: string } } | null, salesFunnel?: { stage: EStage, changedBy: EChangedBy, date: any, user?: string | null, history: Array<{ changedBy: EChangedBy, date: any, stage: EStage, user?: string | null }> } | null, indicationRef?: { partner?: { name: string } | null } | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, consumerClassification?: EConsumerUnitClassification | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { analysedBy?: string | null } | null } | null, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, customerRef: { name: string, document: string, personType: string, maritalStatus?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, uf?: string | null, averageEnergyBillValue?: number | null, dealershipId?: string | null, dealershipName?: string | null, pendencies?: { city: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, document: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, email: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, name: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, neighborhood: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, number: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, phone: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, state: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, street: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, zipcode: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, uf: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, averageEnergyBillValue: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, dealershipName: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, maritalStatus?: EMaritalStatus | null, name?: string | null, nationality?: string | null, document: string, email: string, phone: string, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, pendencies?: { city: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, complement: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, document: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, email: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, name: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, neighborhood: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, number: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, phone: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, state: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null }, zipcode: { acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, solvedAt?: any | null } } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, status?: EProposalFileStatus | null, rejectedAt?: any | null, sendAt?: any | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null } } | null };

export type ProposalListQueryVariables = Exact<{
  params: ProposalListDto;
}>;


export type ProposalListQuery = { proposalList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, consortiumId?: string | null, status: EProposalStatus, hasAnalysis: boolean, origin: EProposalOrigin, createdAt: any, updatedAt: any, sellerRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, supportRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, indicationRef?: { partner?: { name: string } | null } | null, termOfAdhesion?: { signedAt?: string | null } | null, customerRef: { name: string, document: string, personType: string, hasPendencies?: boolean | null }, createBy?: { id: string } | null, customerIndicationRef?: { customerId: string, customerName: string } | null }> } };

export type ProviderInvoiceSimulateDueDateChangeQueryVariables = Exact<{
  params: ContractInvoiceSimulateDueDateChangeDto;
}>;


export type ProviderInvoiceSimulateDueDateChangeQuery = { providerInvoiceSimulateDueDateChange: { invoiceId: string, amountCents: number, daysDifference: number, fineAmountCents: number, interestAmountCents: number, invoiceValueCents: number, isInterestAndFineWaived: boolean, lateDays: number, requestedDueDate: any, validDueDate: any } };

export type RenderPowerPlantQueryVariables = Exact<{
  powerGeneratorParams: PowerGeneratorListDto;
  dealershipParams: DealershipListDto;
}>;


export type RenderPowerPlantQuery = { powerGeneratorList: { data: Array<{ _id: string, name: string }> }, dealershipList: { data: Array<{ _id: string, name?: string | null, maxDiscountPercentagePf?: number | null, maxDiscountPercentagePj?: number | null }> } };

export type UserGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserGetQuery = { userGet: { _id: string, name: string, status: EUserStatus, email: string, type?: EUserType | null, phone: string, createdAt: any, username: string, accessControlRef: { id: string, name: string } } };

export type UserListQueryVariables = Exact<{
  params?: InputMaybe<UserPaginateArgs>;
}>;


export type UserListQuery = { userList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, name: string, status: EUserStatus, email: string, type?: EUserType | null, phone: string, createdAt: any, accessControlRef: { id: string, name: string } }> } };


export const AccessControlCreateDocument = gql`
    mutation AccessControlCreate($params: AccessControlCreateDTO!) {
  accessControlCreate(params: $params) {
    _id
    name
    active
    createdAt
    modules {
      actions
      name
    }
  }
}
    `;
export type AccessControlCreateMutationFn = Apollo.MutationFunction<AccessControlCreateMutation, AccessControlCreateMutationVariables>;

/**
 * __useAccessControlCreateMutation__
 *
 * To run a mutation, you first call `useAccessControlCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccessControlCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accessControlCreateMutation, { data, loading, error }] = useAccessControlCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAccessControlCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccessControlCreateMutation, AccessControlCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccessControlCreateMutation, AccessControlCreateMutationVariables>(AccessControlCreateDocument, options);
      }
export type AccessControlCreateMutationHookResult = ReturnType<typeof useAccessControlCreateMutation>;
export type AccessControlCreateMutationResult = Apollo.MutationResult<AccessControlCreateMutation>;
export type AccessControlCreateMutationOptions = Apollo.BaseMutationOptions<AccessControlCreateMutation, AccessControlCreateMutationVariables>;
export const AccessControlUpdateDocument = gql`
    mutation AccessControlUpdate($params: AccessControlUpdateDTO!) {
  accessControlUpdate(params: $params) {
    _id
    name
    active
    createdAt
    modules {
      actions
      name
    }
  }
}
    `;
export type AccessControlUpdateMutationFn = Apollo.MutationFunction<AccessControlUpdateMutation, AccessControlUpdateMutationVariables>;

/**
 * __useAccessControlUpdateMutation__
 *
 * To run a mutation, you first call `useAccessControlUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccessControlUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accessControlUpdateMutation, { data, loading, error }] = useAccessControlUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAccessControlUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AccessControlUpdateMutation, AccessControlUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccessControlUpdateMutation, AccessControlUpdateMutationVariables>(AccessControlUpdateDocument, options);
      }
export type AccessControlUpdateMutationHookResult = ReturnType<typeof useAccessControlUpdateMutation>;
export type AccessControlUpdateMutationResult = Apollo.MutationResult<AccessControlUpdateMutation>;
export type AccessControlUpdateMutationOptions = Apollo.BaseMutationOptions<AccessControlUpdateMutation, AccessControlUpdateMutationVariables>;
export const ActivateBulkContractDocument = gql`
    mutation ActivateBulkContract($contractIds: [String!]!) {
  activateBulkContract(contractIds: $contractIds) {
    activated
    notActivated {
      error
      id
    }
  }
}
    `;
export type ActivateBulkContractMutationFn = Apollo.MutationFunction<ActivateBulkContractMutation, ActivateBulkContractMutationVariables>;

/**
 * __useActivateBulkContractMutation__
 *
 * To run a mutation, you first call `useActivateBulkContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBulkContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBulkContractMutation, { data, loading, error }] = useActivateBulkContractMutation({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *   },
 * });
 */
export function useActivateBulkContractMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBulkContractMutation, ActivateBulkContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateBulkContractMutation, ActivateBulkContractMutationVariables>(ActivateBulkContractDocument, options);
      }
export type ActivateBulkContractMutationHookResult = ReturnType<typeof useActivateBulkContractMutation>;
export type ActivateBulkContractMutationResult = Apollo.MutationResult<ActivateBulkContractMutation>;
export type ActivateBulkContractMutationOptions = Apollo.BaseMutationOptions<ActivateBulkContractMutation, ActivateBulkContractMutationVariables>;
export const ActiveContractDocument = gql`
    mutation ActiveContract($id: String!) {
  activateContract(contractId: $id) {
    _id
    status
  }
}
    `;
export type ActiveContractMutationFn = Apollo.MutationFunction<ActiveContractMutation, ActiveContractMutationVariables>;

/**
 * __useActiveContractMutation__
 *
 * To run a mutation, you first call `useActiveContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeContractMutation, { data, loading, error }] = useActiveContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActiveContractMutation(baseOptions?: Apollo.MutationHookOptions<ActiveContractMutation, ActiveContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActiveContractMutation, ActiveContractMutationVariables>(ActiveContractDocument, options);
      }
export type ActiveContractMutationHookResult = ReturnType<typeof useActiveContractMutation>;
export type ActiveContractMutationResult = Apollo.MutationResult<ActiveContractMutation>;
export type ActiveContractMutationOptions = Apollo.BaseMutationOptions<ActiveContractMutation, ActiveContractMutationVariables>;
export const AddNoteToProposalDocument = gql`
    mutation AddNoteToProposal($params: AddNoteGraphqlDto!) {
  addNoteToProposal(params: $params) {
    _id
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type AddNoteToProposalMutationFn = Apollo.MutationFunction<AddNoteToProposalMutation, AddNoteToProposalMutationVariables>;

/**
 * __useAddNoteToProposalMutation__
 *
 * To run a mutation, you first call `useAddNoteToProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteToProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteToProposalMutation, { data, loading, error }] = useAddNoteToProposalMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAddNoteToProposalMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteToProposalMutation, AddNoteToProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteToProposalMutation, AddNoteToProposalMutationVariables>(AddNoteToProposalDocument, options);
      }
export type AddNoteToProposalMutationHookResult = ReturnType<typeof useAddNoteToProposalMutation>;
export type AddNoteToProposalMutationResult = Apollo.MutationResult<AddNoteToProposalMutation>;
export type AddNoteToProposalMutationOptions = Apollo.BaseMutationOptions<AddNoteToProposalMutation, AddNoteToProposalMutationVariables>;
export const AnalyseLegalRepresentativeDataDocument = gql`
    mutation AnalyseLegalRepresentativeData($params: AnalyseLegalRepresentativeDataDTO!) {
  analyseLegalRepresentativeData(params: $params) {
    _id
    customerRef {
      legalRepresentative {
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        pendencies {
          city {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          document {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          email {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          name {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          neighborhood {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          number {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          phone {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          state {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          zipcode {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          state {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
        }
        files {
          acceptedAt
          analysedBy
          status
          file {
            fileName
            fileUrl
            key
            storageService
          }
          rejectedAt
          sendAt
          type
        }
      }
    }
  }
}
    `;
export type AnalyseLegalRepresentativeDataMutationFn = Apollo.MutationFunction<AnalyseLegalRepresentativeDataMutation, AnalyseLegalRepresentativeDataMutationVariables>;

/**
 * __useAnalyseLegalRepresentativeDataMutation__
 *
 * To run a mutation, you first call `useAnalyseLegalRepresentativeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyseLegalRepresentativeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyseLegalRepresentativeDataMutation, { data, loading, error }] = useAnalyseLegalRepresentativeDataMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAnalyseLegalRepresentativeDataMutation(baseOptions?: Apollo.MutationHookOptions<AnalyseLegalRepresentativeDataMutation, AnalyseLegalRepresentativeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyseLegalRepresentativeDataMutation, AnalyseLegalRepresentativeDataMutationVariables>(AnalyseLegalRepresentativeDataDocument, options);
      }
export type AnalyseLegalRepresentativeDataMutationHookResult = ReturnType<typeof useAnalyseLegalRepresentativeDataMutation>;
export type AnalyseLegalRepresentativeDataMutationResult = Apollo.MutationResult<AnalyseLegalRepresentativeDataMutation>;
export type AnalyseLegalRepresentativeDataMutationOptions = Apollo.BaseMutationOptions<AnalyseLegalRepresentativeDataMutation, AnalyseLegalRepresentativeDataMutationVariables>;
export const AnalyseRegistrationDataDocument = gql`
    mutation AnalyseRegistrationData($params: AnalyseRegistrationDataDTO!) {
  analyseRegistrationData(params: $params) {
    _id
    customerRef {
      hasPendencies
      pendencies {
        city {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        document {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        email {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        name {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        neighborhood {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        number {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        phone {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        state {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        street {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        zipcode {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        uf {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        averageEnergyBillValue {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        dealershipName {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
      }
    }
  }
}
    `;
export type AnalyseRegistrationDataMutationFn = Apollo.MutationFunction<AnalyseRegistrationDataMutation, AnalyseRegistrationDataMutationVariables>;

/**
 * __useAnalyseRegistrationDataMutation__
 *
 * To run a mutation, you first call `useAnalyseRegistrationDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyseRegistrationDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyseRegistrationDataMutation, { data, loading, error }] = useAnalyseRegistrationDataMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAnalyseRegistrationDataMutation(baseOptions?: Apollo.MutationHookOptions<AnalyseRegistrationDataMutation, AnalyseRegistrationDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyseRegistrationDataMutation, AnalyseRegistrationDataMutationVariables>(AnalyseRegistrationDataDocument, options);
      }
export type AnalyseRegistrationDataMutationHookResult = ReturnType<typeof useAnalyseRegistrationDataMutation>;
export type AnalyseRegistrationDataMutationResult = Apollo.MutationResult<AnalyseRegistrationDataMutation>;
export type AnalyseRegistrationDataMutationOptions = Apollo.BaseMutationOptions<AnalyseRegistrationDataMutation, AnalyseRegistrationDataMutationVariables>;
export const CancelContractDocument = gql`
    mutation CancelContract($params: CancelContractDtoGraphql!) {
  cancelContract(params: $params) {
    _id
    status
    lossReason
  }
}
    `;
export type CancelContractMutationFn = Apollo.MutationFunction<CancelContractMutation, CancelContractMutationVariables>;

/**
 * __useCancelContractMutation__
 *
 * To run a mutation, you first call `useCancelContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelContractMutation, { data, loading, error }] = useCancelContractMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCancelContractMutation(baseOptions?: Apollo.MutationHookOptions<CancelContractMutation, CancelContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelContractMutation, CancelContractMutationVariables>(CancelContractDocument, options);
      }
export type CancelContractMutationHookResult = ReturnType<typeof useCancelContractMutation>;
export type CancelContractMutationResult = Apollo.MutationResult<CancelContractMutation>;
export type CancelContractMutationOptions = Apollo.BaseMutationOptions<CancelContractMutation, CancelContractMutationVariables>;
export const ProviderInvoiceCancelDocument = gql`
    mutation ProviderInvoiceCancel($params: ProviderInvoiceCancelDto!) {
  providerInvoiceCancel(params: $params) {
    _id
    status
  }
}
    `;
export type ProviderInvoiceCancelMutationFn = Apollo.MutationFunction<ProviderInvoiceCancelMutation, ProviderInvoiceCancelMutationVariables>;

/**
 * __useProviderInvoiceCancelMutation__
 *
 * To run a mutation, you first call `useProviderInvoiceCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderInvoiceCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerInvoiceCancelMutation, { data, loading, error }] = useProviderInvoiceCancelMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProviderInvoiceCancelMutation(baseOptions?: Apollo.MutationHookOptions<ProviderInvoiceCancelMutation, ProviderInvoiceCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderInvoiceCancelMutation, ProviderInvoiceCancelMutationVariables>(ProviderInvoiceCancelDocument, options);
      }
export type ProviderInvoiceCancelMutationHookResult = ReturnType<typeof useProviderInvoiceCancelMutation>;
export type ProviderInvoiceCancelMutationResult = Apollo.MutationResult<ProviderInvoiceCancelMutation>;
export type ProviderInvoiceCancelMutationOptions = Apollo.BaseMutationOptions<ProviderInvoiceCancelMutation, ProviderInvoiceCancelMutationVariables>;
export const ConsortiumCreateDocument = gql`
    mutation ConsortiumCreate($params: ConsortiumCreateDTOGraphql!) {
  consortiumCreate(params: $params) {
    _id
    cnpj
    createdAt
    updatedAt
    deletedAt
    email
    fantasyName
    leaderEmail
    leaderName
    name
    phone
    status
    address {
      city
      country
      neighborhood
      number
      state
      street
      zipcode
      complement
    }
    digitalAccount {
      accountOwner
      document
      documents {
        type
        file {
          fileName
          fileUrl
          key
          mimeType
          storageService
        }
      }
      email
      feedback
      legalRepresentative {
        document
        name
      }
      name
      pendencies {
        account {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        address {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        addressProof {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        agency {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        balance_sheet {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        identificationBack {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        identificationFront {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        selfie {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        social_contract {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
      }
      phone
      status
    }
  }
}
    `;
export type ConsortiumCreateMutationFn = Apollo.MutationFunction<ConsortiumCreateMutation, ConsortiumCreateMutationVariables>;

/**
 * __useConsortiumCreateMutation__
 *
 * To run a mutation, you first call `useConsortiumCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsortiumCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consortiumCreateMutation, { data, loading, error }] = useConsortiumCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useConsortiumCreateMutation(baseOptions?: Apollo.MutationHookOptions<ConsortiumCreateMutation, ConsortiumCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsortiumCreateMutation, ConsortiumCreateMutationVariables>(ConsortiumCreateDocument, options);
      }
export type ConsortiumCreateMutationHookResult = ReturnType<typeof useConsortiumCreateMutation>;
export type ConsortiumCreateMutationResult = Apollo.MutationResult<ConsortiumCreateMutation>;
export type ConsortiumCreateMutationOptions = Apollo.BaseMutationOptions<ConsortiumCreateMutation, ConsortiumCreateMutationVariables>;
export const ConsortiumUpdateDocument = gql`
    mutation ConsortiumUpdate($params: ConsortiumUpdateDTOGraphql!) {
  consortiumUpdate(params: $params) {
    _id
    cnpj
    createdAt
    updatedAt
    deletedAt
    email
    fantasyName
    leaderEmail
    leaderName
    name
    phone
    status
    address {
      city
      country
      neighborhood
      number
      state
      street
      zipcode
      complement
    }
    digitalAccount {
      accountOwner
      document
      documents {
        type
        file {
          fileName
          fileUrl
          key
          mimeType
          storageService
        }
      }
      email
      feedback
      legalRepresentative {
        document
        name
      }
      name
      pendencies {
        account {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        address {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        addressProof {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        agency {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        balance_sheet {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        identificationBack {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        identificationFront {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        selfie {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        social_contract {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
      }
      phone
      status
    }
  }
}
    `;
export type ConsortiumUpdateMutationFn = Apollo.MutationFunction<ConsortiumUpdateMutation, ConsortiumUpdateMutationVariables>;

/**
 * __useConsortiumUpdateMutation__
 *
 * To run a mutation, you first call `useConsortiumUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsortiumUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consortiumUpdateMutation, { data, loading, error }] = useConsortiumUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useConsortiumUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ConsortiumUpdateMutation, ConsortiumUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsortiumUpdateMutation, ConsortiumUpdateMutationVariables>(ConsortiumUpdateDocument, options);
      }
export type ConsortiumUpdateMutationHookResult = ReturnType<typeof useConsortiumUpdateMutation>;
export type ConsortiumUpdateMutationResult = Apollo.MutationResult<ConsortiumUpdateMutation>;
export type ConsortiumUpdateMutationOptions = Apollo.BaseMutationOptions<ConsortiumUpdateMutation, ConsortiumUpdateMutationVariables>;
export const ContractAddEnergyBillInfoDocument = gql`
    mutation ContractAddEnergyBillInfo($params: ContractAddEnergyBillInfoGraphqlDto!) {
  contractAddEnergyBillInfo(params: $params) {
    _id
    previousGenerationBalance
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      invoiceDueDay
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    canceledReason
  }
}
    `;
export type ContractAddEnergyBillInfoMutationFn = Apollo.MutationFunction<ContractAddEnergyBillInfoMutation, ContractAddEnergyBillInfoMutationVariables>;

/**
 * __useContractAddEnergyBillInfoMutation__
 *
 * To run a mutation, you first call `useContractAddEnergyBillInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractAddEnergyBillInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractAddEnergyBillInfoMutation, { data, loading, error }] = useContractAddEnergyBillInfoMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractAddEnergyBillInfoMutation(baseOptions?: Apollo.MutationHookOptions<ContractAddEnergyBillInfoMutation, ContractAddEnergyBillInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractAddEnergyBillInfoMutation, ContractAddEnergyBillInfoMutationVariables>(ContractAddEnergyBillInfoDocument, options);
      }
export type ContractAddEnergyBillInfoMutationHookResult = ReturnType<typeof useContractAddEnergyBillInfoMutation>;
export type ContractAddEnergyBillInfoMutationResult = Apollo.MutationResult<ContractAddEnergyBillInfoMutation>;
export type ContractAddEnergyBillInfoMutationOptions = Apollo.BaseMutationOptions<ContractAddEnergyBillInfoMutation, ContractAddEnergyBillInfoMutationVariables>;
export const ContractAddObservationDocument = gql`
    mutation ContractAddObservation($params: ObservationCreateDTOGraphql!) {
  contractAddObservation(params: $params) {
    _id
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    notes {
      analystId
      analystName
      createdAt
      text
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type ContractAddObservationMutationFn = Apollo.MutationFunction<ContractAddObservationMutation, ContractAddObservationMutationVariables>;

/**
 * __useContractAddObservationMutation__
 *
 * To run a mutation, you first call `useContractAddObservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractAddObservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractAddObservationMutation, { data, loading, error }] = useContractAddObservationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractAddObservationMutation(baseOptions?: Apollo.MutationHookOptions<ContractAddObservationMutation, ContractAddObservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractAddObservationMutation, ContractAddObservationMutationVariables>(ContractAddObservationDocument, options);
      }
export type ContractAddObservationMutationHookResult = ReturnType<typeof useContractAddObservationMutation>;
export type ContractAddObservationMutationResult = Apollo.MutationResult<ContractAddObservationMutation>;
export type ContractAddObservationMutationOptions = Apollo.BaseMutationOptions<ContractAddObservationMutation, ContractAddObservationMutationVariables>;
export const ContractAnalyzeRegistrationDataDocument = gql`
    mutation ContractAnalyzeRegistrationData($params: ContractAnalyzeRegistrationDataDTO!) {
  contractAnalyzeRegistrationData(params: $params) {
    _id
    customerRef {
      pendencies {
        city {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        email {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        name {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        neighborhood {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        number {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        phone {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        state {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        street {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        zipCode {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        uf {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
      }
    }
  }
}
    `;
export type ContractAnalyzeRegistrationDataMutationFn = Apollo.MutationFunction<ContractAnalyzeRegistrationDataMutation, ContractAnalyzeRegistrationDataMutationVariables>;

/**
 * __useContractAnalyzeRegistrationDataMutation__
 *
 * To run a mutation, you first call `useContractAnalyzeRegistrationDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractAnalyzeRegistrationDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractAnalyzeRegistrationDataMutation, { data, loading, error }] = useContractAnalyzeRegistrationDataMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractAnalyzeRegistrationDataMutation(baseOptions?: Apollo.MutationHookOptions<ContractAnalyzeRegistrationDataMutation, ContractAnalyzeRegistrationDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractAnalyzeRegistrationDataMutation, ContractAnalyzeRegistrationDataMutationVariables>(ContractAnalyzeRegistrationDataDocument, options);
      }
export type ContractAnalyzeRegistrationDataMutationHookResult = ReturnType<typeof useContractAnalyzeRegistrationDataMutation>;
export type ContractAnalyzeRegistrationDataMutationResult = Apollo.MutationResult<ContractAnalyzeRegistrationDataMutation>;
export type ContractAnalyzeRegistrationDataMutationOptions = Apollo.BaseMutationOptions<ContractAnalyzeRegistrationDataMutation, ContractAnalyzeRegistrationDataMutationVariables>;
export const ContractChangeFlagCanCreateInvoicesDocument = gql`
    mutation ContractChangeFlagCanCreateInvoices($id: String!, $canCreate: Boolean!) {
  contractChangeFlagCanCreateInvoices(
    contractId: $id
    canCreateInvoices: $canCreate
  ) {
    _id
    status
    canCreateInvoices
  }
}
    `;
export type ContractChangeFlagCanCreateInvoicesMutationFn = Apollo.MutationFunction<ContractChangeFlagCanCreateInvoicesMutation, ContractChangeFlagCanCreateInvoicesMutationVariables>;

/**
 * __useContractChangeFlagCanCreateInvoicesMutation__
 *
 * To run a mutation, you first call `useContractChangeFlagCanCreateInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractChangeFlagCanCreateInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractChangeFlagCanCreateInvoicesMutation, { data, loading, error }] = useContractChangeFlagCanCreateInvoicesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      canCreate: // value for 'canCreate'
 *   },
 * });
 */
export function useContractChangeFlagCanCreateInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ContractChangeFlagCanCreateInvoicesMutation, ContractChangeFlagCanCreateInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractChangeFlagCanCreateInvoicesMutation, ContractChangeFlagCanCreateInvoicesMutationVariables>(ContractChangeFlagCanCreateInvoicesDocument, options);
      }
export type ContractChangeFlagCanCreateInvoicesMutationHookResult = ReturnType<typeof useContractChangeFlagCanCreateInvoicesMutation>;
export type ContractChangeFlagCanCreateInvoicesMutationResult = Apollo.MutationResult<ContractChangeFlagCanCreateInvoicesMutation>;
export type ContractChangeFlagCanCreateInvoicesMutationOptions = Apollo.BaseMutationOptions<ContractChangeFlagCanCreateInvoicesMutation, ContractChangeFlagCanCreateInvoicesMutationVariables>;
export const ContractChangePowerPlantDocument = gql`
    mutation ContractChangePowerPlant($params: ContractChangePowerPlantDto!) {
  contractChangePowerPlan(params: $params) {
    _id
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    canceledReason
  }
}
    `;
export type ContractChangePowerPlantMutationFn = Apollo.MutationFunction<ContractChangePowerPlantMutation, ContractChangePowerPlantMutationVariables>;

/**
 * __useContractChangePowerPlantMutation__
 *
 * To run a mutation, you first call `useContractChangePowerPlantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractChangePowerPlantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractChangePowerPlantMutation, { data, loading, error }] = useContractChangePowerPlantMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractChangePowerPlantMutation(baseOptions?: Apollo.MutationHookOptions<ContractChangePowerPlantMutation, ContractChangePowerPlantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractChangePowerPlantMutation, ContractChangePowerPlantMutationVariables>(ContractChangePowerPlantDocument, options);
      }
export type ContractChangePowerPlantMutationHookResult = ReturnType<typeof useContractChangePowerPlantMutation>;
export type ContractChangePowerPlantMutationResult = Apollo.MutationResult<ContractChangePowerPlantMutation>;
export type ContractChangePowerPlantMutationOptions = Apollo.BaseMutationOptions<ContractChangePowerPlantMutation, ContractChangePowerPlantMutationVariables>;
export const ContractCreateDocument = gql`
    mutation ContractCreate($params: ContractCreateDTOGraphql!) {
  contractCreate(params: $params) {
    _id
    previousGenerationBalance
    billingType
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    eligibleForCashback
    reward {
      history {
        description
        ocurredAt
      }
      percent
      type
    }
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    canceledReason
  }
}
    `;
export type ContractCreateMutationFn = Apollo.MutationFunction<ContractCreateMutation, ContractCreateMutationVariables>;

/**
 * __useContractCreateMutation__
 *
 * To run a mutation, you first call `useContractCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractCreateMutation, { data, loading, error }] = useContractCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractCreateMutation(baseOptions?: Apollo.MutationHookOptions<ContractCreateMutation, ContractCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractCreateMutation, ContractCreateMutationVariables>(ContractCreateDocument, options);
      }
export type ContractCreateMutationHookResult = ReturnType<typeof useContractCreateMutation>;
export type ContractCreateMutationResult = Apollo.MutationResult<ContractCreateMutation>;
export type ContractCreateMutationOptions = Apollo.BaseMutationOptions<ContractCreateMutation, ContractCreateMutationVariables>;
export const ContractPendencyRepresentativiesDocument = gql`
    mutation ContractPendencyRepresentativies($id: String!, $filesParams: ContractAnalysisFilesDto!, $dataParams: ContractAnalyzeLegalRepresentativeDataDTO!) {
  contractAnalyzeLegalRepresentativeData(params: $dataParams) {
    _id
    customerRef {
      legalRepresentatives {
        document
        pendencies {
          city {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          complement {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          document {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          email {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          name {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          neighborhood {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          number {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          phone {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          state {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          zipCode {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
        }
      }
    }
  }
  contractFilesAnalysis(id: $id, params: $filesParams) {
    _id
    customerRef {
      legalRepresentatives {
        document
        files {
          acceptedAt
          analyzedBy
          rejectedAt
          status
          type
          sentAt
          file {
            fileName
            fileUrl
            key
            storageService
          }
        }
      }
    }
  }
}
    `;
export type ContractPendencyRepresentativiesMutationFn = Apollo.MutationFunction<ContractPendencyRepresentativiesMutation, ContractPendencyRepresentativiesMutationVariables>;

/**
 * __useContractPendencyRepresentativiesMutation__
 *
 * To run a mutation, you first call `useContractPendencyRepresentativiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractPendencyRepresentativiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractPendencyRepresentativiesMutation, { data, loading, error }] = useContractPendencyRepresentativiesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      filesParams: // value for 'filesParams'
 *      dataParams: // value for 'dataParams'
 *   },
 * });
 */
export function useContractPendencyRepresentativiesMutation(baseOptions?: Apollo.MutationHookOptions<ContractPendencyRepresentativiesMutation, ContractPendencyRepresentativiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractPendencyRepresentativiesMutation, ContractPendencyRepresentativiesMutationVariables>(ContractPendencyRepresentativiesDocument, options);
      }
export type ContractPendencyRepresentativiesMutationHookResult = ReturnType<typeof useContractPendencyRepresentativiesMutation>;
export type ContractPendencyRepresentativiesMutationResult = Apollo.MutationResult<ContractPendencyRepresentativiesMutation>;
export type ContractPendencyRepresentativiesMutationOptions = Apollo.BaseMutationOptions<ContractPendencyRepresentativiesMutation, ContractPendencyRepresentativiesMutationVariables>;
export const ContractRequestTermOfManagementDocument = gql`
    mutation ContractRequestTermOfManagement($contractId: String!) {
  contractRequestTermOfManagement(contractId: $contractId) {
    _id
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      documentSignId
      refusedReason
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
      uuid
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
  }
}
    `;
export type ContractRequestTermOfManagementMutationFn = Apollo.MutationFunction<ContractRequestTermOfManagementMutation, ContractRequestTermOfManagementMutationVariables>;

/**
 * __useContractRequestTermOfManagementMutation__
 *
 * To run a mutation, you first call `useContractRequestTermOfManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractRequestTermOfManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractRequestTermOfManagementMutation, { data, loading, error }] = useContractRequestTermOfManagementMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractRequestTermOfManagementMutation(baseOptions?: Apollo.MutationHookOptions<ContractRequestTermOfManagementMutation, ContractRequestTermOfManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractRequestTermOfManagementMutation, ContractRequestTermOfManagementMutationVariables>(ContractRequestTermOfManagementDocument, options);
      }
export type ContractRequestTermOfManagementMutationHookResult = ReturnType<typeof useContractRequestTermOfManagementMutation>;
export type ContractRequestTermOfManagementMutationResult = Apollo.MutationResult<ContractRequestTermOfManagementMutation>;
export type ContractRequestTermOfManagementMutationOptions = Apollo.BaseMutationOptions<ContractRequestTermOfManagementMutation, ContractRequestTermOfManagementMutationVariables>;
export const ContractUpdateDocument = gql`
    mutation ContractUpdate($params: ContractUpdateDTOGraphql!) {
  contractUpdate(params: $params) {
    _id
    previousGenerationBalance
    ownGenerationAverageKwh
    billingType
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      invoiceDueDay
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    canceledReason
    monthlyConsumption {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
  }
}
    `;
export type ContractUpdateMutationFn = Apollo.MutationFunction<ContractUpdateMutation, ContractUpdateMutationVariables>;

/**
 * __useContractUpdateMutation__
 *
 * To run a mutation, you first call `useContractUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractUpdateMutation, { data, loading, error }] = useContractUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ContractUpdateMutation, ContractUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractUpdateMutation, ContractUpdateMutationVariables>(ContractUpdateDocument, options);
      }
export type ContractUpdateMutationHookResult = ReturnType<typeof useContractUpdateMutation>;
export type ContractUpdateMutationResult = Apollo.MutationResult<ContractUpdateMutation>;
export type ContractUpdateMutationOptions = Apollo.BaseMutationOptions<ContractUpdateMutation, ContractUpdateMutationVariables>;
export const ContractUpdateCommercialConditionDocument = gql`
    mutation ContractUpdateCommercialCondition($params: ContractUpdateCommercialCondition!) {
  contractUpdateCommercialCondition(params: $params) {
    _id
    billingType
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    canceledReason
  }
}
    `;
export type ContractUpdateCommercialConditionMutationFn = Apollo.MutationFunction<ContractUpdateCommercialConditionMutation, ContractUpdateCommercialConditionMutationVariables>;

/**
 * __useContractUpdateCommercialConditionMutation__
 *
 * To run a mutation, you first call `useContractUpdateCommercialConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractUpdateCommercialConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractUpdateCommercialConditionMutation, { data, loading, error }] = useContractUpdateCommercialConditionMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractUpdateCommercialConditionMutation(baseOptions?: Apollo.MutationHookOptions<ContractUpdateCommercialConditionMutation, ContractUpdateCommercialConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractUpdateCommercialConditionMutation, ContractUpdateCommercialConditionMutationVariables>(ContractUpdateCommercialConditionDocument, options);
      }
export type ContractUpdateCommercialConditionMutationHookResult = ReturnType<typeof useContractUpdateCommercialConditionMutation>;
export type ContractUpdateCommercialConditionMutationResult = Apollo.MutationResult<ContractUpdateCommercialConditionMutation>;
export type ContractUpdateCommercialConditionMutationOptions = Apollo.BaseMutationOptions<ContractUpdateCommercialConditionMutation, ContractUpdateCommercialConditionMutationVariables>;
export const ContractUpdateEnergyBillInfoDocument = gql`
    mutation ContractUpdateEnergyBillInfo($params: ContractUpdateEnergyBillInfo!) {
  contractUpdateEnergyBillInfo(params: $params) {
    _id
    previousGenerationBalance
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      invoiceDueDay
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    canceledReason
  }
}
    `;
export type ContractUpdateEnergyBillInfoMutationFn = Apollo.MutationFunction<ContractUpdateEnergyBillInfoMutation, ContractUpdateEnergyBillInfoMutationVariables>;

/**
 * __useContractUpdateEnergyBillInfoMutation__
 *
 * To run a mutation, you first call `useContractUpdateEnergyBillInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractUpdateEnergyBillInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractUpdateEnergyBillInfoMutation, { data, loading, error }] = useContractUpdateEnergyBillInfoMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractUpdateEnergyBillInfoMutation(baseOptions?: Apollo.MutationHookOptions<ContractUpdateEnergyBillInfoMutation, ContractUpdateEnergyBillInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractUpdateEnergyBillInfoMutation, ContractUpdateEnergyBillInfoMutationVariables>(ContractUpdateEnergyBillInfoDocument, options);
      }
export type ContractUpdateEnergyBillInfoMutationHookResult = ReturnType<typeof useContractUpdateEnergyBillInfoMutation>;
export type ContractUpdateEnergyBillInfoMutationResult = Apollo.MutationResult<ContractUpdateEnergyBillInfoMutation>;
export type ContractUpdateEnergyBillInfoMutationOptions = Apollo.BaseMutationOptions<ContractUpdateEnergyBillInfoMutation, ContractUpdateEnergyBillInfoMutationVariables>;
export const ContractUpdateManuallyTermManagementDocument = gql`
    mutation ContractUpdateManuallyTermManagement($params: ContractUpdateManuallyTermManagement!) {
  contractUpdateManuallyTermManagement(params: $params) {
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      documentSignId
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
      uuid
    }
  }
}
    `;
export type ContractUpdateManuallyTermManagementMutationFn = Apollo.MutationFunction<ContractUpdateManuallyTermManagementMutation, ContractUpdateManuallyTermManagementMutationVariables>;

/**
 * __useContractUpdateManuallyTermManagementMutation__
 *
 * To run a mutation, you first call `useContractUpdateManuallyTermManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractUpdateManuallyTermManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractUpdateManuallyTermManagementMutation, { data, loading, error }] = useContractUpdateManuallyTermManagementMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractUpdateManuallyTermManagementMutation(baseOptions?: Apollo.MutationHookOptions<ContractUpdateManuallyTermManagementMutation, ContractUpdateManuallyTermManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractUpdateManuallyTermManagementMutation, ContractUpdateManuallyTermManagementMutationVariables>(ContractUpdateManuallyTermManagementDocument, options);
      }
export type ContractUpdateManuallyTermManagementMutationHookResult = ReturnType<typeof useContractUpdateManuallyTermManagementMutation>;
export type ContractUpdateManuallyTermManagementMutationResult = Apollo.MutationResult<ContractUpdateManuallyTermManagementMutation>;
export type ContractUpdateManuallyTermManagementMutationOptions = Apollo.BaseMutationOptions<ContractUpdateManuallyTermManagementMutation, ContractUpdateManuallyTermManagementMutationVariables>;
export const ContractUpdateManuallyTermManagementApproveOrRepproveDocument = gql`
    mutation ContractUpdateManuallyTermManagementApproveOrRepprove($params: ContractUpdateManuallyTermManagementApproveDto!) {
  contractUpdateManuallyTermManagementApproveOrRepprove(params: $params) {
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      documentSignId
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
      uuid
      refusedReason
    }
  }
}
    `;
export type ContractUpdateManuallyTermManagementApproveOrRepproveMutationFn = Apollo.MutationFunction<ContractUpdateManuallyTermManagementApproveOrRepproveMutation, ContractUpdateManuallyTermManagementApproveOrRepproveMutationVariables>;

/**
 * __useContractUpdateManuallyTermManagementApproveOrRepproveMutation__
 *
 * To run a mutation, you first call `useContractUpdateManuallyTermManagementApproveOrRepproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractUpdateManuallyTermManagementApproveOrRepproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractUpdateManuallyTermManagementApproveOrRepproveMutation, { data, loading, error }] = useContractUpdateManuallyTermManagementApproveOrRepproveMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractUpdateManuallyTermManagementApproveOrRepproveMutation(baseOptions?: Apollo.MutationHookOptions<ContractUpdateManuallyTermManagementApproveOrRepproveMutation, ContractUpdateManuallyTermManagementApproveOrRepproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractUpdateManuallyTermManagementApproveOrRepproveMutation, ContractUpdateManuallyTermManagementApproveOrRepproveMutationVariables>(ContractUpdateManuallyTermManagementApproveOrRepproveDocument, options);
      }
export type ContractUpdateManuallyTermManagementApproveOrRepproveMutationHookResult = ReturnType<typeof useContractUpdateManuallyTermManagementApproveOrRepproveMutation>;
export type ContractUpdateManuallyTermManagementApproveOrRepproveMutationResult = Apollo.MutationResult<ContractUpdateManuallyTermManagementApproveOrRepproveMutation>;
export type ContractUpdateManuallyTermManagementApproveOrRepproveMutationOptions = Apollo.BaseMutationOptions<ContractUpdateManuallyTermManagementApproveOrRepproveMutation, ContractUpdateManuallyTermManagementApproveOrRepproveMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($params: UserCreateInput!) {
  createUser(userCreateInput: $params) {
    _id
    name
    status
    email
    type
    phone
    createdAt
    accessControlRef {
      id
      name
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CustomerAddLegalRepresentantDocument = gql`
    mutation CustomerAddLegalRepresentant($params: LegalRepresentativeAddGraphqlDto!) {
  customerAddLegalRepresentant(params: $params) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    nationality
    maritalStatus
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      nationality
      maritalStatus
      identificationNumber
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type CustomerAddLegalRepresentantMutationFn = Apollo.MutationFunction<CustomerAddLegalRepresentantMutation, CustomerAddLegalRepresentantMutationVariables>;

/**
 * __useCustomerAddLegalRepresentantMutation__
 *
 * To run a mutation, you first call `useCustomerAddLegalRepresentantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerAddLegalRepresentantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerAddLegalRepresentantMutation, { data, loading, error }] = useCustomerAddLegalRepresentantMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerAddLegalRepresentantMutation(baseOptions?: Apollo.MutationHookOptions<CustomerAddLegalRepresentantMutation, CustomerAddLegalRepresentantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerAddLegalRepresentantMutation, CustomerAddLegalRepresentantMutationVariables>(CustomerAddLegalRepresentantDocument, options);
      }
export type CustomerAddLegalRepresentantMutationHookResult = ReturnType<typeof useCustomerAddLegalRepresentantMutation>;
export type CustomerAddLegalRepresentantMutationResult = Apollo.MutationResult<CustomerAddLegalRepresentantMutation>;
export type CustomerAddLegalRepresentantMutationOptions = Apollo.BaseMutationOptions<CustomerAddLegalRepresentantMutation, CustomerAddLegalRepresentantMutationVariables>;
export const CustomerCreateDocument = gql`
    mutation CustomerCreate($params: CustomerCreateGraphqlDto!) {
  customerCreate(params: $params) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    nationality
    maritalStatus
    bank {
      account
      agency
      code
      type
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      nationality
      maritalStatus
      identificationNumber
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type CustomerCreateMutationFn = Apollo.MutationFunction<CustomerCreateMutation, CustomerCreateMutationVariables>;

/**
 * __useCustomerCreateMutation__
 *
 * To run a mutation, you first call `useCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCreateMutation, { data, loading, error }] = useCustomerCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerCreateMutation(baseOptions?: Apollo.MutationHookOptions<CustomerCreateMutation, CustomerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerCreateMutation, CustomerCreateMutationVariables>(CustomerCreateDocument, options);
      }
export type CustomerCreateMutationHookResult = ReturnType<typeof useCustomerCreateMutation>;
export type CustomerCreateMutationResult = Apollo.MutationResult<CustomerCreateMutation>;
export type CustomerCreateMutationOptions = Apollo.BaseMutationOptions<CustomerCreateMutation, CustomerCreateMutationVariables>;
export const CustomerCreateDigitalAccountDocument = gql`
    mutation CustomerCreateDigitalAccount($params: CustomerCreateDigitalAccountGraphqlDTO!) {
  customerCreateDigitalAccount(params: $params) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    nationality
    maritalStatus
    bank {
      account
      agency
      code
      type
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      nationality
      maritalStatus
      identificationNumber
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type CustomerCreateDigitalAccountMutationFn = Apollo.MutationFunction<CustomerCreateDigitalAccountMutation, CustomerCreateDigitalAccountMutationVariables>;

/**
 * __useCustomerCreateDigitalAccountMutation__
 *
 * To run a mutation, you first call `useCustomerCreateDigitalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateDigitalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCreateDigitalAccountMutation, { data, loading, error }] = useCustomerCreateDigitalAccountMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerCreateDigitalAccountMutation(baseOptions?: Apollo.MutationHookOptions<CustomerCreateDigitalAccountMutation, CustomerCreateDigitalAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerCreateDigitalAccountMutation, CustomerCreateDigitalAccountMutationVariables>(CustomerCreateDigitalAccountDocument, options);
      }
export type CustomerCreateDigitalAccountMutationHookResult = ReturnType<typeof useCustomerCreateDigitalAccountMutation>;
export type CustomerCreateDigitalAccountMutationResult = Apollo.MutationResult<CustomerCreateDigitalAccountMutation>;
export type CustomerCreateDigitalAccountMutationOptions = Apollo.BaseMutationOptions<CustomerCreateDigitalAccountMutation, CustomerCreateDigitalAccountMutationVariables>;
export const CustomerRemoveLegalRepresentantDocument = gql`
    mutation CustomerRemoveLegalRepresentant($params: LegalRepresentativeRemoveGraphqlDto!) {
  customerRemoveLegalRepresentant(params: $params) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    nationality
    maritalStatus
    bank {
      account
      agency
      code
      type
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      nationality
      maritalStatus
      identificationNumber
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type CustomerRemoveLegalRepresentantMutationFn = Apollo.MutationFunction<CustomerRemoveLegalRepresentantMutation, CustomerRemoveLegalRepresentantMutationVariables>;

/**
 * __useCustomerRemoveLegalRepresentantMutation__
 *
 * To run a mutation, you first call `useCustomerRemoveLegalRepresentantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerRemoveLegalRepresentantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerRemoveLegalRepresentantMutation, { data, loading, error }] = useCustomerRemoveLegalRepresentantMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerRemoveLegalRepresentantMutation(baseOptions?: Apollo.MutationHookOptions<CustomerRemoveLegalRepresentantMutation, CustomerRemoveLegalRepresentantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerRemoveLegalRepresentantMutation, CustomerRemoveLegalRepresentantMutationVariables>(CustomerRemoveLegalRepresentantDocument, options);
      }
export type CustomerRemoveLegalRepresentantMutationHookResult = ReturnType<typeof useCustomerRemoveLegalRepresentantMutation>;
export type CustomerRemoveLegalRepresentantMutationResult = Apollo.MutationResult<CustomerRemoveLegalRepresentantMutation>;
export type CustomerRemoveLegalRepresentantMutationOptions = Apollo.BaseMutationOptions<CustomerRemoveLegalRepresentantMutation, CustomerRemoveLegalRepresentantMutationVariables>;
export const CustomerUpdateByIdDocument = gql`
    mutation CustomerUpdateById($id: String!, $params: CustomerUpdateGraphqlDTO!) {
  customerUpdateById(id: $id, params: $params) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    nationality
    maritalStatus
    bank {
      account
      agency
      code
      type
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      nationality
      maritalStatus
      identificationNumber
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type CustomerUpdateByIdMutationFn = Apollo.MutationFunction<CustomerUpdateByIdMutation, CustomerUpdateByIdMutationVariables>;

/**
 * __useCustomerUpdateByIdMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateByIdMutation, { data, loading, error }] = useCustomerUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<CustomerUpdateByIdMutation, CustomerUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerUpdateByIdMutation, CustomerUpdateByIdMutationVariables>(CustomerUpdateByIdDocument, options);
      }
export type CustomerUpdateByIdMutationHookResult = ReturnType<typeof useCustomerUpdateByIdMutation>;
export type CustomerUpdateByIdMutationResult = Apollo.MutationResult<CustomerUpdateByIdMutation>;
export type CustomerUpdateByIdMutationOptions = Apollo.BaseMutationOptions<CustomerUpdateByIdMutation, CustomerUpdateByIdMutationVariables>;
export const CustomerUpdateLegalRepresentantDocument = gql`
    mutation CustomerUpdateLegalRepresentant($params: LegalRepresentativeUpdateGraphqlDto!) {
  customerUpdateLegalRepresentant(params: $params) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    nationality
    maritalStatus
    bank {
      account
      agency
      code
      type
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      nationality
      maritalStatus
      identificationNumber
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type CustomerUpdateLegalRepresentantMutationFn = Apollo.MutationFunction<CustomerUpdateLegalRepresentantMutation, CustomerUpdateLegalRepresentantMutationVariables>;

/**
 * __useCustomerUpdateLegalRepresentantMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateLegalRepresentantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateLegalRepresentantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateLegalRepresentantMutation, { data, loading, error }] = useCustomerUpdateLegalRepresentantMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerUpdateLegalRepresentantMutation(baseOptions?: Apollo.MutationHookOptions<CustomerUpdateLegalRepresentantMutation, CustomerUpdateLegalRepresentantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerUpdateLegalRepresentantMutation, CustomerUpdateLegalRepresentantMutationVariables>(CustomerUpdateLegalRepresentantDocument, options);
      }
export type CustomerUpdateLegalRepresentantMutationHookResult = ReturnType<typeof useCustomerUpdateLegalRepresentantMutation>;
export type CustomerUpdateLegalRepresentantMutationResult = Apollo.MutationResult<CustomerUpdateLegalRepresentantMutation>;
export type CustomerUpdateLegalRepresentantMutationOptions = Apollo.BaseMutationOptions<CustomerUpdateLegalRepresentantMutation, CustomerUpdateLegalRepresentantMutationVariables>;
export const DeactivateContractDocument = gql`
    mutation DeactivateContract($id: String!) {
  deactivateContract(contractId: $id) {
    _id
    status
  }
}
    `;
export type DeactivateContractMutationFn = Apollo.MutationFunction<DeactivateContractMutation, DeactivateContractMutationVariables>;

/**
 * __useDeactivateContractMutation__
 *
 * To run a mutation, you first call `useDeactivateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateContractMutation, { data, loading, error }] = useDeactivateContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateContractMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateContractMutation, DeactivateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateContractMutation, DeactivateContractMutationVariables>(DeactivateContractDocument, options);
      }
export type DeactivateContractMutationHookResult = ReturnType<typeof useDeactivateContractMutation>;
export type DeactivateContractMutationResult = Apollo.MutationResult<DeactivateContractMutation>;
export type DeactivateContractMutationOptions = Apollo.BaseMutationOptions<DeactivateContractMutation, DeactivateContractMutationVariables>;
export const DealershipCreateDocument = gql`
    mutation DealershipCreate($params: DealershipCreateDTO!) {
  dealershipCreate(params: $params) {
    _id
    needLoginDealership
    name
    locationUf
    distributorId
    maxDiscountPercentagePf
    maxDiscountPercentagePj
    available
    createdAt
    updatedAt
    deletedAt
    minimumExceptionValue {
      value
      allowException
    }
    resolutionAneel {
      linkUrl
      modality
      resolutionHomologed
      validity
    }
    resolutionClasses {
      class
      cofinsPercentage
      fcp
      icmsPercentage
      teValueCents
      pisPercentage
      tusdValueCents
      wireBCalculationBaseValueCents
    }
    partnerBenefitToCustomer {
      customerPFDiscountMax
      customerPFDiscountMin
      customerPJDiscountMax
      customerPJDiscountMin
      customerPFDiscountSuggested
      customerPJDiscountSuggested
    }
  }
}
    `;
export type DealershipCreateMutationFn = Apollo.MutationFunction<DealershipCreateMutation, DealershipCreateMutationVariables>;

/**
 * __useDealershipCreateMutation__
 *
 * To run a mutation, you first call `useDealershipCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealershipCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealershipCreateMutation, { data, loading, error }] = useDealershipCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDealershipCreateMutation(baseOptions?: Apollo.MutationHookOptions<DealershipCreateMutation, DealershipCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealershipCreateMutation, DealershipCreateMutationVariables>(DealershipCreateDocument, options);
      }
export type DealershipCreateMutationHookResult = ReturnType<typeof useDealershipCreateMutation>;
export type DealershipCreateMutationResult = Apollo.MutationResult<DealershipCreateMutation>;
export type DealershipCreateMutationOptions = Apollo.BaseMutationOptions<DealershipCreateMutation, DealershipCreateMutationVariables>;
export const DealershipUpdateDocument = gql`
    mutation DealershipUpdate($params: DealershipUpdateDTO!) {
  dealershipUpdate(params: $params) {
    _id
    needLoginDealership
    name
    locationUf
    distributorId
    maxDiscountPercentagePf
    maxDiscountPercentagePj
    available
    createdAt
    updatedAt
    deletedAt
    minimumExceptionValue {
      value
      allowException
    }
    resolutionAneel {
      linkUrl
      modality
      resolutionHomologed
      validity
    }
    resolutionClasses {
      class
      cofinsPercentage
      fcp
      icmsPercentage
      teValueCents
      pisPercentage
      tusdValueCents
      wireBCalculationBaseValueCents
    }
    partnerBenefitToCustomer {
      customerPFDiscountMax
      customerPFDiscountMin
      customerPJDiscountMax
      customerPJDiscountMin
      customerPFDiscountSuggested
      customerPJDiscountSuggested
    }
  }
}
    `;
export type DealershipUpdateMutationFn = Apollo.MutationFunction<DealershipUpdateMutation, DealershipUpdateMutationVariables>;

/**
 * __useDealershipUpdateMutation__
 *
 * To run a mutation, you first call `useDealershipUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealershipUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealershipUpdateMutation, { data, loading, error }] = useDealershipUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDealershipUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DealershipUpdateMutation, DealershipUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealershipUpdateMutation, DealershipUpdateMutationVariables>(DealershipUpdateDocument, options);
      }
export type DealershipUpdateMutationHookResult = ReturnType<typeof useDealershipUpdateMutation>;
export type DealershipUpdateMutationResult = Apollo.MutationResult<DealershipUpdateMutation>;
export type DealershipUpdateMutationOptions = Apollo.BaseMutationOptions<DealershipUpdateMutation, DealershipUpdateMutationVariables>;
export const DiscountTableCreateDocument = gql`
    mutation DiscountTableCreate($params: CreateDiscountDto!) {
  discountTableCreate(params: $params) {
    _id
    createdAt
    type
    code
    updatedAt
    discountPercentage
  }
}
    `;
export type DiscountTableCreateMutationFn = Apollo.MutationFunction<DiscountTableCreateMutation, DiscountTableCreateMutationVariables>;

/**
 * __useDiscountTableCreateMutation__
 *
 * To run a mutation, you first call `useDiscountTableCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountTableCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountTableCreateMutation, { data, loading, error }] = useDiscountTableCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDiscountTableCreateMutation(baseOptions?: Apollo.MutationHookOptions<DiscountTableCreateMutation, DiscountTableCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscountTableCreateMutation, DiscountTableCreateMutationVariables>(DiscountTableCreateDocument, options);
      }
export type DiscountTableCreateMutationHookResult = ReturnType<typeof useDiscountTableCreateMutation>;
export type DiscountTableCreateMutationResult = Apollo.MutationResult<DiscountTableCreateMutation>;
export type DiscountTableCreateMutationOptions = Apollo.BaseMutationOptions<DiscountTableCreateMutation, DiscountTableCreateMutationVariables>;
export const DiscountTableUpdateDocument = gql`
    mutation DiscountTableUpdate($id: String!, $params: UpdateDiscountDto!) {
  discountTableUpdate(id: $id, params: $params) {
    _id
    createdAt
    type
    code
    updatedAt
    discountPercentage
  }
}
    `;
export type DiscountTableUpdateMutationFn = Apollo.MutationFunction<DiscountTableUpdateMutation, DiscountTableUpdateMutationVariables>;

/**
 * __useDiscountTableUpdateMutation__
 *
 * To run a mutation, you first call `useDiscountTableUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountTableUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountTableUpdateMutation, { data, loading, error }] = useDiscountTableUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDiscountTableUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DiscountTableUpdateMutation, DiscountTableUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscountTableUpdateMutation, DiscountTableUpdateMutationVariables>(DiscountTableUpdateDocument, options);
      }
export type DiscountTableUpdateMutationHookResult = ReturnType<typeof useDiscountTableUpdateMutation>;
export type DiscountTableUpdateMutationResult = Apollo.MutationResult<DiscountTableUpdateMutation>;
export type DiscountTableUpdateMutationOptions = Apollo.BaseMutationOptions<DiscountTableUpdateMutation, DiscountTableUpdateMutationVariables>;
export const ForInDeactivationContractDocument = gql`
    mutation ForInDeactivationContract($id: String!, $canCreate: Boolean!) {
  forInDeactivationContract(contractId: $id, canCreateInvoices: $canCreate) {
    _id
    status
  }
}
    `;
export type ForInDeactivationContractMutationFn = Apollo.MutationFunction<ForInDeactivationContractMutation, ForInDeactivationContractMutationVariables>;

/**
 * __useForInDeactivationContractMutation__
 *
 * To run a mutation, you first call `useForInDeactivationContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForInDeactivationContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forInDeactivationContractMutation, { data, loading, error }] = useForInDeactivationContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      canCreate: // value for 'canCreate'
 *   },
 * });
 */
export function useForInDeactivationContractMutation(baseOptions?: Apollo.MutationHookOptions<ForInDeactivationContractMutation, ForInDeactivationContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForInDeactivationContractMutation, ForInDeactivationContractMutationVariables>(ForInDeactivationContractDocument, options);
      }
export type ForInDeactivationContractMutationHookResult = ReturnType<typeof useForInDeactivationContractMutation>;
export type ForInDeactivationContractMutationResult = Apollo.MutationResult<ForInDeactivationContractMutation>;
export type ForInDeactivationContractMutationOptions = Apollo.BaseMutationOptions<ForInDeactivationContractMutation, ForInDeactivationContractMutationVariables>;
export const GenerateNewTermOfAdhesionDocument = gql`
    mutation GenerateNewTermOfAdhesion($proposalId: String!) {
  generateNewTermOfAdhesion(proposalId: $proposalId) {
    customerRef {
      personType
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      refusedReason
      approveManual
      manualOrAutomatic
      status
      signers {
        email
        id
        name
        requestSignId
      }
    }
  }
}
    `;
export type GenerateNewTermOfAdhesionMutationFn = Apollo.MutationFunction<GenerateNewTermOfAdhesionMutation, GenerateNewTermOfAdhesionMutationVariables>;

/**
 * __useGenerateNewTermOfAdhesionMutation__
 *
 * To run a mutation, you first call `useGenerateNewTermOfAdhesionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateNewTermOfAdhesionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateNewTermOfAdhesionMutation, { data, loading, error }] = useGenerateNewTermOfAdhesionMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useGenerateNewTermOfAdhesionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateNewTermOfAdhesionMutation, GenerateNewTermOfAdhesionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateNewTermOfAdhesionMutation, GenerateNewTermOfAdhesionMutationVariables>(GenerateNewTermOfAdhesionDocument, options);
      }
export type GenerateNewTermOfAdhesionMutationHookResult = ReturnType<typeof useGenerateNewTermOfAdhesionMutation>;
export type GenerateNewTermOfAdhesionMutationResult = Apollo.MutationResult<GenerateNewTermOfAdhesionMutation>;
export type GenerateNewTermOfAdhesionMutationOptions = Apollo.BaseMutationOptions<GenerateNewTermOfAdhesionMutation, GenerateNewTermOfAdhesionMutationVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($username: String!, $password: String!) {
  loginUser(authUserInput: {username: $username, password: $password}) {
    accessToken
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const NotifyCustomerFinishedDocumentationDocument = gql`
    mutation NotifyCustomerFinishedDocumentation($params: NotifyCustomerFinishedDocumentationGraphqlDto!) {
  notifyCustomerFinishedDocumentation(params: $params) {
    _id
  }
}
    `;
export type NotifyCustomerFinishedDocumentationMutationFn = Apollo.MutationFunction<NotifyCustomerFinishedDocumentationMutation, NotifyCustomerFinishedDocumentationMutationVariables>;

/**
 * __useNotifyCustomerFinishedDocumentationMutation__
 *
 * To run a mutation, you first call `useNotifyCustomerFinishedDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyCustomerFinishedDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyCustomerFinishedDocumentationMutation, { data, loading, error }] = useNotifyCustomerFinishedDocumentationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useNotifyCustomerFinishedDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<NotifyCustomerFinishedDocumentationMutation, NotifyCustomerFinishedDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyCustomerFinishedDocumentationMutation, NotifyCustomerFinishedDocumentationMutationVariables>(NotifyCustomerFinishedDocumentationDocument, options);
      }
export type NotifyCustomerFinishedDocumentationMutationHookResult = ReturnType<typeof useNotifyCustomerFinishedDocumentationMutation>;
export type NotifyCustomerFinishedDocumentationMutationResult = Apollo.MutationResult<NotifyCustomerFinishedDocumentationMutation>;
export type NotifyCustomerFinishedDocumentationMutationOptions = Apollo.BaseMutationOptions<NotifyCustomerFinishedDocumentationMutation, NotifyCustomerFinishedDocumentationMutationVariables>;
export const NotifyPartnerFinishedDocumentationDocument = gql`
    mutation notifyPartnerFinishedDocumentation($params: ContractNotifyPartnerFinishedDocumentationGraphqlDTO!) {
  notifyFinishedDocumentation(params: $params)
}
    `;
export type NotifyPartnerFinishedDocumentationMutationFn = Apollo.MutationFunction<NotifyPartnerFinishedDocumentationMutation, NotifyPartnerFinishedDocumentationMutationVariables>;

/**
 * __useNotifyPartnerFinishedDocumentationMutation__
 *
 * To run a mutation, you first call `useNotifyPartnerFinishedDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyPartnerFinishedDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyPartnerFinishedDocumentationMutation, { data, loading, error }] = useNotifyPartnerFinishedDocumentationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useNotifyPartnerFinishedDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<NotifyPartnerFinishedDocumentationMutation, NotifyPartnerFinishedDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyPartnerFinishedDocumentationMutation, NotifyPartnerFinishedDocumentationMutationVariables>(NotifyPartnerFinishedDocumentationDocument, options);
      }
export type NotifyPartnerFinishedDocumentationMutationHookResult = ReturnType<typeof useNotifyPartnerFinishedDocumentationMutation>;
export type NotifyPartnerFinishedDocumentationMutationResult = Apollo.MutationResult<NotifyPartnerFinishedDocumentationMutation>;
export type NotifyPartnerFinishedDocumentationMutationOptions = Apollo.BaseMutationOptions<NotifyPartnerFinishedDocumentationMutation, NotifyPartnerFinishedDocumentationMutationVariables>;
export const PartnerAffiliateUserApproveDocument = gql`
    mutation PartnerAffiliateUserApprove($id: String!) {
  partnerAffiliateUserApprove(id: $id) {
    _id
    status
    accessStatus
  }
}
    `;
export type PartnerAffiliateUserApproveMutationFn = Apollo.MutationFunction<PartnerAffiliateUserApproveMutation, PartnerAffiliateUserApproveMutationVariables>;

/**
 * __usePartnerAffiliateUserApproveMutation__
 *
 * To run a mutation, you first call `usePartnerAffiliateUserApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAffiliateUserApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAffiliateUserApproveMutation, { data, loading, error }] = usePartnerAffiliateUserApproveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerAffiliateUserApproveMutation(baseOptions?: Apollo.MutationHookOptions<PartnerAffiliateUserApproveMutation, PartnerAffiliateUserApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartnerAffiliateUserApproveMutation, PartnerAffiliateUserApproveMutationVariables>(PartnerAffiliateUserApproveDocument, options);
      }
export type PartnerAffiliateUserApproveMutationHookResult = ReturnType<typeof usePartnerAffiliateUserApproveMutation>;
export type PartnerAffiliateUserApproveMutationResult = Apollo.MutationResult<PartnerAffiliateUserApproveMutation>;
export type PartnerAffiliateUserApproveMutationOptions = Apollo.BaseMutationOptions<PartnerAffiliateUserApproveMutation, PartnerAffiliateUserApproveMutationVariables>;
export const PartnerAffiliateUserRejectDocument = gql`
    mutation PartnerAffiliateUserReject($id: String!, $justification: String!) {
  partnerAffiliateUserReject(id: $id, justification: $justification) {
    _id
    status
    rejectionReason
  }
}
    `;
export type PartnerAffiliateUserRejectMutationFn = Apollo.MutationFunction<PartnerAffiliateUserRejectMutation, PartnerAffiliateUserRejectMutationVariables>;

/**
 * __usePartnerAffiliateUserRejectMutation__
 *
 * To run a mutation, you first call `usePartnerAffiliateUserRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAffiliateUserRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAffiliateUserRejectMutation, { data, loading, error }] = usePartnerAffiliateUserRejectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      justification: // value for 'justification'
 *   },
 * });
 */
export function usePartnerAffiliateUserRejectMutation(baseOptions?: Apollo.MutationHookOptions<PartnerAffiliateUserRejectMutation, PartnerAffiliateUserRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartnerAffiliateUserRejectMutation, PartnerAffiliateUserRejectMutationVariables>(PartnerAffiliateUserRejectDocument, options);
      }
export type PartnerAffiliateUserRejectMutationHookResult = ReturnType<typeof usePartnerAffiliateUserRejectMutation>;
export type PartnerAffiliateUserRejectMutationResult = Apollo.MutationResult<PartnerAffiliateUserRejectMutation>;
export type PartnerAffiliateUserRejectMutationOptions = Apollo.BaseMutationOptions<PartnerAffiliateUserRejectMutation, PartnerAffiliateUserRejectMutationVariables>;
export const PartnerCreateDocument = gql`
    mutation PartnerCreate($params: PartnerCreateDTO!) {
  partnerCreate(params: $params) {
    _id
    manager {
      email
      id
      name
      partnerId
    }
    code
    document
    email
    name
    personType
    phone
    site
    status
    allowFormalizeProposal
    createdAt
    updatedAt
    partnershipConditions {
      anticipated {
        baseCommissionPercentage
        commissionedInvoices
        commissionExceptionGroups {
          baseCommissionPercentage
          commissionedInvoices
          id
          dealerships
        }
      }
      recurring {
        alwaysCommissionedInvoices
        baseCommissionPercentage
        commissionedInvoices
      }
    }
    contactPerson {
      email
      name
      phone
    }
    discountsException {
      customerPFDiscountMax
      customerPJDiscountMax
      customerPFDiscountMin
      customerPJDiscountMin
      customerPFDiscountSuggested
      customerPJDiscountSuggested
      dealershipId
      dealershipName
    }
    configuration {
      icone {
        fileName
        fileUrl
        key
        storageService
      }
      logo {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type PartnerCreateMutationFn = Apollo.MutationFunction<PartnerCreateMutation, PartnerCreateMutationVariables>;

/**
 * __usePartnerCreateMutation__
 *
 * To run a mutation, you first call `usePartnerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateMutation, { data, loading, error }] = usePartnerCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePartnerCreateMutation(baseOptions?: Apollo.MutationHookOptions<PartnerCreateMutation, PartnerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartnerCreateMutation, PartnerCreateMutationVariables>(PartnerCreateDocument, options);
      }
export type PartnerCreateMutationHookResult = ReturnType<typeof usePartnerCreateMutation>;
export type PartnerCreateMutationResult = Apollo.MutationResult<PartnerCreateMutation>;
export type PartnerCreateMutationOptions = Apollo.BaseMutationOptions<PartnerCreateMutation, PartnerCreateMutationVariables>;
export const PartnerUpdateDocument = gql`
    mutation PartnerUpdate($params: PartnerUpdateDTO!) {
  partnerUpdate(params: $params) {
    _id
    manager {
      email
      id
      name
      partnerId
    }
    code
    document
    email
    name
    personType
    phone
    site
    status
    allowFormalizeProposal
    createdAt
    updatedAt
    partnershipConditions {
      recurring {
        alwaysCommissionedInvoices
        baseCommissionPercentage
        commissionedInvoices
      }
      anticipated {
        baseCommissionPercentage
        commissionExceptionGroups {
          baseCommissionPercentage
          commissionedInvoices
          dealerships
          id
        }
        commissionedInvoices
      }
    }
    contactPerson {
      email
      name
      phone
    }
    discountsException {
      customerPFDiscountMax
      customerPJDiscountMax
      customerPFDiscountMin
      customerPJDiscountMin
      customerPFDiscountSuggested
      customerPJDiscountSuggested
      dealershipId
      dealershipName
    }
    configuration {
      icone {
        fileName
        fileUrl
        key
        storageService
      }
      logo {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type PartnerUpdateMutationFn = Apollo.MutationFunction<PartnerUpdateMutation, PartnerUpdateMutationVariables>;

/**
 * __usePartnerUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateMutation, { data, loading, error }] = usePartnerUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePartnerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PartnerUpdateMutation, PartnerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartnerUpdateMutation, PartnerUpdateMutationVariables>(PartnerUpdateDocument, options);
      }
export type PartnerUpdateMutationHookResult = ReturnType<typeof usePartnerUpdateMutation>;
export type PartnerUpdateMutationResult = Apollo.MutationResult<PartnerUpdateMutation>;
export type PartnerUpdateMutationOptions = Apollo.BaseMutationOptions<PartnerUpdateMutation, PartnerUpdateMutationVariables>;
export const PendencyFilesContractDocument = gql`
    mutation PendencyFilesContract($id: String!, $params: ContractAnalysisFilesDto!) {
  contractFilesAnalysis(id: $id, params: $params) {
    _id
    customerRef {
      legalRepresentatives {
        files {
          acceptedAt
          analyzedBy
          rejectedAt
          status
        }
        pendencies {
          document {
            acceptedAt
            analyzedBy
            sentAt
            rejectedAt
          }
        }
      }
    }
    files {
      status
      type
      acceptedAt
      analyzedBy
      sentAt
      rejectedAt
      file {
        fileUrl
        fileName
      }
    }
  }
}
    `;
export type PendencyFilesContractMutationFn = Apollo.MutationFunction<PendencyFilesContractMutation, PendencyFilesContractMutationVariables>;

/**
 * __usePendencyFilesContractMutation__
 *
 * To run a mutation, you first call `usePendencyFilesContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendencyFilesContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendencyFilesContractMutation, { data, loading, error }] = usePendencyFilesContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePendencyFilesContractMutation(baseOptions?: Apollo.MutationHookOptions<PendencyFilesContractMutation, PendencyFilesContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PendencyFilesContractMutation, PendencyFilesContractMutationVariables>(PendencyFilesContractDocument, options);
      }
export type PendencyFilesContractMutationHookResult = ReturnType<typeof usePendencyFilesContractMutation>;
export type PendencyFilesContractMutationResult = Apollo.MutationResult<PendencyFilesContractMutation>;
export type PendencyFilesContractMutationOptions = Apollo.BaseMutationOptions<PendencyFilesContractMutation, PendencyFilesContractMutationVariables>;
export const PendencyFilesProposalDocument = gql`
    mutation PendencyFilesProposal($id: String!, $params: ProposalAnalysisFilesDto!) {
  proposalFilesAnalysis(id: $id, params: $params) {
    _id
    customerRef {
      legalRepresentative {
        files {
          acceptedAt
          analysedBy
          rejectedAt
          status
        }
        pendencies {
          document {
            acceptedAt
            analysedBy
            solvedAt
            rejectedAt
          }
        }
      }
    }
    files {
      status
      type
      acceptedAt
      analysedBy
      sendAt
      rejectedAt
      file {
        fileUrl
        fileName
      }
    }
  }
}
    `;
export type PendencyFilesProposalMutationFn = Apollo.MutationFunction<PendencyFilesProposalMutation, PendencyFilesProposalMutationVariables>;

/**
 * __usePendencyFilesProposalMutation__
 *
 * To run a mutation, you first call `usePendencyFilesProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendencyFilesProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendencyFilesProposalMutation, { data, loading, error }] = usePendencyFilesProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePendencyFilesProposalMutation(baseOptions?: Apollo.MutationHookOptions<PendencyFilesProposalMutation, PendencyFilesProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PendencyFilesProposalMutation, PendencyFilesProposalMutationVariables>(PendencyFilesProposalDocument, options);
      }
export type PendencyFilesProposalMutationHookResult = ReturnType<typeof usePendencyFilesProposalMutation>;
export type PendencyFilesProposalMutationResult = Apollo.MutationResult<PendencyFilesProposalMutation>;
export type PendencyFilesProposalMutationOptions = Apollo.BaseMutationOptions<PendencyFilesProposalMutation, PendencyFilesProposalMutationVariables>;
export const PendencyRepresentativiesDocument = gql`
    mutation PendencyRepresentativies($id: String!, $filesParams: ProposalAnalysisFilesDto!, $dataParams: AnalyseLegalRepresentativeDataDTO!) {
  analyseLegalRepresentativeData(params: $dataParams) {
    _id
    customerRef {
      hasPendencies
      legalRepresentative {
        document
        pendencies {
          city {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          complement {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          document {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          email {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          name {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          neighborhood {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          number {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          phone {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          state {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          zipcode {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
        }
      }
    }
  }
  proposalFilesAnalysis(id: $id, params: $filesParams) {
    _id
    customerRef {
      legalRepresentative {
        document
        files {
          acceptedAt
          analysedBy
          rejectedAt
          status
          type
          sendAt
          file {
            fileName
            fileUrl
            key
            storageService
          }
        }
      }
    }
  }
}
    `;
export type PendencyRepresentativiesMutationFn = Apollo.MutationFunction<PendencyRepresentativiesMutation, PendencyRepresentativiesMutationVariables>;

/**
 * __usePendencyRepresentativiesMutation__
 *
 * To run a mutation, you first call `usePendencyRepresentativiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendencyRepresentativiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendencyRepresentativiesMutation, { data, loading, error }] = usePendencyRepresentativiesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      filesParams: // value for 'filesParams'
 *      dataParams: // value for 'dataParams'
 *   },
 * });
 */
export function usePendencyRepresentativiesMutation(baseOptions?: Apollo.MutationHookOptions<PendencyRepresentativiesMutation, PendencyRepresentativiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PendencyRepresentativiesMutation, PendencyRepresentativiesMutationVariables>(PendencyRepresentativiesDocument, options);
      }
export type PendencyRepresentativiesMutationHookResult = ReturnType<typeof usePendencyRepresentativiesMutation>;
export type PendencyRepresentativiesMutationResult = Apollo.MutationResult<PendencyRepresentativiesMutation>;
export type PendencyRepresentativiesMutationOptions = Apollo.BaseMutationOptions<PendencyRepresentativiesMutation, PendencyRepresentativiesMutationVariables>;
export const PowerGeneratorCreateDocument = gql`
    mutation PowerGeneratorCreate($params: PowerGeneratorCreateDTO!) {
  powerGeneratorCreate(params: $params) {
    _id
    active
    isDesperta
    name
    representatives {
      email
      name
      phone
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export type PowerGeneratorCreateMutationFn = Apollo.MutationFunction<PowerGeneratorCreateMutation, PowerGeneratorCreateMutationVariables>;

/**
 * __usePowerGeneratorCreateMutation__
 *
 * To run a mutation, you first call `usePowerGeneratorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePowerGeneratorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [powerGeneratorCreateMutation, { data, loading, error }] = usePowerGeneratorCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePowerGeneratorCreateMutation(baseOptions?: Apollo.MutationHookOptions<PowerGeneratorCreateMutation, PowerGeneratorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PowerGeneratorCreateMutation, PowerGeneratorCreateMutationVariables>(PowerGeneratorCreateDocument, options);
      }
export type PowerGeneratorCreateMutationHookResult = ReturnType<typeof usePowerGeneratorCreateMutation>;
export type PowerGeneratorCreateMutationResult = Apollo.MutationResult<PowerGeneratorCreateMutation>;
export type PowerGeneratorCreateMutationOptions = Apollo.BaseMutationOptions<PowerGeneratorCreateMutation, PowerGeneratorCreateMutationVariables>;
export const PowerGeneratorUpdateDocument = gql`
    mutation PowerGeneratorUpdate($params: PowerGeneratorUpdateDTO!) {
  powerGeneratorUpdate(params: $params) {
    _id
    active
    isDesperta
    name
    representatives {
      email
      name
      phone
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export type PowerGeneratorUpdateMutationFn = Apollo.MutationFunction<PowerGeneratorUpdateMutation, PowerGeneratorUpdateMutationVariables>;

/**
 * __usePowerGeneratorUpdateMutation__
 *
 * To run a mutation, you first call `usePowerGeneratorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePowerGeneratorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [powerGeneratorUpdateMutation, { data, loading, error }] = usePowerGeneratorUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePowerGeneratorUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PowerGeneratorUpdateMutation, PowerGeneratorUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PowerGeneratorUpdateMutation, PowerGeneratorUpdateMutationVariables>(PowerGeneratorUpdateDocument, options);
      }
export type PowerGeneratorUpdateMutationHookResult = ReturnType<typeof usePowerGeneratorUpdateMutation>;
export type PowerGeneratorUpdateMutationResult = Apollo.MutationResult<PowerGeneratorUpdateMutation>;
export type PowerGeneratorUpdateMutationOptions = Apollo.BaseMutationOptions<PowerGeneratorUpdateMutation, PowerGeneratorUpdateMutationVariables>;
export const PowerPlantCreateDocument = gql`
    mutation PowerPlantCreate($params: PowerPlantCreateDTO!) {
  powerPlantCreate(params: $params) {
    _id
    name
    acceptsPF
    acceptsPJ
    dealershipId
    installation
    isDesperta
    observation
    productionKwh
    productionMwac
    createdAt
    updatedAt
    generatorId
    email
    corporateName
    operationStartDate
    modality
    cashbackInfo {
      active
    }
    discountConfiguration {
      discount {
        pf
        pj
      }
      useDealershipDiscountPercentage
    }
    address {
      city
      complement
      country
      neighborhood
      number
      state
      street
      zipcode
    }
  }
}
    `;
export type PowerPlantCreateMutationFn = Apollo.MutationFunction<PowerPlantCreateMutation, PowerPlantCreateMutationVariables>;

/**
 * __usePowerPlantCreateMutation__
 *
 * To run a mutation, you first call `usePowerPlantCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePowerPlantCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [powerPlantCreateMutation, { data, loading, error }] = usePowerPlantCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePowerPlantCreateMutation(baseOptions?: Apollo.MutationHookOptions<PowerPlantCreateMutation, PowerPlantCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PowerPlantCreateMutation, PowerPlantCreateMutationVariables>(PowerPlantCreateDocument, options);
      }
export type PowerPlantCreateMutationHookResult = ReturnType<typeof usePowerPlantCreateMutation>;
export type PowerPlantCreateMutationResult = Apollo.MutationResult<PowerPlantCreateMutation>;
export type PowerPlantCreateMutationOptions = Apollo.BaseMutationOptions<PowerPlantCreateMutation, PowerPlantCreateMutationVariables>;
export const PowerPlantUpdateDocument = gql`
    mutation PowerPlantUpdate($params: PowerPlantUpdateDTO!) {
  powerPlantUpdate(params: $params) {
    _id
    name
    acceptsPF
    acceptsPJ
    dealershipId
    installation
    isDesperta
    observation
    productionKwh
    productionMwac
    createdAt
    updatedAt
    generatorId
    email
    corporateName
    operationStartDate
    cashbackInfo {
      active
    }
    discountConfiguration {
      discount {
        pf
        pj
      }
      useDealershipDiscountPercentage
    }
    modality
    address {
      city
      complement
      country
      neighborhood
      number
      state
      street
      zipcode
    }
  }
}
    `;
export type PowerPlantUpdateMutationFn = Apollo.MutationFunction<PowerPlantUpdateMutation, PowerPlantUpdateMutationVariables>;

/**
 * __usePowerPlantUpdateMutation__
 *
 * To run a mutation, you first call `usePowerPlantUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePowerPlantUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [powerPlantUpdateMutation, { data, loading, error }] = usePowerPlantUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePowerPlantUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PowerPlantUpdateMutation, PowerPlantUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PowerPlantUpdateMutation, PowerPlantUpdateMutationVariables>(PowerPlantUpdateDocument, options);
      }
export type PowerPlantUpdateMutationHookResult = ReturnType<typeof usePowerPlantUpdateMutation>;
export type PowerPlantUpdateMutationResult = Apollo.MutationResult<PowerPlantUpdateMutation>;
export type PowerPlantUpdateMutationOptions = Apollo.BaseMutationOptions<PowerPlantUpdateMutation, PowerPlantUpdateMutationVariables>;
export const ProposalAddEnergyBillInfoDocument = gql`
    mutation ProposalAddEnergyBillInfo($params: ProposalAddEnergyBillInfoGraphqlDto!) {
  proposalAddEnergyBillInfo(params: $params) {
    _id
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      invoiceDueDay
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type ProposalAddEnergyBillInfoMutationFn = Apollo.MutationFunction<ProposalAddEnergyBillInfoMutation, ProposalAddEnergyBillInfoMutationVariables>;

/**
 * __useProposalAddEnergyBillInfoMutation__
 *
 * To run a mutation, you first call `useProposalAddEnergyBillInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalAddEnergyBillInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalAddEnergyBillInfoMutation, { data, loading, error }] = useProposalAddEnergyBillInfoMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalAddEnergyBillInfoMutation(baseOptions?: Apollo.MutationHookOptions<ProposalAddEnergyBillInfoMutation, ProposalAddEnergyBillInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalAddEnergyBillInfoMutation, ProposalAddEnergyBillInfoMutationVariables>(ProposalAddEnergyBillInfoDocument, options);
      }
export type ProposalAddEnergyBillInfoMutationHookResult = ReturnType<typeof useProposalAddEnergyBillInfoMutation>;
export type ProposalAddEnergyBillInfoMutationResult = Apollo.MutationResult<ProposalAddEnergyBillInfoMutation>;
export type ProposalAddEnergyBillInfoMutationOptions = Apollo.BaseMutationOptions<ProposalAddEnergyBillInfoMutation, ProposalAddEnergyBillInfoMutationVariables>;
export const ProposalAddLegalRepresentativeDocument = gql`
    mutation ProposalAddLegalRepresentative($params: ProposalAddLegalRepresentativeGraphqlDto!) {
  proposalAddLegalRepresentative(params: $params) {
    _id
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type ProposalAddLegalRepresentativeMutationFn = Apollo.MutationFunction<ProposalAddLegalRepresentativeMutation, ProposalAddLegalRepresentativeMutationVariables>;

/**
 * __useProposalAddLegalRepresentativeMutation__
 *
 * To run a mutation, you first call `useProposalAddLegalRepresentativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalAddLegalRepresentativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalAddLegalRepresentativeMutation, { data, loading, error }] = useProposalAddLegalRepresentativeMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalAddLegalRepresentativeMutation(baseOptions?: Apollo.MutationHookOptions<ProposalAddLegalRepresentativeMutation, ProposalAddLegalRepresentativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalAddLegalRepresentativeMutation, ProposalAddLegalRepresentativeMutationVariables>(ProposalAddLegalRepresentativeDocument, options);
      }
export type ProposalAddLegalRepresentativeMutationHookResult = ReturnType<typeof useProposalAddLegalRepresentativeMutation>;
export type ProposalAddLegalRepresentativeMutationResult = Apollo.MutationResult<ProposalAddLegalRepresentativeMutation>;
export type ProposalAddLegalRepresentativeMutationOptions = Apollo.BaseMutationOptions<ProposalAddLegalRepresentativeMutation, ProposalAddLegalRepresentativeMutationVariables>;
export const ProposalCancelDocument = gql`
    mutation ProposalCancel($params: CancelProposalGraphqlDto!) {
  cancelProposal(params: $params) {
    _id
    lossReason
    rejectedInfo {
      reason
      rejectedAt
      rejectedBy {
        id
        name
      }
    }
    salesFunnel {
      stage
      changedBy
      date
      history {
        changedBy
        date
        stage
        user
      }
      user
    }
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type ProposalCancelMutationFn = Apollo.MutationFunction<ProposalCancelMutation, ProposalCancelMutationVariables>;

/**
 * __useProposalCancelMutation__
 *
 * To run a mutation, you first call `useProposalCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalCancelMutation, { data, loading, error }] = useProposalCancelMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalCancelMutation(baseOptions?: Apollo.MutationHookOptions<ProposalCancelMutation, ProposalCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalCancelMutation, ProposalCancelMutationVariables>(ProposalCancelDocument, options);
      }
export type ProposalCancelMutationHookResult = ReturnType<typeof useProposalCancelMutation>;
export type ProposalCancelMutationResult = Apollo.MutationResult<ProposalCancelMutation>;
export type ProposalCancelMutationOptions = Apollo.BaseMutationOptions<ProposalCancelMutation, ProposalCancelMutationVariables>;
export const ProposalCreateDocument = gql`
    mutation ProposalCreate($params: ProposalCreateGraphqlDto!) {
  proposalCreate(params: $params) {
    _id
    fidelityMonths
    sellerRef {
      changeAt
      changeBy
      email
      history {
        changeAt
        changeBy
        email
        id
        name
        user {
          email
          id
          name
        }
      }
      id
      name
      user {
        email
        id
        name
      }
    }
    supportRef {
      changeAt
      changeBy
      email
      history {
        changeAt
        changeBy
        email
        id
        name
        user {
          email
          id
          name
        }
      }
      id
      name
      user {
        email
        id
        name
      }
    }
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    consortiumId
    monthlyConsumption {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
  }
}
    `;
export type ProposalCreateMutationFn = Apollo.MutationFunction<ProposalCreateMutation, ProposalCreateMutationVariables>;

/**
 * __useProposalCreateMutation__
 *
 * To run a mutation, you first call `useProposalCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalCreateMutation, { data, loading, error }] = useProposalCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProposalCreateMutation, ProposalCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalCreateMutation, ProposalCreateMutationVariables>(ProposalCreateDocument, options);
      }
export type ProposalCreateMutationHookResult = ReturnType<typeof useProposalCreateMutation>;
export type ProposalCreateMutationResult = Apollo.MutationResult<ProposalCreateMutation>;
export type ProposalCreateMutationOptions = Apollo.BaseMutationOptions<ProposalCreateMutation, ProposalCreateMutationVariables>;
export const ProposalFormalizationDocument = gql`
    mutation ProposalFormalization($proposalId: String!) {
  proposalFormalization(proposalId: $proposalId) {
    status
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      refusedReason
      approveManual
      manualOrAutomatic
      signers {
        email
        id
        name
        requestSignId
      }
    }
    consortiumId
  }
}
    `;
export type ProposalFormalizationMutationFn = Apollo.MutationFunction<ProposalFormalizationMutation, ProposalFormalizationMutationVariables>;

/**
 * __useProposalFormalizationMutation__
 *
 * To run a mutation, you first call `useProposalFormalizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalFormalizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalFormalizationMutation, { data, loading, error }] = useProposalFormalizationMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useProposalFormalizationMutation(baseOptions?: Apollo.MutationHookOptions<ProposalFormalizationMutation, ProposalFormalizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalFormalizationMutation, ProposalFormalizationMutationVariables>(ProposalFormalizationDocument, options);
      }
export type ProposalFormalizationMutationHookResult = ReturnType<typeof useProposalFormalizationMutation>;
export type ProposalFormalizationMutationResult = Apollo.MutationResult<ProposalFormalizationMutation>;
export type ProposalFormalizationMutationOptions = Apollo.BaseMutationOptions<ProposalFormalizationMutation, ProposalFormalizationMutationVariables>;
export const ProposalUpdateDocument = gql`
    mutation ProposalUpdate($params: ProposalUpdateGraphqlDto!) {
  proposalUpdate(params: $params) {
    _id
    fidelityMonths
    sellerRef {
      changeAt
      changeBy
      email
      history {
        changeAt
        changeBy
        email
        id
        name
        user {
          email
          id
          name
        }
      }
      id
      name
      user {
        email
        id
        name
      }
    }
    supportRef {
      changeAt
      changeBy
      email
      history {
        changeAt
        changeBy
        email
        id
        name
        user {
          email
          id
          name
        }
      }
      id
      name
      user {
        email
        id
        name
      }
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      linkFileToSign
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
            storageService
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      invoiceDueDay
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
        country
      }
    }
    consortiumId
    monthlyConsumption {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
  }
}
    `;
export type ProposalUpdateMutationFn = Apollo.MutationFunction<ProposalUpdateMutation, ProposalUpdateMutationVariables>;

/**
 * __useProposalUpdateMutation__
 *
 * To run a mutation, you first call `useProposalUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalUpdateMutation, { data, loading, error }] = useProposalUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProposalUpdateMutation, ProposalUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalUpdateMutation, ProposalUpdateMutationVariables>(ProposalUpdateDocument, options);
      }
export type ProposalUpdateMutationHookResult = ReturnType<typeof useProposalUpdateMutation>;
export type ProposalUpdateMutationResult = Apollo.MutationResult<ProposalUpdateMutation>;
export type ProposalUpdateMutationOptions = Apollo.BaseMutationOptions<ProposalUpdateMutation, ProposalUpdateMutationVariables>;
export const ProposalUpdateLegalRepresentativeDocument = gql`
    mutation ProposalUpdateLegalRepresentative($params: ProposalUpdateLegalRepresentativeGraphqlDto!) {
  proposalUpdateLegalRepresentative(params: $params) {
    _id
    fidelityMonths
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type ProposalUpdateLegalRepresentativeMutationFn = Apollo.MutationFunction<ProposalUpdateLegalRepresentativeMutation, ProposalUpdateLegalRepresentativeMutationVariables>;

/**
 * __useProposalUpdateLegalRepresentativeMutation__
 *
 * To run a mutation, you first call `useProposalUpdateLegalRepresentativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalUpdateLegalRepresentativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalUpdateLegalRepresentativeMutation, { data, loading, error }] = useProposalUpdateLegalRepresentativeMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalUpdateLegalRepresentativeMutation(baseOptions?: Apollo.MutationHookOptions<ProposalUpdateLegalRepresentativeMutation, ProposalUpdateLegalRepresentativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalUpdateLegalRepresentativeMutation, ProposalUpdateLegalRepresentativeMutationVariables>(ProposalUpdateLegalRepresentativeDocument, options);
      }
export type ProposalUpdateLegalRepresentativeMutationHookResult = ReturnType<typeof useProposalUpdateLegalRepresentativeMutation>;
export type ProposalUpdateLegalRepresentativeMutationResult = Apollo.MutationResult<ProposalUpdateLegalRepresentativeMutation>;
export type ProposalUpdateLegalRepresentativeMutationOptions = Apollo.BaseMutationOptions<ProposalUpdateLegalRepresentativeMutation, ProposalUpdateLegalRepresentativeMutationVariables>;
export const ProviderInvoiceChangeDueDateDocument = gql`
    mutation ProviderInvoiceChangeDueDate($params: ContractInvoiceChangeDueDateDto!) {
  providerInvoiceChangeDueDate(params: $params) {
    _id
    createdAt
    customerDocument
    customerId
    deletedAt
    digitalAccountInvoiceId
    installationNumber
    provider
    providerData
    reference {
      month
      values {
        energyCreditBalanceKwh
        energyCreditProducedKwh
        energyCreditUsedKwh
        energyUsedKwh
        valueDealershipCents
        valueDiscountPowerPlantCents
        valueTotalPowerPlantCents
      }
    }
    status
    type
    updatedAt
    valueCents
  }
}
    `;
export type ProviderInvoiceChangeDueDateMutationFn = Apollo.MutationFunction<ProviderInvoiceChangeDueDateMutation, ProviderInvoiceChangeDueDateMutationVariables>;

/**
 * __useProviderInvoiceChangeDueDateMutation__
 *
 * To run a mutation, you first call `useProviderInvoiceChangeDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderInvoiceChangeDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerInvoiceChangeDueDateMutation, { data, loading, error }] = useProviderInvoiceChangeDueDateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProviderInvoiceChangeDueDateMutation(baseOptions?: Apollo.MutationHookOptions<ProviderInvoiceChangeDueDateMutation, ProviderInvoiceChangeDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderInvoiceChangeDueDateMutation, ProviderInvoiceChangeDueDateMutationVariables>(ProviderInvoiceChangeDueDateDocument, options);
      }
export type ProviderInvoiceChangeDueDateMutationHookResult = ReturnType<typeof useProviderInvoiceChangeDueDateMutation>;
export type ProviderInvoiceChangeDueDateMutationResult = Apollo.MutationResult<ProviderInvoiceChangeDueDateMutation>;
export type ProviderInvoiceChangeDueDateMutationOptions = Apollo.BaseMutationOptions<ProviderInvoiceChangeDueDateMutation, ProviderInvoiceChangeDueDateMutationVariables>;
export const ProposalRemoveLegalRepresentativeDocument = gql`
    mutation ProposalRemoveLegalRepresentative($params: ProposalRemoveLegalRepresentativeGraphqlDto!) {
  proposalRemoveLegalRepresentative(params: $params) {
    _id
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type ProposalRemoveLegalRepresentativeMutationFn = Apollo.MutationFunction<ProposalRemoveLegalRepresentativeMutation, ProposalRemoveLegalRepresentativeMutationVariables>;

/**
 * __useProposalRemoveLegalRepresentativeMutation__
 *
 * To run a mutation, you first call `useProposalRemoveLegalRepresentativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalRemoveLegalRepresentativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalRemoveLegalRepresentativeMutation, { data, loading, error }] = useProposalRemoveLegalRepresentativeMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalRemoveLegalRepresentativeMutation(baseOptions?: Apollo.MutationHookOptions<ProposalRemoveLegalRepresentativeMutation, ProposalRemoveLegalRepresentativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalRemoveLegalRepresentativeMutation, ProposalRemoveLegalRepresentativeMutationVariables>(ProposalRemoveLegalRepresentativeDocument, options);
      }
export type ProposalRemoveLegalRepresentativeMutationHookResult = ReturnType<typeof useProposalRemoveLegalRepresentativeMutation>;
export type ProposalRemoveLegalRepresentativeMutationResult = Apollo.MutationResult<ProposalRemoveLegalRepresentativeMutation>;
export type ProposalRemoveLegalRepresentativeMutationOptions = Apollo.BaseMutationOptions<ProposalRemoveLegalRepresentativeMutation, ProposalRemoveLegalRepresentativeMutationVariables>;
export const ReportExternalPaymentDocument = gql`
    mutation ReportExternalPayment($params: ReportExternalPaymentDTO!) {
  reportExternalPayment(params: $params)
}
    `;
export type ReportExternalPaymentMutationFn = Apollo.MutationFunction<ReportExternalPaymentMutation, ReportExternalPaymentMutationVariables>;

/**
 * __useReportExternalPaymentMutation__
 *
 * To run a mutation, you first call `useReportExternalPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportExternalPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportExternalPaymentMutation, { data, loading, error }] = useReportExternalPaymentMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useReportExternalPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReportExternalPaymentMutation, ReportExternalPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportExternalPaymentMutation, ReportExternalPaymentMutationVariables>(ReportExternalPaymentDocument, options);
      }
export type ReportExternalPaymentMutationHookResult = ReturnType<typeof useReportExternalPaymentMutation>;
export type ReportExternalPaymentMutationResult = Apollo.MutationResult<ReportExternalPaymentMutation>;
export type ReportExternalPaymentMutationOptions = Apollo.BaseMutationOptions<ReportExternalPaymentMutation, ReportExternalPaymentMutationVariables>;
export const SendContractToSignDocument = gql`
    mutation SendContractToSign($params: SendContractToSignDTOGraphql!) {
  sendContractToSign(params: $params) {
    _id
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
  }
}
    `;
export type SendContractToSignMutationFn = Apollo.MutationFunction<SendContractToSignMutation, SendContractToSignMutationVariables>;

/**
 * __useSendContractToSignMutation__
 *
 * To run a mutation, you first call `useSendContractToSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContractToSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContractToSignMutation, { data, loading, error }] = useSendContractToSignMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSendContractToSignMutation(baseOptions?: Apollo.MutationHookOptions<SendContractToSignMutation, SendContractToSignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContractToSignMutation, SendContractToSignMutationVariables>(SendContractToSignDocument, options);
      }
export type SendContractToSignMutationHookResult = ReturnType<typeof useSendContractToSignMutation>;
export type SendContractToSignMutationResult = Apollo.MutationResult<SendContractToSignMutation>;
export type SendContractToSignMutationOptions = Apollo.BaseMutationOptions<SendContractToSignMutation, SendContractToSignMutationVariables>;
export const SolveProposalCustomerPendenciesDocument = gql`
    mutation SolveProposalCustomerPendencies($params: SolveProposalCustomerPendenciesGraphqlDTO!) {
  solveProposalCustomerPendencies(params: $params) {
    _id
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type SolveProposalCustomerPendenciesMutationFn = Apollo.MutationFunction<SolveProposalCustomerPendenciesMutation, SolveProposalCustomerPendenciesMutationVariables>;

/**
 * __useSolveProposalCustomerPendenciesMutation__
 *
 * To run a mutation, you first call `useSolveProposalCustomerPendenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolveProposalCustomerPendenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solveProposalCustomerPendenciesMutation, { data, loading, error }] = useSolveProposalCustomerPendenciesMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSolveProposalCustomerPendenciesMutation(baseOptions?: Apollo.MutationHookOptions<SolveProposalCustomerPendenciesMutation, SolveProposalCustomerPendenciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SolveProposalCustomerPendenciesMutation, SolveProposalCustomerPendenciesMutationVariables>(SolveProposalCustomerPendenciesDocument, options);
      }
export type SolveProposalCustomerPendenciesMutationHookResult = ReturnType<typeof useSolveProposalCustomerPendenciesMutation>;
export type SolveProposalCustomerPendenciesMutationResult = Apollo.MutationResult<SolveProposalCustomerPendenciesMutation>;
export type SolveProposalCustomerPendenciesMutationOptions = Apollo.BaseMutationOptions<SolveProposalCustomerPendenciesMutation, SolveProposalCustomerPendenciesMutationVariables>;
export const SolveProposalLegalRepresentantPendenciesDocument = gql`
    mutation SolveProposalLegalRepresentantPendencies($params: SolveProposalLegalRepresentantPendenciesGraphqlDTO!) {
  solveProposalLegalRepresentantPendencies(params: $params) {
    _id
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type SolveProposalLegalRepresentantPendenciesMutationFn = Apollo.MutationFunction<SolveProposalLegalRepresentantPendenciesMutation, SolveProposalLegalRepresentantPendenciesMutationVariables>;

/**
 * __useSolveProposalLegalRepresentantPendenciesMutation__
 *
 * To run a mutation, you first call `useSolveProposalLegalRepresentantPendenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolveProposalLegalRepresentantPendenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solveProposalLegalRepresentantPendenciesMutation, { data, loading, error }] = useSolveProposalLegalRepresentantPendenciesMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSolveProposalLegalRepresentantPendenciesMutation(baseOptions?: Apollo.MutationHookOptions<SolveProposalLegalRepresentantPendenciesMutation, SolveProposalLegalRepresentantPendenciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SolveProposalLegalRepresentantPendenciesMutation, SolveProposalLegalRepresentantPendenciesMutationVariables>(SolveProposalLegalRepresentantPendenciesDocument, options);
      }
export type SolveProposalLegalRepresentantPendenciesMutationHookResult = ReturnType<typeof useSolveProposalLegalRepresentantPendenciesMutation>;
export type SolveProposalLegalRepresentantPendenciesMutationResult = Apollo.MutationResult<SolveProposalLegalRepresentantPendenciesMutation>;
export type SolveProposalLegalRepresentantPendenciesMutationOptions = Apollo.BaseMutationOptions<SolveProposalLegalRepresentantPendenciesMutation, SolveProposalLegalRepresentantPendenciesMutationVariables>;
export const UpdateInvoicesToExternalNegotiationDocument = gql`
    mutation UpdateInvoicesToExternalNegotiation($invoiceIds: [String!]!) {
  updateInvoicesToExternalNegotiation(invoiceIds: $invoiceIds) {
    notUpdated {
      error
      id
    }
    updated
  }
}
    `;
export type UpdateInvoicesToExternalNegotiationMutationFn = Apollo.MutationFunction<UpdateInvoicesToExternalNegotiationMutation, UpdateInvoicesToExternalNegotiationMutationVariables>;

/**
 * __useUpdateInvoicesToExternalNegotiationMutation__
 *
 * To run a mutation, you first call `useUpdateInvoicesToExternalNegotiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoicesToExternalNegotiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoicesToExternalNegotiationMutation, { data, loading, error }] = useUpdateInvoicesToExternalNegotiationMutation({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useUpdateInvoicesToExternalNegotiationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoicesToExternalNegotiationMutation, UpdateInvoicesToExternalNegotiationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoicesToExternalNegotiationMutation, UpdateInvoicesToExternalNegotiationMutationVariables>(UpdateInvoicesToExternalNegotiationDocument, options);
      }
export type UpdateInvoicesToExternalNegotiationMutationHookResult = ReturnType<typeof useUpdateInvoicesToExternalNegotiationMutation>;
export type UpdateInvoicesToExternalNegotiationMutationResult = Apollo.MutationResult<UpdateInvoicesToExternalNegotiationMutation>;
export type UpdateInvoicesToExternalNegotiationMutationOptions = Apollo.BaseMutationOptions<UpdateInvoicesToExternalNegotiationMutation, UpdateInvoicesToExternalNegotiationMutationVariables>;
export const UpdateSalesFunnelStageDocument = gql`
    mutation UpdateSalesFunnelStage($params: UpdateSalesFunnelStageDto!) {
  updateSalesFunnelStage(params: $params) {
    _id
    lossReason
    rejectedInfo {
      reason
      rejectedAt
      rejectedBy {
        id
        name
      }
    }
    salesFunnel {
      stage
      changedBy
      date
      history {
        changedBy
        date
        stage
        user
      }
      user
    }
  }
}
    `;
export type UpdateSalesFunnelStageMutationFn = Apollo.MutationFunction<UpdateSalesFunnelStageMutation, UpdateSalesFunnelStageMutationVariables>;

/**
 * __useUpdateSalesFunnelStageMutation__
 *
 * To run a mutation, you first call `useUpdateSalesFunnelStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesFunnelStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesFunnelStageMutation, { data, loading, error }] = useUpdateSalesFunnelStageMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateSalesFunnelStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesFunnelStageMutation, UpdateSalesFunnelStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesFunnelStageMutation, UpdateSalesFunnelStageMutationVariables>(UpdateSalesFunnelStageDocument, options);
      }
export type UpdateSalesFunnelStageMutationHookResult = ReturnType<typeof useUpdateSalesFunnelStageMutation>;
export type UpdateSalesFunnelStageMutationResult = Apollo.MutationResult<UpdateSalesFunnelStageMutation>;
export type UpdateSalesFunnelStageMutationOptions = Apollo.BaseMutationOptions<UpdateSalesFunnelStageMutation, UpdateSalesFunnelStageMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $params: UserUpdateInput!) {
  updateUser(id: $id, userUpdateInput: $params) {
    _id
    name
    status
    email
    type
    phone
    createdAt
    accessControlRef {
      id
      name
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UserChangePasswordDocument = gql`
    mutation UserChangePassword($params: RecoverPasswordChangeInput!) {
  userChangePassword(RecoverPasswordChangeInput: $params) {
    _id
    userRef {
      email
    }
  }
}
    `;
export type UserChangePasswordMutationFn = Apollo.MutationFunction<UserChangePasswordMutation, UserChangePasswordMutationVariables>;

/**
 * __useUserChangePasswordMutation__
 *
 * To run a mutation, you first call `useUserChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangePasswordMutation, { data, loading, error }] = useUserChangePasswordMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUserChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UserChangePasswordMutation, UserChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserChangePasswordMutation, UserChangePasswordMutationVariables>(UserChangePasswordDocument, options);
      }
export type UserChangePasswordMutationHookResult = ReturnType<typeof useUserChangePasswordMutation>;
export type UserChangePasswordMutationResult = Apollo.MutationResult<UserChangePasswordMutation>;
export type UserChangePasswordMutationOptions = Apollo.BaseMutationOptions<UserChangePasswordMutation, UserChangePasswordMutationVariables>;
export const UserRecoverPasswordDocument = gql`
    mutation UserRecoverPassword($params: RecoverPasswordInput!) {
  userRecoverPassword(RecoverPasswordInput: $params) {
    _id
    userRef {
      email
    }
  }
}
    `;
export type UserRecoverPasswordMutationFn = Apollo.MutationFunction<UserRecoverPasswordMutation, UserRecoverPasswordMutationVariables>;

/**
 * __useUserRecoverPasswordMutation__
 *
 * To run a mutation, you first call `useUserRecoverPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRecoverPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRecoverPasswordMutation, { data, loading, error }] = useUserRecoverPasswordMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUserRecoverPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UserRecoverPasswordMutation, UserRecoverPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRecoverPasswordMutation, UserRecoverPasswordMutationVariables>(UserRecoverPasswordDocument, options);
      }
export type UserRecoverPasswordMutationHookResult = ReturnType<typeof useUserRecoverPasswordMutation>;
export type UserRecoverPasswordMutationResult = Apollo.MutationResult<UserRecoverPasswordMutation>;
export type UserRecoverPasswordMutationOptions = Apollo.BaseMutationOptions<UserRecoverPasswordMutation, UserRecoverPasswordMutationVariables>;
export const AccessControlGetDocument = gql`
    query AccessControlGet($id: String!) {
  accessControlGet(id: $id) {
    _id
    name
    active
    createdAt
    modules {
      actions
      name
    }
  }
}
    `;

/**
 * __useAccessControlGetQuery__
 *
 * To run a query within a React component, call `useAccessControlGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessControlGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessControlGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccessControlGetQuery(baseOptions: Apollo.QueryHookOptions<AccessControlGetQuery, AccessControlGetQueryVariables> & ({ variables: AccessControlGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessControlGetQuery, AccessControlGetQueryVariables>(AccessControlGetDocument, options);
      }
export function useAccessControlGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessControlGetQuery, AccessControlGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessControlGetQuery, AccessControlGetQueryVariables>(AccessControlGetDocument, options);
        }
// @ts-ignore
export function useAccessControlGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessControlGetQuery, AccessControlGetQueryVariables>): Apollo.UseSuspenseQueryResult<AccessControlGetQuery, AccessControlGetQueryVariables>;
export function useAccessControlGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessControlGetQuery, AccessControlGetQueryVariables>): Apollo.UseSuspenseQueryResult<AccessControlGetQuery | undefined, AccessControlGetQueryVariables>;
export function useAccessControlGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessControlGetQuery, AccessControlGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessControlGetQuery, AccessControlGetQueryVariables>(AccessControlGetDocument, options);
        }
export type AccessControlGetQueryHookResult = ReturnType<typeof useAccessControlGetQuery>;
export type AccessControlGetLazyQueryHookResult = ReturnType<typeof useAccessControlGetLazyQuery>;
export type AccessControlGetSuspenseQueryHookResult = ReturnType<typeof useAccessControlGetSuspenseQuery>;
export type AccessControlGetQueryResult = Apollo.QueryResult<AccessControlGetQuery, AccessControlGetQueryVariables>;
export const AccessControlListDocument = gql`
    query AccessControlList($params: AccessControlListDTO) {
  accessControlList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      active
      name
      createdAt
    }
  }
}
    `;

/**
 * __useAccessControlListQuery__
 *
 * To run a query within a React component, call `useAccessControlListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessControlListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessControlListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAccessControlListQuery(baseOptions?: Apollo.QueryHookOptions<AccessControlListQuery, AccessControlListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessControlListQuery, AccessControlListQueryVariables>(AccessControlListDocument, options);
      }
export function useAccessControlListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessControlListQuery, AccessControlListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessControlListQuery, AccessControlListQueryVariables>(AccessControlListDocument, options);
        }
// @ts-ignore
export function useAccessControlListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessControlListQuery, AccessControlListQueryVariables>): Apollo.UseSuspenseQueryResult<AccessControlListQuery, AccessControlListQueryVariables>;
export function useAccessControlListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessControlListQuery, AccessControlListQueryVariables>): Apollo.UseSuspenseQueryResult<AccessControlListQuery | undefined, AccessControlListQueryVariables>;
export function useAccessControlListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessControlListQuery, AccessControlListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessControlListQuery, AccessControlListQueryVariables>(AccessControlListDocument, options);
        }
export type AccessControlListQueryHookResult = ReturnType<typeof useAccessControlListQuery>;
export type AccessControlListLazyQueryHookResult = ReturnType<typeof useAccessControlListLazyQuery>;
export type AccessControlListSuspenseQueryHookResult = ReturnType<typeof useAccessControlListSuspenseQuery>;
export type AccessControlListQueryResult = Apollo.QueryResult<AccessControlListQuery, AccessControlListQueryVariables>;
export const ConsortiumGetDocument = gql`
    query ConsortiumGet($id: String!) {
  consortiumGet(id: $id) {
    _id
    cnpj
    createdAt
    updatedAt
    deletedAt
    email
    fantasyName
    leaderEmail
    leaderName
    name
    phone
    digitalAccount {
      accountOwner
      document
      documents {
        type
        file {
          fileName
          fileUrl
          key
          mimeType
          storageService
        }
      }
      email
      feedback
      legalRepresentative {
        document
        name
      }
      name
      pendencies {
        account {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        address {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        addressProof {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        agency {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        balance_sheet {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        identificationBack {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        identificationFront {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        selfie {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
        social_contract {
          approvedAt
          inAnalysisAt
          pendenciedAt
          rejectedAt
        }
      }
      phone
      status
    }
    legalRepresentative {
      name
      document
    }
    bank {
      account
      agency
      code
      type
    }
    status
    address {
      city
      country
      neighborhood
      number
      state
      street
      zipcode
      complement
    }
  }
}
    `;

/**
 * __useConsortiumGetQuery__
 *
 * To run a query within a React component, call `useConsortiumGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsortiumGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsortiumGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsortiumGetQuery(baseOptions: Apollo.QueryHookOptions<ConsortiumGetQuery, ConsortiumGetQueryVariables> & ({ variables: ConsortiumGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsortiumGetQuery, ConsortiumGetQueryVariables>(ConsortiumGetDocument, options);
      }
export function useConsortiumGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsortiumGetQuery, ConsortiumGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsortiumGetQuery, ConsortiumGetQueryVariables>(ConsortiumGetDocument, options);
        }
// @ts-ignore
export function useConsortiumGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsortiumGetQuery, ConsortiumGetQueryVariables>): Apollo.UseSuspenseQueryResult<ConsortiumGetQuery, ConsortiumGetQueryVariables>;
export function useConsortiumGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConsortiumGetQuery, ConsortiumGetQueryVariables>): Apollo.UseSuspenseQueryResult<ConsortiumGetQuery | undefined, ConsortiumGetQueryVariables>;
export function useConsortiumGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConsortiumGetQuery, ConsortiumGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsortiumGetQuery, ConsortiumGetQueryVariables>(ConsortiumGetDocument, options);
        }
export type ConsortiumGetQueryHookResult = ReturnType<typeof useConsortiumGetQuery>;
export type ConsortiumGetLazyQueryHookResult = ReturnType<typeof useConsortiumGetLazyQuery>;
export type ConsortiumGetSuspenseQueryHookResult = ReturnType<typeof useConsortiumGetSuspenseQuery>;
export type ConsortiumGetQueryResult = Apollo.QueryResult<ConsortiumGetQuery, ConsortiumGetQueryVariables>;
export const ConsortiumListDocument = gql`
    query ConsortiumList($params: ConsortiumListDTOGraphql) {
  consortiumList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      cnpj
      status
      name
      status
      digitalAccount {
        status
      }
    }
  }
}
    `;

/**
 * __useConsortiumListQuery__
 *
 * To run a query within a React component, call `useConsortiumListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsortiumListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsortiumListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useConsortiumListQuery(baseOptions?: Apollo.QueryHookOptions<ConsortiumListQuery, ConsortiumListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsortiumListQuery, ConsortiumListQueryVariables>(ConsortiumListDocument, options);
      }
export function useConsortiumListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsortiumListQuery, ConsortiumListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsortiumListQuery, ConsortiumListQueryVariables>(ConsortiumListDocument, options);
        }
// @ts-ignore
export function useConsortiumListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsortiumListQuery, ConsortiumListQueryVariables>): Apollo.UseSuspenseQueryResult<ConsortiumListQuery, ConsortiumListQueryVariables>;
export function useConsortiumListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConsortiumListQuery, ConsortiumListQueryVariables>): Apollo.UseSuspenseQueryResult<ConsortiumListQuery | undefined, ConsortiumListQueryVariables>;
export function useConsortiumListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConsortiumListQuery, ConsortiumListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsortiumListQuery, ConsortiumListQueryVariables>(ConsortiumListDocument, options);
        }
export type ConsortiumListQueryHookResult = ReturnType<typeof useConsortiumListQuery>;
export type ConsortiumListLazyQueryHookResult = ReturnType<typeof useConsortiumListLazyQuery>;
export type ConsortiumListSuspenseQueryHookResult = ReturnType<typeof useConsortiumListSuspenseQuery>;
export type ConsortiumListQueryResult = Apollo.QueryResult<ConsortiumListQuery, ConsortiumListQueryVariables>;
export const ContractGetDocument = gql`
    query ContractGet($id: String!) {
  contractGet(id: $id) {
    _id
    canCreateInvoices
    ownGenerationAverageKwh
    isFormalizedByPartner
    isDocumentsAudited
    cancellationRequestedAt
    cancellationRequestedBy
    previousGenerationBalance
    billingType
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    notes {
      analystId
      analystName
      createdAt
      text
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
    customerRef {
      document
      name
      personType
      email
      phone
      legalRepresentatives {
        document
        email
        name
        document
        phone
        files {
          acceptedAt
          analyzedBy
          file {
            fileName
            fileUrl
            key
            storageService
          }
          rejectedAt
          sentAt
          status
          type
        }
        pendencies {
          city {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          complement {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          document {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          email {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          name {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          neighborhood {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          number {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          phone {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          state {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          zipCode {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
        }
      }
      pendencies {
        city {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        email {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        name {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        neighborhood {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        number {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        phone {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        state {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        street {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        zipCode {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
        uf {
          acceptedAt
          analyzedBy
          rejectedAt
          sentAt
        }
      }
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
      uuid
      refusedReason
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
        key
        storageService
      }
      energyTaxes
      installationNumber
      oldInstallationNumber
      hasNewStandardInstallationNumber
      installationNumberMigratedAt
      invoiceDueDay
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    activatedAt
    activatedBy
    canceledReason
    monthlyConsumption {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
    indicationRef {
      condition {
        anticipated {
          additionalCommissionPercentage
          baseCommissionPercentage
          commissionAmountPercentage
          commissionExceptionGroupId
          commissionedInvoices
        }
        customerDiscountMax
        customerDiscountMin
        customerDiscountOffered
        customerDiscountSuggested
        dealershipId
        dealershipName
        recurring {
          additionalCommissionPercentage
          baseCommissionPercentage
          commissionAmountPercentage
          alwaysCommissionedInvoices
          commissionedInvoices
        }
        uf
      }
      expired
      id
      partner {
        document
        email
        id
        name
        phone
      }
      salesman {
        id
        name
      }
      type
    }
    customerIndicationRef {
      customerId
      customerName
    }
    files {
      acceptedAt
      analyzedBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      rejectedAt
      sentAt
      status
      type
    }
  }
}
    `;

/**
 * __useContractGetQuery__
 *
 * To run a query within a React component, call `useContractGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractGetQuery(baseOptions: Apollo.QueryHookOptions<ContractGetQuery, ContractGetQueryVariables> & ({ variables: ContractGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractGetQuery, ContractGetQueryVariables>(ContractGetDocument, options);
      }
export function useContractGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractGetQuery, ContractGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractGetQuery, ContractGetQueryVariables>(ContractGetDocument, options);
        }
// @ts-ignore
export function useContractGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractGetQuery, ContractGetQueryVariables>): Apollo.UseSuspenseQueryResult<ContractGetQuery, ContractGetQueryVariables>;
export function useContractGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractGetQuery, ContractGetQueryVariables>): Apollo.UseSuspenseQueryResult<ContractGetQuery | undefined, ContractGetQueryVariables>;
export function useContractGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractGetQuery, ContractGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractGetQuery, ContractGetQueryVariables>(ContractGetDocument, options);
        }
export type ContractGetQueryHookResult = ReturnType<typeof useContractGetQuery>;
export type ContractGetLazyQueryHookResult = ReturnType<typeof useContractGetLazyQuery>;
export type ContractGetSuspenseQueryHookResult = ReturnType<typeof useContractGetSuspenseQuery>;
export type ContractGetQueryResult = Apollo.QueryResult<ContractGetQuery, ContractGetQueryVariables>;
export const ContractListDocument = gql`
    query ContractList($params: ContractListDTOGraphql) {
  contractList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      isFormalizedByPartner
      origin
      energyBillInfo {
        installationNumber
        oldInstallationNumber
        hasNewStandardInstallationNumber
        installationNumberMigratedAt
      }
      indicationRef {
        partner {
          name
        }
      }
      customerRef {
        name
        document
        phone
        email
      }
      status
      type
      customerIndicationRef {
        customerId
        customerName
      }
    }
  }
}
    `;

/**
 * __useContractListQuery__
 *
 * To run a query within a React component, call `useContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractListQuery(baseOptions?: Apollo.QueryHookOptions<ContractListQuery, ContractListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractListQuery, ContractListQueryVariables>(ContractListDocument, options);
      }
export function useContractListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractListQuery, ContractListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractListQuery, ContractListQueryVariables>(ContractListDocument, options);
        }
// @ts-ignore
export function useContractListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractListQuery, ContractListQueryVariables>): Apollo.UseSuspenseQueryResult<ContractListQuery, ContractListQueryVariables>;
export function useContractListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractListQuery, ContractListQueryVariables>): Apollo.UseSuspenseQueryResult<ContractListQuery | undefined, ContractListQueryVariables>;
export function useContractListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractListQuery, ContractListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractListQuery, ContractListQueryVariables>(ContractListDocument, options);
        }
export type ContractListQueryHookResult = ReturnType<typeof useContractListQuery>;
export type ContractListLazyQueryHookResult = ReturnType<typeof useContractListLazyQuery>;
export type ContractListSuspenseQueryHookResult = ReturnType<typeof useContractListSuspenseQuery>;
export type ContractListQueryResult = Apollo.QueryResult<ContractListQuery, ContractListQueryVariables>;
export const CustomerCalculateNewDueDateInvoiceIdDocument = gql`
    query CustomerCalculateNewDueDateInvoiceId($invoiceId: String!) {
  customerCalculateNewDueDateInvoiceId(invoiceId: $invoiceId) {
    invoiceId
    newDueDateCalculated {
      dueDate
      invoiceValue
      fineAmountCents
      interestAmountCents
      amountCents
      lateDays
    }
  }
}
    `;

/**
 * __useCustomerCalculateNewDueDateInvoiceIdQuery__
 *
 * To run a query within a React component, call `useCustomerCalculateNewDueDateInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCalculateNewDueDateInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCalculateNewDueDateInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useCustomerCalculateNewDueDateInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables> & ({ variables: CustomerCalculateNewDueDateInvoiceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>(CustomerCalculateNewDueDateInvoiceIdDocument, options);
      }
export function useCustomerCalculateNewDueDateInvoiceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>(CustomerCalculateNewDueDateInvoiceIdDocument, options);
        }
// @ts-ignore
export function useCustomerCalculateNewDueDateInvoiceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>;
export function useCustomerCalculateNewDueDateInvoiceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerCalculateNewDueDateInvoiceIdQuery | undefined, CustomerCalculateNewDueDateInvoiceIdQueryVariables>;
export function useCustomerCalculateNewDueDateInvoiceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>(CustomerCalculateNewDueDateInvoiceIdDocument, options);
        }
export type CustomerCalculateNewDueDateInvoiceIdQueryHookResult = ReturnType<typeof useCustomerCalculateNewDueDateInvoiceIdQuery>;
export type CustomerCalculateNewDueDateInvoiceIdLazyQueryHookResult = ReturnType<typeof useCustomerCalculateNewDueDateInvoiceIdLazyQuery>;
export type CustomerCalculateNewDueDateInvoiceIdSuspenseQueryHookResult = ReturnType<typeof useCustomerCalculateNewDueDateInvoiceIdSuspenseQuery>;
export type CustomerCalculateNewDueDateInvoiceIdQueryResult = Apollo.QueryResult<CustomerCalculateNewDueDateInvoiceIdQuery, CustomerCalculateNewDueDateInvoiceIdQueryVariables>;
export const CustomerContractListDocument = gql`
    query CustomerContractList($customerId: String) {
  contractList(params: {customerId: $customerId}) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      contractedSharePercent
      status
      reward {
        type
        percent
      }
    }
  }
}
    `;

/**
 * __useCustomerContractListQuery__
 *
 * To run a query within a React component, call `useCustomerContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractListQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerContractListQuery(baseOptions?: Apollo.QueryHookOptions<CustomerContractListQuery, CustomerContractListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerContractListQuery, CustomerContractListQueryVariables>(CustomerContractListDocument, options);
      }
export function useCustomerContractListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerContractListQuery, CustomerContractListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerContractListQuery, CustomerContractListQueryVariables>(CustomerContractListDocument, options);
        }
// @ts-ignore
export function useCustomerContractListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerContractListQuery, CustomerContractListQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerContractListQuery, CustomerContractListQueryVariables>;
export function useCustomerContractListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerContractListQuery, CustomerContractListQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerContractListQuery | undefined, CustomerContractListQueryVariables>;
export function useCustomerContractListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerContractListQuery, CustomerContractListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerContractListQuery, CustomerContractListQueryVariables>(CustomerContractListDocument, options);
        }
export type CustomerContractListQueryHookResult = ReturnType<typeof useCustomerContractListQuery>;
export type CustomerContractListLazyQueryHookResult = ReturnType<typeof useCustomerContractListLazyQuery>;
export type CustomerContractListSuspenseQueryHookResult = ReturnType<typeof useCustomerContractListSuspenseQuery>;
export type CustomerContractListQueryResult = Apollo.QueryResult<CustomerContractListQuery, CustomerContractListQueryVariables>;
export const CustomerGetDocument = gql`
    query CustomerGet($id: String!) {
  customerGet(id: $id) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    nationality
    maritalStatus
    digitalAccount {
      id
      name
      status
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      nationality
      maritalStatus
      identificationNumber
      bank {
        code
        type
        account
        agency
      }
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
    bank {
      code
      type
      account
      agency
    }
  }
}
    `;

/**
 * __useCustomerGetQuery__
 *
 * To run a query within a React component, call `useCustomerGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerGetQuery(baseOptions: Apollo.QueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables> & ({ variables: CustomerGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerGetQuery, CustomerGetQueryVariables>(CustomerGetDocument, options);
      }
export function useCustomerGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerGetQuery, CustomerGetQueryVariables>(CustomerGetDocument, options);
        }
// @ts-ignore
export function useCustomerGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerGetQuery, CustomerGetQueryVariables>;
export function useCustomerGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerGetQuery | undefined, CustomerGetQueryVariables>;
export function useCustomerGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerGetQuery, CustomerGetQueryVariables>(CustomerGetDocument, options);
        }
export type CustomerGetQueryHookResult = ReturnType<typeof useCustomerGetQuery>;
export type CustomerGetLazyQueryHookResult = ReturnType<typeof useCustomerGetLazyQuery>;
export type CustomerGetSuspenseQueryHookResult = ReturnType<typeof useCustomerGetSuspenseQuery>;
export type CustomerGetQueryResult = Apollo.QueryResult<CustomerGetQuery, CustomerGetQueryVariables>;
export const CustomerListDocument = gql`
    query CustomerList($params: CustomerListGraphqlDTO) {
  customerList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      name
      email
      phone
      status
      document
      createdAt
      personType
    }
  }
}
    `;

/**
 * __useCustomerListQuery__
 *
 * To run a query within a React component, call `useCustomerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerListQuery(baseOptions?: Apollo.QueryHookOptions<CustomerListQuery, CustomerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerListQuery, CustomerListQueryVariables>(CustomerListDocument, options);
      }
export function useCustomerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerListQuery, CustomerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerListQuery, CustomerListQueryVariables>(CustomerListDocument, options);
        }
// @ts-ignore
export function useCustomerListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerListQuery, CustomerListQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerListQuery, CustomerListQueryVariables>;
export function useCustomerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerListQuery, CustomerListQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerListQuery | undefined, CustomerListQueryVariables>;
export function useCustomerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerListQuery, CustomerListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerListQuery, CustomerListQueryVariables>(CustomerListDocument, options);
        }
export type CustomerListQueryHookResult = ReturnType<typeof useCustomerListQuery>;
export type CustomerListLazyQueryHookResult = ReturnType<typeof useCustomerListLazyQuery>;
export type CustomerListSuspenseQueryHookResult = ReturnType<typeof useCustomerListSuspenseQuery>;
export type CustomerListQueryResult = Apollo.QueryResult<CustomerListQuery, CustomerListQueryVariables>;
export const CustomerListAllDocument = gql`
    query CustomerListAll($params: CustomerListGraphqlDTO) {
  customerList(params: $params) {
    data {
      _id
      name
      email
      phone
      status
      document
      createdAt
      personType
      nationality
      maritalStatus
      address {
        city
        state
        street
        number
        zipcode
        complement
        neighborhood
      }
      files {
        file {
          fileName
          fileUrl
          key
        }
        sendAt
        status
        type
      }
      bank {
        code
        type
        account
        agency
      }
      legalRepresentatives {
        address {
          city
          state
          street
          number
          zipcode
          complement
          neighborhood
        }
        name
        email
        phone
        document
        nationality
        maritalStatus
        identificationNumber
        files {
          file {
            fileName
            fileUrl
          }
          sendAt
          status
          type
        }
        bank {
          code
          type
          account
          agency
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerListAllQuery__
 *
 * To run a query within a React component, call `useCustomerListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerListAllQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerListAllQuery(baseOptions?: Apollo.QueryHookOptions<CustomerListAllQuery, CustomerListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerListAllQuery, CustomerListAllQueryVariables>(CustomerListAllDocument, options);
      }
export function useCustomerListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerListAllQuery, CustomerListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerListAllQuery, CustomerListAllQueryVariables>(CustomerListAllDocument, options);
        }
// @ts-ignore
export function useCustomerListAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerListAllQuery, CustomerListAllQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerListAllQuery, CustomerListAllQueryVariables>;
export function useCustomerListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerListAllQuery, CustomerListAllQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerListAllQuery | undefined, CustomerListAllQueryVariables>;
export function useCustomerListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerListAllQuery, CustomerListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerListAllQuery, CustomerListAllQueryVariables>(CustomerListAllDocument, options);
        }
export type CustomerListAllQueryHookResult = ReturnType<typeof useCustomerListAllQuery>;
export type CustomerListAllLazyQueryHookResult = ReturnType<typeof useCustomerListAllLazyQuery>;
export type CustomerListAllSuspenseQueryHookResult = ReturnType<typeof useCustomerListAllSuspenseQuery>;
export type CustomerListAllQueryResult = Apollo.QueryResult<CustomerListAllQuery, CustomerListAllQueryVariables>;
export const CustomerRequestInvoiceSecondCopyDocument = gql`
    mutation CustomerRequestInvoiceSecondCopy($params: InvoiceRequestSecondCopyInput!) {
  customerRequestInvoiceSecondCopy(params: $params) {
    status
  }
}
    `;
export type CustomerRequestInvoiceSecondCopyMutationFn = Apollo.MutationFunction<CustomerRequestInvoiceSecondCopyMutation, CustomerRequestInvoiceSecondCopyMutationVariables>;

/**
 * __useCustomerRequestInvoiceSecondCopyMutation__
 *
 * To run a mutation, you first call `useCustomerRequestInvoiceSecondCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerRequestInvoiceSecondCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerRequestInvoiceSecondCopyMutation, { data, loading, error }] = useCustomerRequestInvoiceSecondCopyMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerRequestInvoiceSecondCopyMutation(baseOptions?: Apollo.MutationHookOptions<CustomerRequestInvoiceSecondCopyMutation, CustomerRequestInvoiceSecondCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerRequestInvoiceSecondCopyMutation, CustomerRequestInvoiceSecondCopyMutationVariables>(CustomerRequestInvoiceSecondCopyDocument, options);
      }
export type CustomerRequestInvoiceSecondCopyMutationHookResult = ReturnType<typeof useCustomerRequestInvoiceSecondCopyMutation>;
export type CustomerRequestInvoiceSecondCopyMutationResult = Apollo.MutationResult<CustomerRequestInvoiceSecondCopyMutation>;
export type CustomerRequestInvoiceSecondCopyMutationOptions = Apollo.BaseMutationOptions<CustomerRequestInvoiceSecondCopyMutation, CustomerRequestInvoiceSecondCopyMutationVariables>;
export const DashboardsGetEmbedInfoDocument = gql`
    query DashboardsGetEmbedInfo($internalId: String!) {
  dashboardsGetEmbedInfo(internalId: $internalId) {
    embedToken
    embedUrl
    reportId
  }
}
    `;

/**
 * __useDashboardsGetEmbedInfoQuery__
 *
 * To run a query within a React component, call `useDashboardsGetEmbedInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardsGetEmbedInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardsGetEmbedInfoQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *   },
 * });
 */
export function useDashboardsGetEmbedInfoQuery(baseOptions: Apollo.QueryHookOptions<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables> & ({ variables: DashboardsGetEmbedInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>(DashboardsGetEmbedInfoDocument, options);
      }
export function useDashboardsGetEmbedInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>(DashboardsGetEmbedInfoDocument, options);
        }
// @ts-ignore
export function useDashboardsGetEmbedInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>;
export function useDashboardsGetEmbedInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardsGetEmbedInfoQuery | undefined, DashboardsGetEmbedInfoQueryVariables>;
export function useDashboardsGetEmbedInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>(DashboardsGetEmbedInfoDocument, options);
        }
export type DashboardsGetEmbedInfoQueryHookResult = ReturnType<typeof useDashboardsGetEmbedInfoQuery>;
export type DashboardsGetEmbedInfoLazyQueryHookResult = ReturnType<typeof useDashboardsGetEmbedInfoLazyQuery>;
export type DashboardsGetEmbedInfoSuspenseQueryHookResult = ReturnType<typeof useDashboardsGetEmbedInfoSuspenseQuery>;
export type DashboardsGetEmbedInfoQueryResult = Apollo.QueryResult<DashboardsGetEmbedInfoQuery, DashboardsGetEmbedInfoQueryVariables>;
export const DashboardsListDocument = gql`
    query DashboardsList {
  dashboardsList {
    name
    internalId
  }
}
    `;

/**
 * __useDashboardsListQuery__
 *
 * To run a query within a React component, call `useDashboardsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardsListQuery(baseOptions?: Apollo.QueryHookOptions<DashboardsListQuery, DashboardsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardsListQuery, DashboardsListQueryVariables>(DashboardsListDocument, options);
      }
export function useDashboardsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardsListQuery, DashboardsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardsListQuery, DashboardsListQueryVariables>(DashboardsListDocument, options);
        }
// @ts-ignore
export function useDashboardsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardsListQuery, DashboardsListQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardsListQuery, DashboardsListQueryVariables>;
export function useDashboardsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardsListQuery, DashboardsListQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardsListQuery | undefined, DashboardsListQueryVariables>;
export function useDashboardsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardsListQuery, DashboardsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardsListQuery, DashboardsListQueryVariables>(DashboardsListDocument, options);
        }
export type DashboardsListQueryHookResult = ReturnType<typeof useDashboardsListQuery>;
export type DashboardsListLazyQueryHookResult = ReturnType<typeof useDashboardsListLazyQuery>;
export type DashboardsListSuspenseQueryHookResult = ReturnType<typeof useDashboardsListSuspenseQuery>;
export type DashboardsListQueryResult = Apollo.QueryResult<DashboardsListQuery, DashboardsListQueryVariables>;
export const DealershipGetDocument = gql`
    query DealershipGet($id: String!) {
  dealershipGet(id: $id) {
    _id
    needLoginDealership
    name
    distributorId
    locationUf
    maxDiscountPercentagePf
    maxDiscountPercentagePj
    available
    resolutionAneel {
      linkUrl
      modality
      resolutionHomologed
      validity
    }
    resolutionClasses {
      class
      cofinsPercentage
      fcp
      icmsPercentage
      pisPercentage
      teValueCents
      tusdValueCents
      wireBCalculationBaseValueCents
    }
    minimumExceptionValue {
      value
      allowException
    }
    partnerBenefitToCustomer {
      customerPFDiscountMax
      customerPFDiscountMin
      customerPJDiscountMax
      customerPJDiscountMin
      customerPFDiscountSuggested
      customerPJDiscountSuggested
    }
  }
}
    `;

/**
 * __useDealershipGetQuery__
 *
 * To run a query within a React component, call `useDealershipGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealershipGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealershipGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealershipGetQuery(baseOptions: Apollo.QueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables> & ({ variables: DealershipGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealershipGetQuery, DealershipGetQueryVariables>(DealershipGetDocument, options);
      }
export function useDealershipGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealershipGetQuery, DealershipGetQueryVariables>(DealershipGetDocument, options);
        }
// @ts-ignore
export function useDealershipGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables>): Apollo.UseSuspenseQueryResult<DealershipGetQuery, DealershipGetQueryVariables>;
export function useDealershipGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables>): Apollo.UseSuspenseQueryResult<DealershipGetQuery | undefined, DealershipGetQueryVariables>;
export function useDealershipGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DealershipGetQuery, DealershipGetQueryVariables>(DealershipGetDocument, options);
        }
export type DealershipGetQueryHookResult = ReturnType<typeof useDealershipGetQuery>;
export type DealershipGetLazyQueryHookResult = ReturnType<typeof useDealershipGetLazyQuery>;
export type DealershipGetSuspenseQueryHookResult = ReturnType<typeof useDealershipGetSuspenseQuery>;
export type DealershipGetQueryResult = Apollo.QueryResult<DealershipGetQuery, DealershipGetQueryVariables>;
export const DealershipListDocument = gql`
    query DealershipList($params: DealershipListDTO) {
  dealershipList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      name
      locationUf
      maxDiscountPercentagePf
      maxDiscountPercentagePj
      partnerBenefitToCustomer {
        customerPFDiscountMax
        customerPFDiscountMin
        customerPFDiscountSuggested
        customerPJDiscountMax
        customerPJDiscountMin
        customerPJDiscountSuggested
      }
      available
      minimumExceptionValue {
        value
        allowException
      }
    }
  }
}
    `;

/**
 * __useDealershipListQuery__
 *
 * To run a query within a React component, call `useDealershipListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealershipListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealershipListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDealershipListQuery(baseOptions?: Apollo.QueryHookOptions<DealershipListQuery, DealershipListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealershipListQuery, DealershipListQueryVariables>(DealershipListDocument, options);
      }
export function useDealershipListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealershipListQuery, DealershipListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealershipListQuery, DealershipListQueryVariables>(DealershipListDocument, options);
        }
// @ts-ignore
export function useDealershipListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DealershipListQuery, DealershipListQueryVariables>): Apollo.UseSuspenseQueryResult<DealershipListQuery, DealershipListQueryVariables>;
export function useDealershipListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealershipListQuery, DealershipListQueryVariables>): Apollo.UseSuspenseQueryResult<DealershipListQuery | undefined, DealershipListQueryVariables>;
export function useDealershipListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealershipListQuery, DealershipListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DealershipListQuery, DealershipListQueryVariables>(DealershipListDocument, options);
        }
export type DealershipListQueryHookResult = ReturnType<typeof useDealershipListQuery>;
export type DealershipListLazyQueryHookResult = ReturnType<typeof useDealershipListLazyQuery>;
export type DealershipListSuspenseQueryHookResult = ReturnType<typeof useDealershipListSuspenseQuery>;
export type DealershipListQueryResult = Apollo.QueryResult<DealershipListQuery, DealershipListQueryVariables>;
export const DiscountTableByIdDocument = gql`
    query DiscountTableById($id: String!) {
  discountTableById(id: $id) {
    _id
    code
    discountPercentage
    type
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useDiscountTableByIdQuery__
 *
 * To run a query within a React component, call `useDiscountTableByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountTableByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountTableByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscountTableByIdQuery(baseOptions: Apollo.QueryHookOptions<DiscountTableByIdQuery, DiscountTableByIdQueryVariables> & ({ variables: DiscountTableByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>(DiscountTableByIdDocument, options);
      }
export function useDiscountTableByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>(DiscountTableByIdDocument, options);
        }
// @ts-ignore
export function useDiscountTableByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>): Apollo.UseSuspenseQueryResult<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>;
export function useDiscountTableByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>): Apollo.UseSuspenseQueryResult<DiscountTableByIdQuery | undefined, DiscountTableByIdQueryVariables>;
export function useDiscountTableByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>(DiscountTableByIdDocument, options);
        }
export type DiscountTableByIdQueryHookResult = ReturnType<typeof useDiscountTableByIdQuery>;
export type DiscountTableByIdLazyQueryHookResult = ReturnType<typeof useDiscountTableByIdLazyQuery>;
export type DiscountTableByIdSuspenseQueryHookResult = ReturnType<typeof useDiscountTableByIdSuspenseQuery>;
export type DiscountTableByIdQueryResult = Apollo.QueryResult<DiscountTableByIdQuery, DiscountTableByIdQueryVariables>;
export const DiscountTableByListDocument = gql`
    query DiscountTableByList($params: DiscountTableListDTO!) {
  discountTableByList(params: $params) {
    data {
      _id
      code
      discountPercentage
      type
      createdAt
      updatedAt
    }
    meta {
      currentPage
      documentCounts
      pageSize
    }
  }
}
    `;

/**
 * __useDiscountTableByListQuery__
 *
 * To run a query within a React component, call `useDiscountTableByListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountTableByListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountTableByListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDiscountTableByListQuery(baseOptions: Apollo.QueryHookOptions<DiscountTableByListQuery, DiscountTableByListQueryVariables> & ({ variables: DiscountTableByListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountTableByListQuery, DiscountTableByListQueryVariables>(DiscountTableByListDocument, options);
      }
export function useDiscountTableByListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountTableByListQuery, DiscountTableByListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountTableByListQuery, DiscountTableByListQueryVariables>(DiscountTableByListDocument, options);
        }
// @ts-ignore
export function useDiscountTableByListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountTableByListQuery, DiscountTableByListQueryVariables>): Apollo.UseSuspenseQueryResult<DiscountTableByListQuery, DiscountTableByListQueryVariables>;
export function useDiscountTableByListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountTableByListQuery, DiscountTableByListQueryVariables>): Apollo.UseSuspenseQueryResult<DiscountTableByListQuery | undefined, DiscountTableByListQueryVariables>;
export function useDiscountTableByListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountTableByListQuery, DiscountTableByListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountTableByListQuery, DiscountTableByListQueryVariables>(DiscountTableByListDocument, options);
        }
export type DiscountTableByListQueryHookResult = ReturnType<typeof useDiscountTableByListQuery>;
export type DiscountTableByListLazyQueryHookResult = ReturnType<typeof useDiscountTableByListLazyQuery>;
export type DiscountTableByListSuspenseQueryHookResult = ReturnType<typeof useDiscountTableByListSuspenseQuery>;
export type DiscountTableByListQueryResult = Apollo.QueryResult<DiscountTableByListQuery, DiscountTableByListQueryVariables>;
export const GetAuthUserDocument = gql`
    query GetAuthUser {
  getAuthUser {
    user {
      customerId
      email
      id
      name
      partnerId
      partnerOwner
      phone
      type
    }
    accessControlRef {
      id
      name
    }
    roles
  }
}
    `;

/**
 * __useGetAuthUserQuery__
 *
 * To run a query within a React component, call `useGetAuthUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthUserQuery, GetAuthUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthUserQuery, GetAuthUserQueryVariables>(GetAuthUserDocument, options);
      }
export function useGetAuthUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthUserQuery, GetAuthUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthUserQuery, GetAuthUserQueryVariables>(GetAuthUserDocument, options);
        }
// @ts-ignore
export function useGetAuthUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuthUserQuery, GetAuthUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuthUserQuery, GetAuthUserQueryVariables>;
export function useGetAuthUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthUserQuery, GetAuthUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuthUserQuery | undefined, GetAuthUserQueryVariables>;
export function useGetAuthUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthUserQuery, GetAuthUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthUserQuery, GetAuthUserQueryVariables>(GetAuthUserDocument, options);
        }
export type GetAuthUserQueryHookResult = ReturnType<typeof useGetAuthUserQuery>;
export type GetAuthUserLazyQueryHookResult = ReturnType<typeof useGetAuthUserLazyQuery>;
export type GetAuthUserSuspenseQueryHookResult = ReturnType<typeof useGetAuthUserSuspenseQuery>;
export type GetAuthUserQueryResult = Apollo.QueryResult<GetAuthUserQuery, GetAuthUserQueryVariables>;
export const GetDigitalAccountWalletExtractByCustomerIdDocument = gql`
    query GetDigitalAccountWalletExtractByCustomerId($customerId: String!, $filters: FilterDigitalAccountWalletExtractGraphqlDto!) {
  getDigitalAccountWalletExtractByCustomerId(
    customerId: $customerId
    filters: $filters
  ) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      balanceCents
      status
      valueCents
      createdAt
      operationType
      description
      metadata {
        contractId
      }
      trackOperation {
        owner {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetDigitalAccountWalletExtractByCustomerIdQuery__
 *
 * To run a query within a React component, call `useGetDigitalAccountWalletExtractByCustomerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalAccountWalletExtractByCustomerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalAccountWalletExtractByCustomerIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDigitalAccountWalletExtractByCustomerIdQuery(baseOptions: Apollo.QueryHookOptions<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables> & ({ variables: GetDigitalAccountWalletExtractByCustomerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>(GetDigitalAccountWalletExtractByCustomerIdDocument, options);
      }
export function useGetDigitalAccountWalletExtractByCustomerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>(GetDigitalAccountWalletExtractByCustomerIdDocument, options);
        }
// @ts-ignore
export function useGetDigitalAccountWalletExtractByCustomerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>;
export function useGetDigitalAccountWalletExtractByCustomerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalAccountWalletExtractByCustomerIdQuery | undefined, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>;
export function useGetDigitalAccountWalletExtractByCustomerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>(GetDigitalAccountWalletExtractByCustomerIdDocument, options);
        }
export type GetDigitalAccountWalletExtractByCustomerIdQueryHookResult = ReturnType<typeof useGetDigitalAccountWalletExtractByCustomerIdQuery>;
export type GetDigitalAccountWalletExtractByCustomerIdLazyQueryHookResult = ReturnType<typeof useGetDigitalAccountWalletExtractByCustomerIdLazyQuery>;
export type GetDigitalAccountWalletExtractByCustomerIdSuspenseQueryHookResult = ReturnType<typeof useGetDigitalAccountWalletExtractByCustomerIdSuspenseQuery>;
export type GetDigitalAccountWalletExtractByCustomerIdQueryResult = Apollo.QueryResult<GetDigitalAccountWalletExtractByCustomerIdQuery, GetDigitalAccountWalletExtractByCustomerIdQueryVariables>;
export const GetDistributorsDocument = gql`
    query GetDistributors($params: DistributorListDTO!) {
  getDistributors(params: $params) {
    data {
      _id
      name
      active
    }
  }
}
    `;

/**
 * __useGetDistributorsQuery__
 *
 * To run a query within a React component, call `useGetDistributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributorsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetDistributorsQuery(baseOptions: Apollo.QueryHookOptions<GetDistributorsQuery, GetDistributorsQueryVariables> & ({ variables: GetDistributorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistributorsQuery, GetDistributorsQueryVariables>(GetDistributorsDocument, options);
      }
export function useGetDistributorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistributorsQuery, GetDistributorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistributorsQuery, GetDistributorsQueryVariables>(GetDistributorsDocument, options);
        }
// @ts-ignore
export function useGetDistributorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDistributorsQuery, GetDistributorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDistributorsQuery, GetDistributorsQueryVariables>;
export function useGetDistributorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistributorsQuery, GetDistributorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDistributorsQuery | undefined, GetDistributorsQueryVariables>;
export function useGetDistributorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistributorsQuery, GetDistributorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistributorsQuery, GetDistributorsQueryVariables>(GetDistributorsDocument, options);
        }
export type GetDistributorsQueryHookResult = ReturnType<typeof useGetDistributorsQuery>;
export type GetDistributorsLazyQueryHookResult = ReturnType<typeof useGetDistributorsLazyQuery>;
export type GetDistributorsSuspenseQueryHookResult = ReturnType<typeof useGetDistributorsSuspenseQuery>;
export type GetDistributorsQueryResult = Apollo.QueryResult<GetDistributorsQuery, GetDistributorsQueryVariables>;
export const GetModulesListDocument = gql`
    query GetModulesList {
  modules {
    publicName
    internalName
    actions {
      internalName
      publicName
    }
  }
}
    `;

/**
 * __useGetModulesListQuery__
 *
 * To run a query within a React component, call `useGetModulesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModulesListQuery(baseOptions?: Apollo.QueryHookOptions<GetModulesListQuery, GetModulesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesListQuery, GetModulesListQueryVariables>(GetModulesListDocument, options);
      }
export function useGetModulesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesListQuery, GetModulesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesListQuery, GetModulesListQueryVariables>(GetModulesListDocument, options);
        }
// @ts-ignore
export function useGetModulesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModulesListQuery, GetModulesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetModulesListQuery, GetModulesListQueryVariables>;
export function useGetModulesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModulesListQuery, GetModulesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetModulesListQuery | undefined, GetModulesListQueryVariables>;
export function useGetModulesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModulesListQuery, GetModulesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModulesListQuery, GetModulesListQueryVariables>(GetModulesListDocument, options);
        }
export type GetModulesListQueryHookResult = ReturnType<typeof useGetModulesListQuery>;
export type GetModulesListLazyQueryHookResult = ReturnType<typeof useGetModulesListLazyQuery>;
export type GetModulesListSuspenseQueryHookResult = ReturnType<typeof useGetModulesListSuspenseQuery>;
export type GetModulesListQueryResult = Apollo.QueryResult<GetModulesListQuery, GetModulesListQueryVariables>;
export const GetWalletBalanceByCustomerIdDocument = gql`
    query GetWalletBalanceByCustomerId($customerId: String!) {
  getWalletBalanceByCustomerId(customerId: $customerId) {
    balanceCents
  }
}
    `;

/**
 * __useGetWalletBalanceByCustomerIdQuery__
 *
 * To run a query within a React component, call `useGetWalletBalanceByCustomerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletBalanceByCustomerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletBalanceByCustomerIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetWalletBalanceByCustomerIdQuery(baseOptions: Apollo.QueryHookOptions<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables> & ({ variables: GetWalletBalanceByCustomerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>(GetWalletBalanceByCustomerIdDocument, options);
      }
export function useGetWalletBalanceByCustomerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>(GetWalletBalanceByCustomerIdDocument, options);
        }
// @ts-ignore
export function useGetWalletBalanceByCustomerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>;
export function useGetWalletBalanceByCustomerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetWalletBalanceByCustomerIdQuery | undefined, GetWalletBalanceByCustomerIdQueryVariables>;
export function useGetWalletBalanceByCustomerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>(GetWalletBalanceByCustomerIdDocument, options);
        }
export type GetWalletBalanceByCustomerIdQueryHookResult = ReturnType<typeof useGetWalletBalanceByCustomerIdQuery>;
export type GetWalletBalanceByCustomerIdLazyQueryHookResult = ReturnType<typeof useGetWalletBalanceByCustomerIdLazyQuery>;
export type GetWalletBalanceByCustomerIdSuspenseQueryHookResult = ReturnType<typeof useGetWalletBalanceByCustomerIdSuspenseQuery>;
export type GetWalletBalanceByCustomerIdQueryResult = Apollo.QueryResult<GetWalletBalanceByCustomerIdQuery, GetWalletBalanceByCustomerIdQueryVariables>;
export const InvoiceListDocument = gql`
    query InvoiceList($params: InvoiceListDTO) {
  invoiceList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      contract {
        id
      }
      status
      createdAt
      updatedAt
      dueDate
      amountCents
      cancelInfo {
        canceledBy
        createdAt
        description
        reason
      }
      energyBill {
        reference {
          month
          year
        }
      }
      payment {
        paidAt
        paidValue
      }
      customer {
        name
      }
      paymentType
    }
  }
}
    `;

/**
 * __useInvoiceListQuery__
 *
 * To run a query within a React component, call `useInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useInvoiceListQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceListQuery, InvoiceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceListQuery, InvoiceListQueryVariables>(InvoiceListDocument, options);
      }
export function useInvoiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceListQuery, InvoiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceListQuery, InvoiceListQueryVariables>(InvoiceListDocument, options);
        }
// @ts-ignore
export function useInvoiceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceListQuery, InvoiceListQueryVariables>): Apollo.UseSuspenseQueryResult<InvoiceListQuery, InvoiceListQueryVariables>;
export function useInvoiceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceListQuery, InvoiceListQueryVariables>): Apollo.UseSuspenseQueryResult<InvoiceListQuery | undefined, InvoiceListQueryVariables>;
export function useInvoiceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceListQuery, InvoiceListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceListQuery, InvoiceListQueryVariables>(InvoiceListDocument, options);
        }
export type InvoiceListQueryHookResult = ReturnType<typeof useInvoiceListQuery>;
export type InvoiceListLazyQueryHookResult = ReturnType<typeof useInvoiceListLazyQuery>;
export type InvoiceListSuspenseQueryHookResult = ReturnType<typeof useInvoiceListSuspenseQuery>;
export type InvoiceListQueryResult = Apollo.QueryResult<InvoiceListQuery, InvoiceListQueryVariables>;
export const ModulesListDocument = gql`
    query ModulesList {
  modulesList
}
    `;

/**
 * __useModulesListQuery__
 *
 * To run a query within a React component, call `useModulesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useModulesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModulesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useModulesListQuery(baseOptions?: Apollo.QueryHookOptions<ModulesListQuery, ModulesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModulesListQuery, ModulesListQueryVariables>(ModulesListDocument, options);
      }
export function useModulesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModulesListQuery, ModulesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModulesListQuery, ModulesListQueryVariables>(ModulesListDocument, options);
        }
// @ts-ignore
export function useModulesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModulesListQuery, ModulesListQueryVariables>): Apollo.UseSuspenseQueryResult<ModulesListQuery, ModulesListQueryVariables>;
export function useModulesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModulesListQuery, ModulesListQueryVariables>): Apollo.UseSuspenseQueryResult<ModulesListQuery | undefined, ModulesListQueryVariables>;
export function useModulesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModulesListQuery, ModulesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModulesListQuery, ModulesListQueryVariables>(ModulesListDocument, options);
        }
export type ModulesListQueryHookResult = ReturnType<typeof useModulesListQuery>;
export type ModulesListLazyQueryHookResult = ReturnType<typeof useModulesListLazyQuery>;
export type ModulesListSuspenseQueryHookResult = ReturnType<typeof useModulesListSuspenseQuery>;
export type ModulesListQueryResult = Apollo.QueryResult<ModulesListQuery, ModulesListQueryVariables>;
export const PartnerAffiliateUserGetDocument = gql`
    query PartnerAffiliateUserGet($id: String!) {
  partnerAffiliateUserGet(id: $id) {
    _id
    name
    cpf
    email
    phone
    status
    accessStatus
    captureSource
    linkedin
    instagram
    facebook
    site
    rejectionReason
    createdAt
    updatedAt
    address {
      street
      number
      complement
      neighborhood
      city
      state
      zipcode
      country
    }
    partnerRef {
      id
      name
      email
      phone
    }
    professionalHistory {
      companyName
      segment
      role
      observation
    }
    files {
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
    history {
      author
      date
      event
      userId
      userName
    }
    accessControlRef {
      id
      name
    }
  }
}
    `;

/**
 * __usePartnerAffiliateUserGetQuery__
 *
 * To run a query within a React component, call `usePartnerAffiliateUserGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAffiliateUserGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAffiliateUserGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerAffiliateUserGetQuery(baseOptions: Apollo.QueryHookOptions<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables> & ({ variables: PartnerAffiliateUserGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>(PartnerAffiliateUserGetDocument, options);
      }
export function usePartnerAffiliateUserGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>(PartnerAffiliateUserGetDocument, options);
        }
// @ts-ignore
export function usePartnerAffiliateUserGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>;
export function usePartnerAffiliateUserGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerAffiliateUserGetQuery | undefined, PartnerAffiliateUserGetQueryVariables>;
export function usePartnerAffiliateUserGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>(PartnerAffiliateUserGetDocument, options);
        }
export type PartnerAffiliateUserGetQueryHookResult = ReturnType<typeof usePartnerAffiliateUserGetQuery>;
export type PartnerAffiliateUserGetLazyQueryHookResult = ReturnType<typeof usePartnerAffiliateUserGetLazyQuery>;
export type PartnerAffiliateUserGetSuspenseQueryHookResult = ReturnType<typeof usePartnerAffiliateUserGetSuspenseQuery>;
export type PartnerAffiliateUserGetQueryResult = Apollo.QueryResult<PartnerAffiliateUserGetQuery, PartnerAffiliateUserGetQueryVariables>;
export const PartnerAffiliateUserListDocument = gql`
    query PartnerAffiliateUserList($params: PartnerAffiliateUserListDTO) {
  partnerAffiliateUserList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      name
      cpf
      email
      status
      accessStatus
      createdAt
      partnerRef {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePartnerAffiliateUserListQuery__
 *
 * To run a query within a React component, call `usePartnerAffiliateUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAffiliateUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAffiliateUserListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePartnerAffiliateUserListQuery(baseOptions?: Apollo.QueryHookOptions<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>(PartnerAffiliateUserListDocument, options);
      }
export function usePartnerAffiliateUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>(PartnerAffiliateUserListDocument, options);
        }
// @ts-ignore
export function usePartnerAffiliateUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>;
export function usePartnerAffiliateUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerAffiliateUserListQuery | undefined, PartnerAffiliateUserListQueryVariables>;
export function usePartnerAffiliateUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>(PartnerAffiliateUserListDocument, options);
        }
export type PartnerAffiliateUserListQueryHookResult = ReturnType<typeof usePartnerAffiliateUserListQuery>;
export type PartnerAffiliateUserListLazyQueryHookResult = ReturnType<typeof usePartnerAffiliateUserListLazyQuery>;
export type PartnerAffiliateUserListSuspenseQueryHookResult = ReturnType<typeof usePartnerAffiliateUserListSuspenseQuery>;
export type PartnerAffiliateUserListQueryResult = Apollo.QueryResult<PartnerAffiliateUserListQuery, PartnerAffiliateUserListQueryVariables>;
export const PartnerGetDocument = gql`
    query PartnerGet($id: String!) {
  partnerGet(id: $id) {
    _id
    manager {
      email
      id
      name
      partnerId
    }
    code
    document
    email
    name
    personType
    phone
    site
    status
    allowFormalizeProposal
    createdAt
    updatedAt
    partnershipConditions {
      recurring {
        alwaysCommissionedInvoices
        baseCommissionPercentage
        commissionedInvoices
      }
      anticipated {
        baseCommissionPercentage
        commissionExceptionGroups {
          baseCommissionPercentage
          commissionedInvoices
          dealerships
          id
        }
        commissionedInvoices
      }
    }
    contactPerson {
      email
      name
      phone
    }
    discountsException {
      customerPFDiscountMax
      customerPJDiscountMax
      customerPFDiscountMin
      customerPJDiscountMin
      customerPFDiscountSuggested
      customerPJDiscountSuggested
      dealershipId
      dealershipName
    }
    configuration {
      icone {
        fileName
        fileUrl
        key
        storageService
      }
      logo {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;

/**
 * __usePartnerGetQuery__
 *
 * To run a query within a React component, call `usePartnerGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerGetQuery(baseOptions: Apollo.QueryHookOptions<PartnerGetQuery, PartnerGetQueryVariables> & ({ variables: PartnerGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerGetQuery, PartnerGetQueryVariables>(PartnerGetDocument, options);
      }
export function usePartnerGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerGetQuery, PartnerGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerGetQuery, PartnerGetQueryVariables>(PartnerGetDocument, options);
        }
// @ts-ignore
export function usePartnerGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartnerGetQuery, PartnerGetQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerGetQuery, PartnerGetQueryVariables>;
export function usePartnerGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerGetQuery, PartnerGetQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerGetQuery | undefined, PartnerGetQueryVariables>;
export function usePartnerGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerGetQuery, PartnerGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerGetQuery, PartnerGetQueryVariables>(PartnerGetDocument, options);
        }
export type PartnerGetQueryHookResult = ReturnType<typeof usePartnerGetQuery>;
export type PartnerGetLazyQueryHookResult = ReturnType<typeof usePartnerGetLazyQuery>;
export type PartnerGetSuspenseQueryHookResult = ReturnType<typeof usePartnerGetSuspenseQuery>;
export type PartnerGetQueryResult = Apollo.QueryResult<PartnerGetQuery, PartnerGetQueryVariables>;
export const PartnerGetManagersDocument = gql`
    query PartnerGetManagers {
  partnerGetManagers {
    email
    id
    name
    partnerId
  }
}
    `;

/**
 * __usePartnerGetManagersQuery__
 *
 * To run a query within a React component, call `usePartnerGetManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetManagersQuery(baseOptions?: Apollo.QueryHookOptions<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>(PartnerGetManagersDocument, options);
      }
export function usePartnerGetManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>(PartnerGetManagersDocument, options);
        }
// @ts-ignore
export function usePartnerGetManagersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>;
export function usePartnerGetManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerGetManagersQuery | undefined, PartnerGetManagersQueryVariables>;
export function usePartnerGetManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>(PartnerGetManagersDocument, options);
        }
export type PartnerGetManagersQueryHookResult = ReturnType<typeof usePartnerGetManagersQuery>;
export type PartnerGetManagersLazyQueryHookResult = ReturnType<typeof usePartnerGetManagersLazyQuery>;
export type PartnerGetManagersSuspenseQueryHookResult = ReturnType<typeof usePartnerGetManagersSuspenseQuery>;
export type PartnerGetManagersQueryResult = Apollo.QueryResult<PartnerGetManagersQuery, PartnerGetManagersQueryVariables>;
export const PartnerListDocument = gql`
    query PartnerList($params: PartnerListDTO) {
  partnerList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      name
      phone
      document
      createdAt
      updatedAt
      status
    }
  }
}
    `;

/**
 * __usePartnerListQuery__
 *
 * To run a query within a React component, call `usePartnerListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePartnerListQuery(baseOptions?: Apollo.QueryHookOptions<PartnerListQuery, PartnerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerListQuery, PartnerListQueryVariables>(PartnerListDocument, options);
      }
export function usePartnerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerListQuery, PartnerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerListQuery, PartnerListQueryVariables>(PartnerListDocument, options);
        }
// @ts-ignore
export function usePartnerListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartnerListQuery, PartnerListQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerListQuery, PartnerListQueryVariables>;
export function usePartnerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerListQuery, PartnerListQueryVariables>): Apollo.UseSuspenseQueryResult<PartnerListQuery | undefined, PartnerListQueryVariables>;
export function usePartnerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerListQuery, PartnerListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerListQuery, PartnerListQueryVariables>(PartnerListDocument, options);
        }
export type PartnerListQueryHookResult = ReturnType<typeof usePartnerListQuery>;
export type PartnerListLazyQueryHookResult = ReturnType<typeof usePartnerListLazyQuery>;
export type PartnerListSuspenseQueryHookResult = ReturnType<typeof usePartnerListSuspenseQuery>;
export type PartnerListQueryResult = Apollo.QueryResult<PartnerListQuery, PartnerListQueryVariables>;
export const PowerGeneratorGetDocument = gql`
    query PowerGeneratorGet($id: String!) {
  powerGeneratorGet(id: $id) {
    _id
    active
    isDesperta
    name
    createdAt
    updatedAt
    deletedAt
    representatives {
      email
      name
      phone
    }
  }
}
    `;

/**
 * __usePowerGeneratorGetQuery__
 *
 * To run a query within a React component, call `usePowerGeneratorGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerGeneratorGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerGeneratorGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePowerGeneratorGetQuery(baseOptions: Apollo.QueryHookOptions<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables> & ({ variables: PowerGeneratorGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>(PowerGeneratorGetDocument, options);
      }
export function usePowerGeneratorGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>(PowerGeneratorGetDocument, options);
        }
// @ts-ignore
export function usePowerGeneratorGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>): Apollo.UseSuspenseQueryResult<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>;
export function usePowerGeneratorGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>): Apollo.UseSuspenseQueryResult<PowerGeneratorGetQuery | undefined, PowerGeneratorGetQueryVariables>;
export function usePowerGeneratorGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>(PowerGeneratorGetDocument, options);
        }
export type PowerGeneratorGetQueryHookResult = ReturnType<typeof usePowerGeneratorGetQuery>;
export type PowerGeneratorGetLazyQueryHookResult = ReturnType<typeof usePowerGeneratorGetLazyQuery>;
export type PowerGeneratorGetSuspenseQueryHookResult = ReturnType<typeof usePowerGeneratorGetSuspenseQuery>;
export type PowerGeneratorGetQueryResult = Apollo.QueryResult<PowerGeneratorGetQuery, PowerGeneratorGetQueryVariables>;
export const PowerGeneratorListDocument = gql`
    query PowerGeneratorList($params: PowerGeneratorListDTO) {
  powerGeneratorList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      active
      isDesperta
      name
      createdAt
      updatedAt
      deletedAt
      representatives {
        email
        name
        phone
      }
    }
  }
}
    `;

/**
 * __usePowerGeneratorListQuery__
 *
 * To run a query within a React component, call `usePowerGeneratorListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerGeneratorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerGeneratorListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePowerGeneratorListQuery(baseOptions?: Apollo.QueryHookOptions<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>(PowerGeneratorListDocument, options);
      }
export function usePowerGeneratorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>(PowerGeneratorListDocument, options);
        }
// @ts-ignore
export function usePowerGeneratorListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>): Apollo.UseSuspenseQueryResult<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>;
export function usePowerGeneratorListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>): Apollo.UseSuspenseQueryResult<PowerGeneratorListQuery | undefined, PowerGeneratorListQueryVariables>;
export function usePowerGeneratorListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>(PowerGeneratorListDocument, options);
        }
export type PowerGeneratorListQueryHookResult = ReturnType<typeof usePowerGeneratorListQuery>;
export type PowerGeneratorListLazyQueryHookResult = ReturnType<typeof usePowerGeneratorListLazyQuery>;
export type PowerGeneratorListSuspenseQueryHookResult = ReturnType<typeof usePowerGeneratorListSuspenseQuery>;
export type PowerGeneratorListQueryResult = Apollo.QueryResult<PowerGeneratorListQuery, PowerGeneratorListQueryVariables>;
export const PowerPlantGetDocument = gql`
    query PowerPlantGet($id: String!) {
  powerPlantGet(id: $id) {
    _id
    name
    acceptsPF
    acceptsPJ
    dealershipId
    installation
    isDesperta
    observation
    productionKwh
    productionMwac
    createdAt
    updatedAt
    generatorId
    clientNumber
    accessKeyExtra
    accessKeyLogin
    accessKeyPassword
    modality
    discountConfiguration {
      discount {
        pf
        pj
      }
      useDealershipDiscountPercentage
    }
    address {
      city
      complement
      country
      neighborhood
      number
      state
      street
      zipcode
    }
    document
    email
    corporateName
    operationStartDate
    cashbackInfo {
      active
    }
  }
}
    `;

/**
 * __usePowerPlantGetQuery__
 *
 * To run a query within a React component, call `usePowerPlantGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerPlantGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerPlantGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePowerPlantGetQuery(baseOptions: Apollo.QueryHookOptions<PowerPlantGetQuery, PowerPlantGetQueryVariables> & ({ variables: PowerPlantGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PowerPlantGetQuery, PowerPlantGetQueryVariables>(PowerPlantGetDocument, options);
      }
export function usePowerPlantGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PowerPlantGetQuery, PowerPlantGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PowerPlantGetQuery, PowerPlantGetQueryVariables>(PowerPlantGetDocument, options);
        }
// @ts-ignore
export function usePowerPlantGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PowerPlantGetQuery, PowerPlantGetQueryVariables>): Apollo.UseSuspenseQueryResult<PowerPlantGetQuery, PowerPlantGetQueryVariables>;
export function usePowerPlantGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowerPlantGetQuery, PowerPlantGetQueryVariables>): Apollo.UseSuspenseQueryResult<PowerPlantGetQuery | undefined, PowerPlantGetQueryVariables>;
export function usePowerPlantGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowerPlantGetQuery, PowerPlantGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PowerPlantGetQuery, PowerPlantGetQueryVariables>(PowerPlantGetDocument, options);
        }
export type PowerPlantGetQueryHookResult = ReturnType<typeof usePowerPlantGetQuery>;
export type PowerPlantGetLazyQueryHookResult = ReturnType<typeof usePowerPlantGetLazyQuery>;
export type PowerPlantGetSuspenseQueryHookResult = ReturnType<typeof usePowerPlantGetSuspenseQuery>;
export type PowerPlantGetQueryResult = Apollo.QueryResult<PowerPlantGetQuery, PowerPlantGetQueryVariables>;
export const PowerPlantListDocument = gql`
    query PowerPlantList($params: PowerPlantListDTO) {
  powerPlantList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      name
      acceptsPF
      acceptsPJ
      dealershipId
      installation
      isDesperta
      observation
      productionKwh
      productionMwac
      createdAt
      updatedAt
      generatorId
      cashbackInfo {
        active
      }
    }
  }
}
    `;

/**
 * __usePowerPlantListQuery__
 *
 * To run a query within a React component, call `usePowerPlantListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerPlantListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerPlantListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePowerPlantListQuery(baseOptions?: Apollo.QueryHookOptions<PowerPlantListQuery, PowerPlantListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PowerPlantListQuery, PowerPlantListQueryVariables>(PowerPlantListDocument, options);
      }
export function usePowerPlantListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PowerPlantListQuery, PowerPlantListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PowerPlantListQuery, PowerPlantListQueryVariables>(PowerPlantListDocument, options);
        }
// @ts-ignore
export function usePowerPlantListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PowerPlantListQuery, PowerPlantListQueryVariables>): Apollo.UseSuspenseQueryResult<PowerPlantListQuery, PowerPlantListQueryVariables>;
export function usePowerPlantListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowerPlantListQuery, PowerPlantListQueryVariables>): Apollo.UseSuspenseQueryResult<PowerPlantListQuery | undefined, PowerPlantListQueryVariables>;
export function usePowerPlantListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowerPlantListQuery, PowerPlantListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PowerPlantListQuery, PowerPlantListQueryVariables>(PowerPlantListDocument, options);
        }
export type PowerPlantListQueryHookResult = ReturnType<typeof usePowerPlantListQuery>;
export type PowerPlantListLazyQueryHookResult = ReturnType<typeof usePowerPlantListLazyQuery>;
export type PowerPlantListSuspenseQueryHookResult = ReturnType<typeof usePowerPlantListSuspenseQuery>;
export type PowerPlantListQueryResult = Apollo.QueryResult<PowerPlantListQuery, PowerPlantListQueryVariables>;
export const ProposalGetDocument = gql`
    query ProposalGet($id: String!) {
  proposalGet(id: $id) {
    _id
    sellerRef {
      changeAt
      changeBy
      email
      history {
        changeAt
        changeBy
        email
        id
        name
        user {
          email
          id
          name
        }
      }
      id
      name
      user {
        email
        id
        name
      }
    }
    supportRef {
      changeAt
      changeBy
      email
      history {
        changeAt
        changeBy
        email
        id
        name
        user {
          email
          id
          name
        }
      }
      id
      name
      user {
        email
        id
        name
      }
    }
    consortiumId
    contractId
    lossReason
    fidelityMonths
    dealershipLogin {
      extraPassword
      login
      password
    }
    rejectedInfo {
      reason
      rejectedAt
      rejectedBy {
        id
        name
      }
    }
    salesFunnel {
      stage
      changedBy
      date
      history {
        changedBy
        date
        stage
        user
      }
      user
    }
    indicationRef {
      partner {
        name
      }
    }
    cashbackInfo {
      active
      cashbackPercentagePf
      cashbackPercentagePj
    }
    hasAnalysis
    notes {
      analystId
      createdAt
      text
      analystName
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
    preProposals {
      file {
        fileName
        fileUrl
        key
      }
      dealershipName
      dealershipId
    }
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      refusedReason
      approveManual
      manualOrAutomatic
      status
      key
      url
      signers {
        email
        id
        name
        requestSignId
      }
    }
    businessProposals {
      acceptedAt
      businessProposalDespertaNumber
      businessProposalPartnerNumber
      contractOfAdhesion {
        fileName
        fileUrl
        key
      }
      createdAt
      file {
        fileName
        fileUrl
        key
      }
      invoiceValueWithPartner
      monthlyEconomyPercent
      observation
      powerPlantId
      powerGeneratorId
      rejectedAt
      rejectedBy
      updatedAt
      tariffGreenFlag
      tariffRedFlagP1
      tariffRedFlagP2
      tariffPurpleFlag
      tariffYellowFlag
      status
    }
    files {
      status
      file {
        fileName
        fileUrl
        key
      }
      type
      sendAt
      analysedBy
    }
    customerRef {
      hasPendencies
      pendencies {
        averageEnergyBillValue {
          rejectedAt
          solvedAt
          acceptedAt
        }
        city {
          rejectedAt
          solvedAt
          acceptedAt
        }
        dealershipName {
          rejectedAt
          solvedAt
          acceptedAt
        }
        document {
          rejectedAt
          solvedAt
          acceptedAt
        }
        email {
          rejectedAt
          solvedAt
          acceptedAt
        }
        name {
          rejectedAt
          solvedAt
          acceptedAt
        }
        neighborhood {
          rejectedAt
          solvedAt
          acceptedAt
        }
        number {
          rejectedAt
          solvedAt
          acceptedAt
        }
        phone {
          rejectedAt
          solvedAt
          acceptedAt
        }
        state {
          rejectedAt
          solvedAt
          acceptedAt
        }
        street {
          rejectedAt
          solvedAt
          acceptedAt
        }
        uf {
          rejectedAt
          solvedAt
          acceptedAt
        }
        zipcode {
          rejectedAt
          solvedAt
          acceptedAt
        }
      }
      averageEnergyBillValue
      uf
      dealershipId
      dealershipName
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      maritalStatus
      legalRepresentative {
        pendencies {
          city {
            rejectedAt
            solvedAt
            acceptedAt
          }
          complement {
            rejectedAt
            solvedAt
            acceptedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        files {
          acceptedAt
          analysedBy
          file {
            fileName
            fileUrl
            key
          }
          rejectedAt
          sendAt
          status
          type
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    hash
    origin
    status
    createBy {
      id
      name
      email
      phone
      type
    }
    updatedAt
    createdAt
    energyBillInfo {
      AmountCents
      consumerClassification
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        file {
          fileName
          fileUrl
          key
        }
        status
        type
      }
      energyTaxes
      installationNumber
      oldInstallationNumber
      hasNewStandardInstallationNumber
      installationNumberMigratedAt
      invoiceDueDay
      tariffClassification
      tension
      tusdValue
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
    monthlyConsumption {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
    customerIndicationRef {
      customerId
      customerName
    }
  }
}
    `;

/**
 * __useProposalGetQuery__
 *
 * To run a query within a React component, call `useProposalGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProposalGetQuery(baseOptions: Apollo.QueryHookOptions<ProposalGetQuery, ProposalGetQueryVariables> & ({ variables: ProposalGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalGetQuery, ProposalGetQueryVariables>(ProposalGetDocument, options);
      }
export function useProposalGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalGetQuery, ProposalGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalGetQuery, ProposalGetQueryVariables>(ProposalGetDocument, options);
        }
// @ts-ignore
export function useProposalGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProposalGetQuery, ProposalGetQueryVariables>): Apollo.UseSuspenseQueryResult<ProposalGetQuery, ProposalGetQueryVariables>;
export function useProposalGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalGetQuery, ProposalGetQueryVariables>): Apollo.UseSuspenseQueryResult<ProposalGetQuery | undefined, ProposalGetQueryVariables>;
export function useProposalGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalGetQuery, ProposalGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalGetQuery, ProposalGetQueryVariables>(ProposalGetDocument, options);
        }
export type ProposalGetQueryHookResult = ReturnType<typeof useProposalGetQuery>;
export type ProposalGetLazyQueryHookResult = ReturnType<typeof useProposalGetLazyQuery>;
export type ProposalGetSuspenseQueryHookResult = ReturnType<typeof useProposalGetSuspenseQuery>;
export type ProposalGetQueryResult = Apollo.QueryResult<ProposalGetQuery, ProposalGetQueryVariables>;
export const ProposalWithDealershipsDocument = gql`
    query ProposalWithDealerships($id: String!, $params: DealershipListDTO) {
  dealershipList(params: $params) {
    data {
      _id
      locationUf
      name
    }
  }
  proposalGet(id: $id) {
    _id
    notes {
      analystId
      createdAt
      text
      analystName
    }
    fidelityMonths
    hash
    origin
    updatedAt
    createdAt
    status
    files {
      status
      type
      acceptedAt
      analysedBy
      sendAt
      rejectedAt
      file {
        fileUrl
        fileName
      }
    }
    rejectedInfo {
      reason
      rejectedAt
      rejectedBy {
        id
        name
      }
    }
    salesFunnel {
      stage
      changedBy
      date
      history {
        changedBy
        date
        stage
        user
      }
      user
    }
    indicationRef {
      partner {
        name
      }
    }
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      clientNumber
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        analysedBy
      }
      energyTaxes
      installationNumber
      tariffClassification
      tension
      tusdValue
      consumerClassification
    }
    createBy {
      id
      name
      email
      phone
      type
    }
    customerRef {
      name
      document
      personType
      maritalStatus
      email
      phone
      nationality
      uf
      averageEnergyBillValue
      nationality
      dealershipId
      dealershipName
      pendencies {
        city {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        document {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        email {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        name {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        neighborhood {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        number {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        phone {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        state {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        street {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        zipcode {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        uf {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        averageEnergyBillValue {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
        dealershipName {
          acceptedAt
          analysedBy
          rejectedAt
          solvedAt
        }
      }
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      legalRepresentative {
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        identificationNumber
        maritalStatus
        name
        nationality
        document
        email
        phone
        pendencies {
          city {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          complement {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          document {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          email {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          name {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          neighborhood {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          number {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          phone {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          state {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          zipcode {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
          state {
            acceptedAt
            analysedBy
            rejectedAt
            solvedAt
          }
        }
        files {
          acceptedAt
          analysedBy
          status
          file {
            fileName
            fileUrl
            key
            storageService
          }
          rejectedAt
          sendAt
          type
        }
      }
    }
  }
}
    `;

/**
 * __useProposalWithDealershipsQuery__
 *
 * To run a query within a React component, call `useProposalWithDealershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalWithDealershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalWithDealershipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalWithDealershipsQuery(baseOptions: Apollo.QueryHookOptions<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables> & ({ variables: ProposalWithDealershipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>(ProposalWithDealershipsDocument, options);
      }
export function useProposalWithDealershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>(ProposalWithDealershipsDocument, options);
        }
// @ts-ignore
export function useProposalWithDealershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>): Apollo.UseSuspenseQueryResult<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>;
export function useProposalWithDealershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>): Apollo.UseSuspenseQueryResult<ProposalWithDealershipsQuery | undefined, ProposalWithDealershipsQueryVariables>;
export function useProposalWithDealershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>(ProposalWithDealershipsDocument, options);
        }
export type ProposalWithDealershipsQueryHookResult = ReturnType<typeof useProposalWithDealershipsQuery>;
export type ProposalWithDealershipsLazyQueryHookResult = ReturnType<typeof useProposalWithDealershipsLazyQuery>;
export type ProposalWithDealershipsSuspenseQueryHookResult = ReturnType<typeof useProposalWithDealershipsSuspenseQuery>;
export type ProposalWithDealershipsQueryResult = Apollo.QueryResult<ProposalWithDealershipsQuery, ProposalWithDealershipsQueryVariables>;
export const ProposalListDocument = gql`
    query ProposalList($params: ProposalListDTO!) {
  proposalList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      sellerRef {
        changeAt
        changeBy
        email
        history {
          changeAt
          changeBy
          email
          id
          name
          user {
            email
            id
            name
          }
        }
        id
        name
        user {
          email
          id
          name
        }
      }
      supportRef {
        changeAt
        changeBy
        email
        history {
          changeAt
          changeBy
          email
          id
          name
          user {
            email
            id
            name
          }
        }
        id
        name
        user {
          email
          id
          name
        }
      }
      consortiumId
      status
      hasAnalysis
      origin
      indicationRef {
        partner {
          name
        }
      }
      termOfAdhesion {
        signedAt
      }
      customerRef {
        name
        document
        personType
        hasPendencies
      }
      createdAt
      updatedAt
      createBy {
        id
      }
      customerIndicationRef {
        customerId
        customerName
      }
    }
  }
}
    `;

/**
 * __useProposalListQuery__
 *
 * To run a query within a React component, call `useProposalListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProposalListQuery(baseOptions: Apollo.QueryHookOptions<ProposalListQuery, ProposalListQueryVariables> & ({ variables: ProposalListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalListQuery, ProposalListQueryVariables>(ProposalListDocument, options);
      }
export function useProposalListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalListQuery, ProposalListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalListQuery, ProposalListQueryVariables>(ProposalListDocument, options);
        }
// @ts-ignore
export function useProposalListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProposalListQuery, ProposalListQueryVariables>): Apollo.UseSuspenseQueryResult<ProposalListQuery, ProposalListQueryVariables>;
export function useProposalListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalListQuery, ProposalListQueryVariables>): Apollo.UseSuspenseQueryResult<ProposalListQuery | undefined, ProposalListQueryVariables>;
export function useProposalListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalListQuery, ProposalListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalListQuery, ProposalListQueryVariables>(ProposalListDocument, options);
        }
export type ProposalListQueryHookResult = ReturnType<typeof useProposalListQuery>;
export type ProposalListLazyQueryHookResult = ReturnType<typeof useProposalListLazyQuery>;
export type ProposalListSuspenseQueryHookResult = ReturnType<typeof useProposalListSuspenseQuery>;
export type ProposalListQueryResult = Apollo.QueryResult<ProposalListQuery, ProposalListQueryVariables>;
export const ProviderInvoiceSimulateDueDateChangeDocument = gql`
    query ProviderInvoiceSimulateDueDateChange($params: ContractInvoiceSimulateDueDateChangeDto!) {
  providerInvoiceSimulateDueDateChange(params: $params) {
    invoiceId
    amountCents
    daysDifference
    fineAmountCents
    interestAmountCents
    invoiceValueCents
    isInterestAndFineWaived
    lateDays
    requestedDueDate
    validDueDate
  }
}
    `;

/**
 * __useProviderInvoiceSimulateDueDateChangeQuery__
 *
 * To run a query within a React component, call `useProviderInvoiceSimulateDueDateChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderInvoiceSimulateDueDateChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderInvoiceSimulateDueDateChangeQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProviderInvoiceSimulateDueDateChangeQuery(baseOptions: Apollo.QueryHookOptions<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables> & ({ variables: ProviderInvoiceSimulateDueDateChangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>(ProviderInvoiceSimulateDueDateChangeDocument, options);
      }
export function useProviderInvoiceSimulateDueDateChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>(ProviderInvoiceSimulateDueDateChangeDocument, options);
        }
// @ts-ignore
export function useProviderInvoiceSimulateDueDateChangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>): Apollo.UseSuspenseQueryResult<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>;
export function useProviderInvoiceSimulateDueDateChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>): Apollo.UseSuspenseQueryResult<ProviderInvoiceSimulateDueDateChangeQuery | undefined, ProviderInvoiceSimulateDueDateChangeQueryVariables>;
export function useProviderInvoiceSimulateDueDateChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>(ProviderInvoiceSimulateDueDateChangeDocument, options);
        }
export type ProviderInvoiceSimulateDueDateChangeQueryHookResult = ReturnType<typeof useProviderInvoiceSimulateDueDateChangeQuery>;
export type ProviderInvoiceSimulateDueDateChangeLazyQueryHookResult = ReturnType<typeof useProviderInvoiceSimulateDueDateChangeLazyQuery>;
export type ProviderInvoiceSimulateDueDateChangeSuspenseQueryHookResult = ReturnType<typeof useProviderInvoiceSimulateDueDateChangeSuspenseQuery>;
export type ProviderInvoiceSimulateDueDateChangeQueryResult = Apollo.QueryResult<ProviderInvoiceSimulateDueDateChangeQuery, ProviderInvoiceSimulateDueDateChangeQueryVariables>;
export const RenderPowerPlantDocument = gql`
    query renderPowerPlant($powerGeneratorParams: PowerGeneratorListDTO!, $dealershipParams: DealershipListDTO!) {
  powerGeneratorList(params: $powerGeneratorParams) {
    data {
      _id
      name
    }
  }
  dealershipList(params: $dealershipParams) {
    data {
      _id
      name
      maxDiscountPercentagePf
      maxDiscountPercentagePj
    }
  }
}
    `;

/**
 * __useRenderPowerPlantQuery__
 *
 * To run a query within a React component, call `useRenderPowerPlantQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderPowerPlantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderPowerPlantQuery({
 *   variables: {
 *      powerGeneratorParams: // value for 'powerGeneratorParams'
 *      dealershipParams: // value for 'dealershipParams'
 *   },
 * });
 */
export function useRenderPowerPlantQuery(baseOptions: Apollo.QueryHookOptions<RenderPowerPlantQuery, RenderPowerPlantQueryVariables> & ({ variables: RenderPowerPlantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>(RenderPowerPlantDocument, options);
      }
export function useRenderPowerPlantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>(RenderPowerPlantDocument, options);
        }
// @ts-ignore
export function useRenderPowerPlantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>): Apollo.UseSuspenseQueryResult<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>;
export function useRenderPowerPlantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>): Apollo.UseSuspenseQueryResult<RenderPowerPlantQuery | undefined, RenderPowerPlantQueryVariables>;
export function useRenderPowerPlantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>(RenderPowerPlantDocument, options);
        }
export type RenderPowerPlantQueryHookResult = ReturnType<typeof useRenderPowerPlantQuery>;
export type RenderPowerPlantLazyQueryHookResult = ReturnType<typeof useRenderPowerPlantLazyQuery>;
export type RenderPowerPlantSuspenseQueryHookResult = ReturnType<typeof useRenderPowerPlantSuspenseQuery>;
export type RenderPowerPlantQueryResult = Apollo.QueryResult<RenderPowerPlantQuery, RenderPowerPlantQueryVariables>;
export const UserGetDocument = gql`
    query UserGet($id: String!) {
  userGet(id: $id) {
    _id
    name
    status
    email
    type
    phone
    createdAt
    username
    accessControlRef {
      id
      name
    }
  }
}
    `;

/**
 * __useUserGetQuery__
 *
 * To run a query within a React component, call `useUserGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGetQuery(baseOptions: Apollo.QueryHookOptions<UserGetQuery, UserGetQueryVariables> & ({ variables: UserGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGetQuery, UserGetQueryVariables>(UserGetDocument, options);
      }
export function useUserGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGetQuery, UserGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGetQuery, UserGetQueryVariables>(UserGetDocument, options);
        }
// @ts-ignore
export function useUserGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGetQuery, UserGetQueryVariables>): Apollo.UseSuspenseQueryResult<UserGetQuery, UserGetQueryVariables>;
export function useUserGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGetQuery, UserGetQueryVariables>): Apollo.UseSuspenseQueryResult<UserGetQuery | undefined, UserGetQueryVariables>;
export function useUserGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGetQuery, UserGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGetQuery, UserGetQueryVariables>(UserGetDocument, options);
        }
export type UserGetQueryHookResult = ReturnType<typeof useUserGetQuery>;
export type UserGetLazyQueryHookResult = ReturnType<typeof useUserGetLazyQuery>;
export type UserGetSuspenseQueryHookResult = ReturnType<typeof useUserGetSuspenseQuery>;
export type UserGetQueryResult = Apollo.QueryResult<UserGetQuery, UserGetQueryVariables>;
export const UserListDocument = gql`
    query UserList($params: UserPaginateArgs) {
  userList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      name
      status
      email
      type
      phone
      createdAt
      accessControlRef {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUserListQuery(baseOptions?: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
// @ts-ignore
export function useUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserListQuery, UserListQueryVariables>): Apollo.UseSuspenseQueryResult<UserListQuery, UserListQueryVariables>;
export function useUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserListQuery, UserListQueryVariables>): Apollo.UseSuspenseQueryResult<UserListQuery | undefined, UserListQueryVariables>;
export function useUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListSuspenseQueryHookResult = ReturnType<typeof useUserListSuspenseQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;